webpackJsonp([0],{

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_SELECTOR; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Default back button selector
var DEFAULT_SELECTOR = '[data-target="back"]';

var BackButton = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to add back button properties on.
   * */
  function BackButton(elementRef) {
    _classCallCheck(this, BackButton);

    // Initialise attributes
    this.elementRef = elementRef;

    this._setup();
  }

  // Event Handlers

  /**
   * Event handler for the back button.
   *
   * @param {Event} event - click event on the back button.
   * */


  _createClass(BackButton, [{
    key: 'clickHandler',
    value: function clickHandler(event) {
      event.preventDefault();
      event.stopPropagation();

      window.history.back();
    }

    // private

    /**
     * Set-up the back button.
     *  1) Appropriately binds all necessary event callbacks.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      this._addEventListeners();
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.elementRef.addEventListener('click', this.clickHandler);
    }
  }]);

  return BackButton;
}();

/* harmony default export */ __webpack_exports__["b"] = (BackButton);

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(55);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// Default class names for dropdown states
var CLASS_NAME = {
  DROPDOWN: 'dropdown',
  DROPDOWN_MENU: 'dropdown__menu',
  DROPDOWN_OPEN: 'dropdown--open'
};

// Default configs for popper
var CONFIG = {
  placement: 'bottom-end'
};

// Default dropdown selector
var DEFAULT_SELECTOR = '[data-toggle="dropdown"]';

var DEFAULT_OPTIONS = {
  className: CLASS_NAME,
  config: CONFIG,
  selector: DEFAULT_SELECTOR
};

var Dropdown = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to add dropdown properties on.
   * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
   * */
  function Dropdown(elementRef) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

    _classCallCheck(this, Dropdown);

    // Initialise attributes

    // Root dropdown container
    this.elementRef = elementRef;
    // Object to hold all the className of the modal
    this.className = options.className || CLASS_NAME;
    this.config = options.config || CONFIG;

    this._dropdown = this.elementRef.closest('.' + this.className['DROPDOWN']);
    this._dropdownMenu = this._dropdown.querySelector('.' + this.className['DROPDOWN_MENU']);

    this._popper = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](this.elementRef, this._dropdownMenu, this.config);

    // Bind functions
    this.hide = this.hide.bind(this);
    this.toggle = this.toggle.bind(this);

    this._setup();
  }

  // Event Handlers

  /**
   * Event handler to toggle the dropdown.
   *
   * @param {Event} event - click event on the toggle button `this.elementRef`.
   * */


  _createClass(Dropdown, [{
    key: 'toggle',
    value: function toggle(event) {
      event.preventDefault();
      event.stopPropagation();

      this._dropdown.classList.toggle('' + this.className['DROPDOWN_OPEN']);
      this._popper.update();
    }

    /**
     * Event handler to hide the dropdown.
     *
     * @param {Event} event - click event
     * */

  }, {
    key: 'hide',
    value: function hide(event) {
      this._dropdown.classList.remove('' + this.className['DROPDOWN_OPEN']);
    }

    // private

    /**
     * Set-up the dropdown.
     *  1) Appropriately binds all necessary event callbacks.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      this._addEventListeners();
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.elementRef.addEventListener('click', this.toggle);
      document.body.addEventListener('click', this.hide);
    }
  }]);

  return Dropdown;
}();

/* harmony default export */ __webpack_exports__["b"] = (Dropdown);

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/popper.js/dist/esm/popper.js
var popper = __webpack_require__(55);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(119);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./app/assets/javascripts/lib/geolocationManager.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_OPTIONS = {
  components: 'country:th',
  types: ['geocode'],
  strictbounds: false
};

/**
 * Convert a complex Google Place suggestion into a simple PlaceSuggestion object
 *
 * @param {Object} [suggestion] - a Google Place suggestion
 * @return {Object} - a formatted place suggestion object
 */
var PlaceSuggestion = function PlaceSuggestion(suggestion) {
  /* eslint-disable camelcase */
  var place_id = suggestion.place_id,
      description = suggestion.description,
      structured_formatting = suggestion.structured_formatting;

  return {
    id: place_id,
    description: description,
    main_text: structured_formatting.main_text,
    secondary_text: structured_formatting.secondary_text
  };
  /* eslint-enable camelcase */
};

var GeolocationManager = function () {
  function GeolocationManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, GeolocationManager);

    this.options = _extends({}, DEFAULT_OPTIONS, options);
  }

  /**
   * Get the place predictions based on a text string.
   * Uses Google Place Predictions:
   * https://developers.google.com/maps/documentation/javascript/reference#AutocompletionRequest
   *
   * @param {String} [inputText] - string for which the suggestions are to be found
   * @return {Promise} - a promise which will resolve to the place details
   */


  _createClass(GeolocationManager, [{
    key: 'getPlaceSuggestions',
    value: function getPlaceSuggestions(inputText) {
      var _this = this;

      var placesService = new google.maps.places.AutocompleteService();

      return new Promise(function (resolve, reject) {
        placesService.getPlacePredictions(_extends({ input: inputText }, _this.options), function (suggestions, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            suggestions = suggestions.filter(function (suggestion) {
              return suggestion.terms.length === 2;
            });
            if (suggestions.length > 0) {
              var formattedSuggestions = suggestions.map(function (suggestion) {
                return PlaceSuggestion(suggestion);
              });

              resolve(formattedSuggestions);
            } else {
              reject(
              // eslint-disable-next-line camelcase
              new Error(I18n.t('geolocation_manager.error.no_suggestion_found', { search_text: inputText })));
            }
          } else {
            reject(
            // eslint-disable-next-line camelcase
            new Error(I18n.t('geolocation_manager.error.no_suggestion_found', { search_text: inputText })));
          }
        });
      });
    }

    /**
     * Fetches the details of a place identified by `placeId`
     * Uses Google Place Details:
     * https://developers.google.com/maps/documentation/javascript/places#place_details
     *
     * @param {String} [placeId] - google place_id of the place
     */

  }, {
    key: 'getPlaceDetails',
    value: function getPlaceDetails(placeId) {
      var request = {
        placeId: placeId
      };

      return new Promise(function (resolve, reject) {
        var service = new google.maps.places.PlacesService(document.createElement('div'));
        service.getDetails(request, function (place, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            resolve(place);
          } else {
            reject(new Error(I18n.t('geolocation_manager.error.place_detail_failure')));
          }
        });
      });
    }
  }]);

  return GeolocationManager;
}();

/* harmony default export */ var geolocationManager = (GeolocationManager);
// EXTERNAL MODULE: ./app/assets/javascripts/components/locationSearch/events.js
var events = __webpack_require__(49);

// CONCATENATED MODULE: ./app/assets/javascripts/components/locationSearch/error.js
var error_Error = function Error(message) {
  return "<li class=\"location-search__error\">" + message + "</li>";
};

/* harmony default export */ var locationSearch_error = (error_Error);
// CONCATENATED MODULE: ./app/assets/javascripts/components/locationSearch/suggestionItem.js
var SuggestionItem = function SuggestionItem(suggestion) {
  /* eslint-disable camelcase */
  var id = suggestion.id,
      description = suggestion.description,
      main_text = suggestion.main_text,
      secondary_text = suggestion.secondary_text;

  return "<li data-id=\"" + id + "\" data-description=\"" + description + "\"><span>" + main_text + "</span>" + secondary_text + "</li>";
  /* eslint-enable camelcase */
};

/* harmony default export */ var suggestionItem = (SuggestionItem);
// CONCATENATED MODULE: ./app/assets/javascripts/components/spinner/index.js
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Spinner = function Spinner(_ref) {
  var size = _ref.size;

  var baseClass = 'spinner';
  var classNames = [baseClass];
  var sizeClassName = void 0;

  switch (size) {
    case 'small':
      sizeClassName = baseClass + '--xs';
      break;
    case 'medium':
      sizeClassName = baseClass + '--md';
      break;
    default:
      sizeClassName = undefined;
  }

  sizeClassName && classNames.push(sizeClassName);

  var spinnerWrapper = document.createElement('div');
  spinnerWrapper.setAttribute('class', classNames.join(' '));

  [].concat(_toConsumableArray(Array(12))).forEach(function (_, index) {
    var spinnerCircle = document.createElement('div');
    spinnerCircle.setAttribute('class', 'spinner__circle spinner__circle--' + (index + 1));

    spinnerWrapper.appendChild(spinnerCircle);
  });

  return spinnerWrapper;
};

/* harmony default export */ var components_spinner = (Spinner);
// EXTERNAL MODULE: ./app/assets/javascripts/components/svgIcon/index.js
var svgIcon = __webpack_require__(65);

// CONCATENATED MODULE: ./app/assets/javascripts/components/locationSearch/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationSearch_DEFAULT_OPTIONS; });
var locationSearch__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function locationSearch__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












// Default class names for the DOM elements of the locationInput
var CLASS_NAME = {
  BASE_WRAPPER: 'location-search',
  INPUT_CONTAINER: 'location-search__input-container',
  INPUT: 'location-search__input',
  PLACE_ID_INPUT: 'location-place-id-input',
  ICON_CONTAINER: 'location-search__icon-container',
  ICON: 'location-search__icon',
  RESET_BUTTON: 'location-search__btn-reset',
  SUGGESTION_LIST: 'location-search__suggestion-list',
  // States
  FETCHING_SUGGESTION: 'location-search--fetching',
  FILLED_SEARCH_INPUT: 'location-search--filled',
  OPEN_SUGGESTION_LIST: 'location-search--open',
  DISABLED: 'location-search--disabled'
};

// Default configs for popper
var CONFIG = {
  placement: 'bottom-end'
};

var locationSearch_DEFAULT_OPTIONS = {
  className: CLASS_NAME,
  config: CONFIG,
  selector: '.location-search-input',
  enableGeolocation: false,
  suggestionTypes: ['geocode'],
  disabled: false
};

var locationSearch_LocationSearch = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to add locationSearch properties on.
   * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
   * */
  function LocationSearch(elementRef) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locationSearch_DEFAULT_OPTIONS;

    locationSearch__classCallCheck(this, LocationSearch);

    var _elementRef$dataset = elementRef.dataset,
        disabled = _elementRef$dataset.disabled,
        geolocation = _elementRef$dataset.geolocation,
        geolocationInput = _elementRef$dataset.geolocationInput,
        placeIdInput = _elementRef$dataset.placeIdInput;

    // Root element container

    this.elementRef = elementRef;
    this.searchText = this.elementRef.value;

    // Configuration
    this.options = options;
    this.className = CLASS_NAME;
    this.config = options.config || CONFIG;
    this.disabled = disabled || locationSearch_DEFAULT_OPTIONS['disabled'];
    this.enableGeolocation = geolocation !== undefined && geolocationInput !== undefined || locationSearch_DEFAULT_OPTIONS['enableGeolocation'];
    this.geolocationInputRef = document.querySelector(geolocationInput) || undefined;
    this.placeIdInputRef = document.querySelector(placeIdInput) || undefined;

    // Set Suggestion types
    this.suggestionTypes = locationSearch_DEFAULT_OPTIONS['suggestionTypes'];
    if (this.elementRef.getAttribute('data-suggestion-types')) {
      this.suggestionTypes = this.elementRef.getAttribute('data-suggestion-types').split(',');
    }

    this.geolocationManager = new geolocationManager({ types: this.suggestionTypes });

    // Bind functions
    this.onSearchInputHandler = Object(lodash["debounce"])(this.onSearchInputHandler.bind(this), 500);
    this.onBlurInputHandler = this.onBlurInputHandler.bind(this);
    this.onClickSuggestionHandler = this.onClickSuggestionHandler.bind(this);
    this.onClickResetHandler = this.onClickResetHandler.bind(this);
    this.onClickInputContainerHandler = this.onClickInputContainerHandler.bind(this);

    this.onFetchingSuggestionsHandler = this.onFetchingSuggestionsHandler.bind(this);
    this.onFetchSuggestionsSuccessHandler = this.onFetchSuggestionsSuccessHandler.bind(this);
    this.onFetchSuggestionsFailureHandler = this.onFetchSuggestionsFailureHandler.bind(this);

    this.onSelectingLocationHandler = this.onSelectingLocationHandler.bind(this);
    this.onSelectLocationSuccessHandler = this.onSelectLocationSuccessHandler.bind(this);
    this.onSelectLocationFailureHandler = this.onSelectLocationFailureHandler.bind(this);

    this.onResetLocationHandler = this.onResetLocationHandler.bind(this);

    this._setup();
  }

  // Event Handlers

  /**
   * Event handler when text is entered in the search input.
   * Triggers a request to fetch place suggestions.
   *
   * @param {Event} _event - input event on the search input.
   * */


  locationSearch__createClass(LocationSearch, [{
    key: 'onSearchInputHandler',
    value: function onSearchInputHandler(_event) {
      var _this = this;

      var inputText = this.searchInput.value;

      if (this.searchText && !inputText) {
        var resetLocationEvent = new CustomEvent(events["c" /* LOCATION_SEARCH_RESET_LOCATION */]);
        this.searchInput.dispatchEvent(resetLocationEvent);
      }

      if (!inputText || this.searchText === inputText) {
        return;
      }

      var fetchingSuggestionsEvent = new CustomEvent(events["a" /* LOCATION_SEARCH_IS_FETCHING_SUGGESTIONS */]);
      this.searchInput.dispatchEvent(fetchingSuggestionsEvent);

      this.geolocationManager.getPlaceSuggestions(inputText).then(function (suggestions) {
        var fetchSuccessEvent = new CustomEvent(events["h" /* LOCATION_SEARCH_SUGGESTIONS_FETCH_SUCCESS */], {
          detail: { suggestions: suggestions }
        });
        _this.searchInput.dispatchEvent(fetchSuccessEvent);
      }).catch(function (error) {
        var fetchFailureEvent = new CustomEvent(events["g" /* LOCATION_SEARCH_SUGGESTIONS_FETCH_FAILURE */], {
          detail: { error: error.message }
        });
        _this.searchInput.dispatchEvent(fetchFailureEvent);
      });
    }

    /**
     * Event handler when the search input has lost focus.
     *
     * @param {Event} _event - input event on the search input.
     * */

  }, {
    key: 'onBlurInputHandler',
    value: function onBlurInputHandler(_event) {
      var inputText = this.searchInput.value;
      var previousLocation = this.searchText;

      if (previousLocation && !inputText) {
        this._setLocationInputValue(previousLocation);
      }
    }

    /**
     * Event handler to select a suggestion.
     * If geolocation is enabled, triggers a request to fetch the geo-data.
     *
     * @param {Event} event - click event on the suggestion list item.
     * */

  }, {
    key: 'onClickSuggestionHandler',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var selectingSuggestionsEvent, _event$currentTarget$, id, description, eventPayload, placeDetails, location, selectLocationSuccessEvent, selectLocationFailureEvent;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                selectingSuggestionsEvent = new CustomEvent(events["b" /* LOCATION_SEARCH_IS_SELECTING_LOCATION */]);

                this.searchInput.dispatchEvent(selectingSuggestionsEvent);

                _context.prev = 2;
                _event$currentTarget$ = event.currentTarget.dataset, id = _event$currentTarget$.id, description = _event$currentTarget$.description;
                eventPayload = { description: description };


                this._setPlaceIdValue(id);

                if (!this.enableGeolocation) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return this.geolocationManager.getPlaceDetails(id);

              case 9:
                placeDetails = _context.sent;
                location = placeDetails.geometry.location;


                eventPayload['geolocation'] = {
                  latitude: location.lat(),
                  longitude: location.lng()
                };

              case 12:
                selectLocationSuccessEvent = new CustomEvent(events["f" /* LOCATION_SEARCH_SELECT_LOCATION_SUCCESS */], {
                  detail: eventPayload
                });

                this.searchInput.dispatchEvent(selectLocationSuccessEvent);
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](2);
                selectLocationFailureEvent = new CustomEvent(events["e" /* LOCATION_SEARCH_SELECT_LOCATION_FAILURE */], {
                  detail: { error: _context.t0.message }
                });

                this.searchInput.dispatchEvent(selectLocationFailureEvent);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 16]]);
      }));

      function onClickSuggestionHandler(_x2) {
        return _ref.apply(this, arguments);
      }

      return onClickSuggestionHandler;
    }()

    /**
     * Event handler when the search input is cleared.
     *
     * @param {Event} _event - click event on the reset button.
     * */

  }, {
    key: 'onClickResetHandler',
    value: function onClickResetHandler(_event) {
      this.searchInput.value = '';

      var resetLocationEvent = new CustomEvent(events["c" /* LOCATION_SEARCH_RESET_LOCATION */]);
      this.searchInput.dispatchEvent(resetLocationEvent);
    }

    /**
     * Event handler when the search container is clicked.
     *
     * @param {Event} _event - click event on the search container element.
     * */

  }, {
    key: 'onClickInputContainerHandler',
    value: function onClickInputContainerHandler(_event) {
      this.searchInput.focus();
    }

    /**
     * Event handler when suggestion are being fetched.
     *
     * @param {Event} _event - custom event.
     * */

  }, {
    key: 'onFetchingSuggestionsHandler',
    value: function onFetchingSuggestionsHandler(_event) {
      this._showSpinner();
      this._hideSuggestionDropdown();
      this._resetSuggestionList();
    }

    /**
     * Event handler when suggestion have been fetched sucessfully.
     *
     * @param {Event} event - custom event.
     * */

  }, {
    key: 'onFetchSuggestionsSuccessHandler',
    value: function onFetchSuggestionsSuccessHandler(event) {
      var suggestions = event.detail.suggestions;


      this._hideSpinner();
      this._showResetButton();
      this._renderSuggestionList(suggestions);
      this._showSuggestionDropdown();
    }

    /**
     * Event handler when suggestion have NOT been fetched sucessfully.
     *
     * @param {Event} event - custom event.
     * */

  }, {
    key: 'onFetchSuggestionsFailureHandler',
    value: function onFetchSuggestionsFailureHandler(event) {
      var error = event.detail.error;


      this._hideSpinner();
      this._showResetButton();
      this._renderError(error);
      this._showSuggestionDropdown();
    }

    /**
     * Event handler when a suggestion is being selected.
     *
     * @param {Event} _event - custom event.
     * */

  }, {
    key: 'onSelectingLocationHandler',
    value: function onSelectingLocationHandler(_event) {
      this._showSpinner();
    }

    /**
     * Event handler when a suggestion has been selected successfully.
     *
     * @param {Event} event - custom event.
     * */

  }, {
    key: 'onSelectLocationSuccessHandler',
    value: function onSelectLocationSuccessHandler(event) {
      var _event$detail = event.detail,
          description = _event$detail.description,
          geolocation = _event$detail.geolocation;


      this.searchText = description;
      this._setLocationInputValue(description);
      geolocation && this._setGeolocationInputValue(geolocation.latitude, geolocation.longitude);

      this._hideSpinner();
      this._enableSearch();
      this._showResetButton();
      this._hideSuggestionDropdown();

      // Dispatch event is bubbling outside of the component scope
      // so that screens can bind to it to implement custom callback when a location is selected
      var selectLocationCompleteEvent = new CustomEvent(events["d" /* LOCATION_SEARCH_SELECT_LOCATION_COMPLETE */], {
        bubbles: true
      });
      this.searchInput.dispatchEvent(selectLocationCompleteEvent);
    }

    /**
     * Event handler when a suggestion has NOT been selected successfully.
     *
     * @param {Event} event - custom event.
     * */

  }, {
    key: 'onSelectLocationFailureHandler',
    value: function onSelectLocationFailureHandler(event) {
      var error = event.detail.error;


      this._hideSpinner();
      this._enableSearch();
      this._showResetButton();
      this._renderError(error);
      this._showSuggestionDropdown();
    }

    /**
     * Event handler when the serach input is reset.
     *
     * @param {Event} _event - custom event.
     * */

  }, {
    key: 'onResetLocationHandler',
    value: function onResetLocationHandler(_event) {
      this._hideResetButton();
      this._hideSuggestionDropdown();
      this._resetSuggestionList();
      this._setLocationInputValue();
      this.enableGeolocation && this._setGeolocationInputValue();
    }

    // Private

    /**
     * Set-up the location search form.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      // Hide original search input
      this.elementRef.style.display = 'none';

      // Create DOM elements
      this.baseWrapper = this._createBaseWrapper();
      this.searchContainer = this._createSearchContainer();
      this.suggestionList = this._createSuggestionList();

      this.baseWrapper.appendChild(this.searchContainer);
      this.baseWrapper.appendChild(this.suggestionList);

      // Generate dropdown
      this.popper = new popper["a" /* default */](this.searchContainer, this.suggestionList, this.config);

      if (this.disabled) {
        this._disableSearch();
      }

      this._addEventListeners();
    }

    /**
     * Creates the root container of the location selection container.
     *
     * @return {Element} - HTML node, root container of the location search.
     * */

  }, {
    key: '_createBaseWrapper',
    value: function _createBaseWrapper() {
      var baseWrapper = document.createElement('div');
      baseWrapper.setAttribute('class', this.className['BASE_WRAPPER']);
      if (this.elementRef.dataset.classNames) {
        baseWrapper.classList.add(this.elementRef.dataset.classNames);
      }
      this.elementRef.parentElement.appendChild(baseWrapper);

      return baseWrapper;
    }

    /**
     * Creates the search container used to search locations.
     *
     * @return {Element} - HTML node, search container.
     * */

  }, {
    key: '_createSearchContainer',
    value: function _createSearchContainer() {
      this.searchContainer = document.createElement('div');
      this.searchContainer.setAttribute('class', this.className['INPUT_CONTAINER']);

      var searchIcon = Object(svgIcon["a" /* default */])({ name: 'icon-location', width: 18, height: 18 });
      var searchIconContainer = document.createElement('div');
      searchIconContainer.setAttribute('class', this.className['ICON_CONTAINER']);
      searchIconContainer.appendChild(searchIcon);

      var spinner = components_spinner({ size: 'small' });
      var activityIconContainer = document.createElement('div');
      activityIconContainer.setAttribute('class', this.className['ICON_CONTAINER']);
      activityIconContainer.appendChild(spinner);

      var closeIcon = Object(svgIcon["a" /* default */])({ name: 'icon-close', width: 14, height: 14 });
      this.resetButton = document.createElement('button');
      this.resetButton.setAttribute('type', 'button');
      this.resetButton.setAttribute('class', this.className['RESET_BUTTON']);
      this.resetButton.appendChild(closeIcon);
      activityIconContainer.appendChild(this.resetButton);

      this.searchInput = document.createElement('input');
      this.searchInput.setAttribute('type', 'search');
      this.searchInput.setAttribute('class', this.className['INPUT']);
      this.searchInput.setAttribute('placeholder', this.elementRef.placeholder);
      this.searchInput.setAttribute('value', this.elementRef.value);

      this.searchContainer.appendChild(searchIconContainer);
      this.searchContainer.appendChild(this.searchInput);
      this.searchContainer.appendChild(activityIconContainer);

      return this.searchContainer;
    }

    /**
     * Creates the suggestion list container.
     *
     * @return {Element} - HTML node, suggestionList list.
     * */

  }, {
    key: '_createSuggestionList',
    value: function _createSuggestionList() {
      var suggestionList = document.createElement('ul');
      suggestionList.setAttribute('class', this.className['SUGGESTION_LIST']);

      return suggestionList;
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.searchInput.addEventListener('input', this.onSearchInputHandler);
      this.searchInput.addEventListener('blur', this.onBlurInputHandler);
      this.resetButton.addEventListener('click', this.onClickResetHandler);
      this.searchContainer.addEventListener('click', this.onClickInputContainerHandler);

      this.searchInput.addEventListener(events["a" /* LOCATION_SEARCH_IS_FETCHING_SUGGESTIONS */], this.onFetchingSuggestionsHandler);
      this.searchInput.addEventListener(events["h" /* LOCATION_SEARCH_SUGGESTIONS_FETCH_SUCCESS */], this.onFetchSuggestionsSuccessHandler);
      this.searchInput.addEventListener(events["g" /* LOCATION_SEARCH_SUGGESTIONS_FETCH_FAILURE */], this.onFetchSuggestionsFailureHandler);

      this.searchInput.addEventListener(events["b" /* LOCATION_SEARCH_IS_SELECTING_LOCATION */], this.onSelectingLocationHandler);
      this.searchInput.addEventListener(events["f" /* LOCATION_SEARCH_SELECT_LOCATION_SUCCESS */], this.onSelectLocationSuccessHandler);
      this.searchInput.addEventListener(events["e" /* LOCATION_SEARCH_SELECT_LOCATION_FAILURE */], this.onSelectLocationFailureHandler);

      this.searchInput.addEventListener(events["c" /* LOCATION_SEARCH_RESET_LOCATION */], this.onResetLocationHandler);
    }
  }, {
    key: '_enableSearch',
    value: function _enableSearch() {
      this.baseWrapper.classList.remove(this.className['DISABLED']);
      this.searchInput.disabled = false;
    }
  }, {
    key: '_disableSearch',
    value: function _disableSearch() {
      this.baseWrapper.classList.add(this.className['DISABLED']);
      this.searchInput.disabled = true;
    }
  }, {
    key: '_showSpinner',
    value: function _showSpinner() {
      this.baseWrapper.classList.add(this.className['FETCHING_SUGGESTION']);
    }
  }, {
    key: '_hideSpinner',
    value: function _hideSpinner() {
      this.baseWrapper.classList.remove(this.className['FETCHING_SUGGESTION']);
    }
  }, {
    key: '_showResetButton',
    value: function _showResetButton() {
      this.baseWrapper.classList.add(this.className['FILLED_SEARCH_INPUT']);
    }
  }, {
    key: '_hideResetButton',
    value: function _hideResetButton() {
      this.baseWrapper.classList.remove(this.className['FILLED_SEARCH_INPUT']);
    }
  }, {
    key: '_showSuggestionDropdown',
    value: function _showSuggestionDropdown() {
      this.baseWrapper.classList.add(this.className['OPEN_SUGGESTION_LIST']);
    }
  }, {
    key: '_hideSuggestionDropdown',
    value: function _hideSuggestionDropdown() {
      this.baseWrapper.classList.remove(this.className['OPEN_SUGGESTION_LIST']);
    }

    /**
     * Fill in the location inputs (initial + created by locationSearch) values.
     *
     * @return {String} - input value
     * */

  }, {
    key: '_setLocationInputValue',
    value: function _setLocationInputValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.elementRef.value = value;
      this.searchInput.value = value;
    }

    /**
     * Fill in the geolocation with a formatted geolocation string e.g. (10.23, 45,23).
     *
     * @return {String} - latitude
     * @return {String} - longitude
     * */

  }, {
    key: '_setGeolocationInputValue',
    value: function _setGeolocationInputValue() {
      var lat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var lng = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (!this.geolocationInputRef) {
        return;
      }
      this.geolocationInputRef.value = lat && lng ? '(' + lat + ', ' + lng + ')' : '';
    }
  }, {
    key: '_setPlaceIdValue',
    value: function _setPlaceIdValue(placeId) {
      if (!this.placeIdInputRef) {
        return;
      }

      this.placeIdInputRef.value = placeId;
    }

    /**
     * Creates the suggestion list container.
     *
     * @return {Array} - list of suggestion items.
     * */

  }, {
    key: '_renderSuggestionList',
    value: function _renderSuggestionList(suggestions) {
      var _this2 = this;

      this.suggestionList.innerHTML = suggestions.map(function (suggestion) {
        return suggestionItem(suggestion);
      }).join(' ');

      // Bind event listners to the list items
      this.suggestionList.querySelectorAll('li').forEach(function (listItem) {
        listItem.addEventListener('click', _this2.onClickSuggestionHandler);
      });
    }

    /**
     * Removes all content in the suggestion dropdown.
     *
     * @return {String} - error message.
     * */

  }, {
    key: '_resetSuggestionList',
    value: function _resetSuggestionList() {
      this.suggestionList.innerHTML = '';
    }

    /**
     * Renders an error messafge in the suggestion dropdown.
     *
     * @return {String} - error message.
     * */

  }, {
    key: '_renderError',
    value: function _renderError(message) {
      this.suggestionList.innerHTML = locationSearch_error(message);
    }
  }]);

  return LocationSearch;
}();

/* harmony default export */ var locationSearch = __webpack_exports__["b"] = (locationSearch_LocationSearch);

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Lib_fileUploadManager__ = __webpack_require__(67);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// Default selectors for UserProfileForm
var SELECTORS = {
  FORM: '.form-user-profile',
  AVATAR_FORM_GROUP: '.form-user-profile__avatar',
  AVATAR: '.avatar',
  AVATAR_PLACEHOLDER: '.avatar__placeholder',
  AVATAR_INPUT: '#user_avatar',
  SUBMIT_BUTTON: '[type="submit"]'
};

var CLASS_NAME = {
  UPLOADING: 'form-user-profile__avatar--uploading'
};

var DEFAULT_OPTIONS = {
  className: CLASS_NAME,
  selectors: SELECTORS
};

var UserProfileForm = function () {
  /**
   * Initializer
   *
   * @param {Element} form - user profile form
   * */
  function UserProfileForm(form) {
    _classCallCheck(this, UserProfileForm);

    // Initialise attributes

    // Form Node
    this.form = form;
    this.avatarFormGroup = this.form.querySelector(SELECTORS['AVATAR_FORM_GROUP']);
    this.avatarPreviewElement = this.form.querySelector(SELECTORS['AVATAR']);
    this.avatarPlaceholder = this.form.querySelector(SELECTORS['AVATAR_PLACEHOLDER']);
    this.avatarInputField = this.form.querySelector(SELECTORS['AVATAR_INPUT']);
    this.formSubmitButton = this.form.querySelector(SELECTORS['SUBMIT_BUTTON']);
    this.isUploading = false;

    // Bind functions
    this.openFileUploader = this.openFileUploader.bind(this);
    this.fileUploadStartHandler = this.fileUploadStartHandler.bind(this);
    this.fileUploadSuccessHandler = this.fileUploadSuccessHandler.bind(this);

    this._setup();
  }

  // Event Handlers

  /**
   * Event handler to open the file uploader.
   *
   * @param {Event} event - click event to open the file uploader.
   * */


  _createClass(UserProfileForm, [{
    key: 'openFileUploader',
    value: function openFileUploader(event) {
      event.preventDefault();

      if (this.isUploading) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0_Lib_fileUploadManager__["a" /* default */].pick({
        imagesOnly: true,
        onFileUploadStart: this.fileUploadStartHandler,
        onFileUploadSuccess: this.fileUploadSuccessHandler
      });
    }

    /**
     * Callback to be triggered when the upload starts.
     *
     * 1) Sets `isUploading` to `true`
     * 2) Adds `form__group--avatar-uploading` to the avatar form group. This shows the loading animation.
     * 3) Disables the form submit button.
     * */

  }, {
    key: 'fileUploadStartHandler',
    value: function fileUploadStartHandler() {
      this.isUploading = true;
      this.avatarFormGroup.classList.add(CLASS_NAME['UPLOADING']);
      this.formSubmitButton.disabled = true;
    }

    /**
     * Callback to be triggered when the upload finishes.
     *
     * 1) Sets `isUploading` to `false`.
     * 2) Removes the loading animation, if any.
     * 3) Adds the newly uploaded image in avatar preview.
     * 4) Enables the form submit button.
     *
     * @param {Object} file - file object that was uploaded.
     *    https://uploadcare.com/docs/api_reference/javascript/files_uploads/#file-info
     * */

  }, {
    key: 'fileUploadSuccessHandler',
    value: function fileUploadSuccessHandler(file) {
      this.isUploading = false;

      var fallbackIcon = this.avatarPreviewElement.querySelector('svg');
      fallbackIcon && this.avatarPreviewElement.removeChild(fallbackIcon);

      this.avatarPreviewElement.style.backgroundImage = 'url(' + file.cdnUrl + ')';
      this.avatarPreviewElement.style.backgroundSize = '100% 100%';
      this.avatarInputField.value = file.cdnUrl;
      if (this.avatarPlaceholder !== null && this.avatarPlaceholder !== undefined) {
        this.avatarPlaceholder.style.display = 'none';
      }

      this.avatarFormGroup.classList.remove(CLASS_NAME['UPLOADING']);
      this.formSubmitButton.disabled = false;
    }

    // Private Methods

  }, {
    key: '_setup',
    value: function _setup() {
      this._addEventListeners();
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.avatarFormGroup.addEventListener('click', this.openFileUploader);
    }
  }]);

  return UserProfileForm;
}();

/* harmony default export */ __webpack_exports__["b"] = (UserProfileForm);

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Utils_window__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_CoreComponents_selectInput___ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var SELECTOR = {
  localeSelect: '#locale_select'
};

var LocaleForm = function () {
  function LocaleForm() {
    _classCallCheck(this, LocaleForm);

    // Initialise attributes
    this.localeSelect = document.querySelector(SELECTOR['localeSelect']);

    // Bind functions
    this.changeHandler = this.changeHandler.bind(this);

    this._setup();
    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler triggered when the form elements are changed.
   * */


  _createClass(LocaleForm, [{
    key: 'changeHandler',
    value: function changeHandler() {
      this._submitForm();
    }

    // Private Methods

  }, {
    key: '_setup',
    value: function _setup() {
      new __WEBPACK_IMPORTED_MODULE_1_CoreComponents_selectInput___["b" /* default */](this.localeSelect);
    }

    /**
     * Binds event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.localeSelect.addEventListener('change', this.changeHandler);
    }

    /**
     * Serialize form values and redirects to the selected locale translation page.
     * */

  }, {
    key: '_submitForm',
    value: function _submitForm() {
      var currentURL = window.location.href;
      var url = new URL(currentURL);

      if (url.pathname.match(/^\/(en|th|ms)/)) {
        url = url.pathname.replace(/^\/(en|th|ms)/, '/' + this.localeSelect.value);
      } else if (url.pathname) {
        url = '/' + this.localeSelect.value + url.pathname;
      } else {
        url = '/' + this.localeSelect.value;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0_Utils_window__["a" /* redirectTo */])(url.toString());
    }
  }]);

  return LocaleForm;
}();

/* harmony default export */ __webpack_exports__["a"] = (LocaleForm);

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SideNav = function () {
  _createClass(SideNav, null, [{
    key: 'blockClicks',

    /**
     * Event handler to block the clicks.
     *
     * @param {Event} event - click event.
     * */
    value: function blockClicks(event) {
      event.stopPropagation();
    }
  }]);

  function SideNav() {
    _classCallCheck(this, SideNav);

    // Initialise attributes
    this.sideNavElement = document.querySelector('.side-nav');
    this.sideNavContainerElement = document.querySelector('.side-nav__container');
    this.toggleButtonElement = document.querySelector('.navbar__toggle');
    this.toggleButtonIconElement = document.querySelector('.navbar__toggle svg use');
    this.sideNavCollapseElements = document.querySelectorAll('.side-nav__container a, .side-nav__container button');

    this.startX = 0;
    this.currentX = 0;
    this.touchingSideNav = false;

    this.transitionEndProperty = null;
    this.transitionEndTime = 0;

    this.supportsPassive = undefined;

    // Bind functions
    this.showSideNav = this.showSideNav.bind(this);
    this.hideSideNav = this.hideSideNav.bind(this);
    this.toggleSideNav = this.toggleSideNav.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.update = this.update.bind(this);
    this.onTransitionEnd = this.onTransitionEnd.bind(this);

    this._setup();
  }

  // Event Handlers

  /**
   * Event handler to show the sideNav.
   *
   * @param {Event} event - click event.
   * */


  _createClass(SideNav, [{
    key: 'showSideNav',
    value: function showSideNav(event) {
      event.preventDefault();

      this.sideNavElement.classList.add('side-nav--animatable');
      this.sideNavElement.classList.add('side-nav--visible');
      this.toggleButtonIconElement.setAttribute('xlink:href', '#icon-close');

      this.transitionEndProperty = 'transform';
      // the duration of transition (make unique to distinguish transitions )
      this.transitionEndTime = 0.33;

      this.sideNavElement.addEventListener('transitionend', this.onTransitionEnd);
    }

    /**
     * Event handler to hide the sideNav.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'hideSideNav',
    value: function hideSideNav(event) {
      this.sideNavElement.classList.add('side-nav--animatable');
      this.sideNavElement.classList.remove('side-nav--visible');
      this.toggleButtonIconElement.setAttribute('xlink:href', '#icon-menu');

      this.transitionEndProperty = 'transform';
      this.transitionEndTime = 0.13;

      this.sideNavElement.addEventListener('transitionend', this.onTransitionEnd);
    }

    /**
     * Event handler to toggle the sideNav.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'toggleSideNav',
    value: function toggleSideNav(event) {
      event.preventDefault();

      var classAdded = this.sideNavElement.classList.toggle('side-nav--visible');

      if (classAdded) {
        this.toggleButtonIconElement.setAttribute('xlink:href', '#icon-close');
      } else {
        this.toggleButtonIconElement.setAttribute('xlink:href', '#icon-menu');
      }
    }

    /**
     * Event handler for touchstart event.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'onTouchStart',
    value: function onTouchStart(event) {
      if (!this.sideNavElement.classList.contains('side-nav--visible')) {
        return;
      }

      this.startX = event.touches[0].pageX;
      this.currentX = this.startX;
      this.touchingSideNav = true;

      requestAnimationFrame(this.update);
    }

    /**
     * Event handler for touchmove event.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'onTouchMove',
    value: function onTouchMove(event) {
      if (!this.touchingSideNav) {
        return;
      }

      this.currentX = event.touches[0].pageX;
    }

    /**
     * Event handler for touchend event.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'onTouchEnd',
    value: function onTouchEnd(event) {
      if (!this.touchingSideNav) {
        return;
      }

      this.touchingSideNav = false;

      var translateX = Math.min(0, this.currentX - this.startX);
      this.sideNavContainerElement.style.transform = '';

      if (translateX < 0) {
        this.hideSideNav(event);
      }
    }

    /**
     * Event handler for end of transition of the sideNav.
     *
     * @param {Event} event
     * */

  }, {
    key: 'onTransitionEnd',
    value: function onTransitionEnd(event) {
      if (event.propertyName !== this.transitionEndProperty && event.elapsedTime !== this.transitionEndTime) {
        return;
      }

      this.transitionEndProperty = null;
      this.transitionEndTime = 0;

      this.sideNavElement.classList.remove('side-nav--animatable');
      this.sideNavElement.removeEventListener('transitionend', this.onTransitionEnd);
    }

    // private

  }, {
    key: '_setup',
    value: function _setup() {
      this._addEventListeners();
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this = this;

      this.toggleButtonElement && this.toggleButtonElement.addEventListener('click', this.toggleSideNav);
      this.sideNavElement.addEventListener('click', this.hideSideNav);
      this.sideNavContainerElement.addEventListener('click', this.constructor.blockClicks);
      this.sideNavCollapseElements.forEach(function (element) {
        element.addEventListener('click', _this.hideSideNav);
      });

      this.sideNavContainerElement.addEventListener('touchstart', this.onTouchStart);
      this.sideNavContainerElement.addEventListener('touchmove', this.onTouchMove);
      this.sideNavContainerElement.addEventListener('touchend', this.onTouchEnd);
    }

    /**
     * Renders the sideNav based the touch action.
     * */

  }, {
    key: 'update',
    value: function update() {
      if (!this.touchingSideNav) {
        return;
      }

      requestAnimationFrame(this.update);

      var translateX = Math.min(0, this.currentX - this.startX);
      this.sideNavContainerElement.style.transform = 'translateX(' + translateX + 'px)';
    }
  }]);

  return SideNav;
}();

/* harmony default export */ __webpack_exports__["a"] = (SideNav);

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_lightbox__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_simple_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_simple_lightbox__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var Lightbox = function () {
  function Lightbox() {
    _classCallCheck(this, Lightbox);

    this._setup();
  }

  _createClass(Lightbox, [{
    key: '_setup',
    value: function _setup() {
      new __WEBPACK_IMPORTED_MODULE_0_simple_lightbox___default.a({
        elements: 'li.list-media__item a'
      });
    }
  }]);

  return Lightbox;
}();

/* harmony default export */ __webpack_exports__["a"] = (Lightbox);

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// Default class names for nav elements
var CLASS_NAME = {
  LINK: 'navtab__link',
  LINK_ACTIVE: 'navtab__link--active',
  TAB_ITEM: 'navtab__item',
  PANE: 'navtab__pane',
  PANE_ACTIVE: 'navtab__pane--active',
  NAVTAB_CONTENT: 'navtab__content'
};

// Default NavTab selector
var DEFAULT_SELECTOR = '.navtab';

var DEFAULT_OPTIONS = {
  className: CLASS_NAME,
  selector: DEFAULT_SELECTOR
};

var NavTab = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node that functions as a navTab container
   * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
   * */
  function NavTab(elementRef) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

    _classCallCheck(this, NavTab);

    // Initialise attributes
    this.elementRef = elementRef;
    this.options = options;
    this.className = options.className || CLASS_NAME;

    this.tabLinks = elementRef.querySelectorAll('.' + this.className['LINK']);
    this.tabPanes = elementRef.querySelectorAll('.' + this.className['PANE']);

    // Bind functions
    this.clickHandler = this.clickHandler.bind(this);
    this.reset = this.reset.bind(this);

    this._setup();
  }

  /**
   * Resets the navtab.
   * */


  _createClass(NavTab, [{
    key: 'reset',
    value: function reset() {
      this._removeEventListeners();
      return new NavTab(this.elementRef, this.options);
    }

    // Event Handlers

    /**
     * Click handler of tabLinks.
     *
     * @param {Event} event - click event on tabLinks
     * */

  }, {
    key: 'clickHandler',
    value: function clickHandler(event) {
      event.preventDefault();

      var tabLink = event.target.closest('.' + this.className['LINK']);
      var linkHref = tabLink.getAttribute('href').substring(1);

      this._updateTabItem(linkHref);
      this._updateTabPane(linkHref);
      this._dispatchNavtabChangedEvent(linkHref);
    }

    // private

    /**
     * Updates all the tab items.
     *  1) Adds `active` class to the tabLink with matching `href`.
     *  1) Removes `active` class from other tabLinks.
     *
     * @param {String} href - tab ID to be activated
     * */

  }, {
    key: '_updateTabItem',
    value: function _updateTabItem(href) {
      var _this = this;

      this.tabLinks.forEach(function (tabLink) {
        if (tabLink.getAttribute('href') === '#' + href) {
          tabLink.classList.add(_this.className['LINK_ACTIVE']);
        } else {
          tabLink.classList.remove(_this.className['LINK_ACTIVE']);
        }
      });
    }

    /**
     * Updates all the tab panes.
     *  1) Adds `active` class to the tabPane with matching `href`.
     *  1) Removes `active` class from other tabPanes.
     *
     * @param {String} href - tab ID to be activated
     * */

  }, {
    key: '_updateTabPane',
    value: function _updateTabPane(href) {
      var _this2 = this;

      this.tabPanes.forEach(function (tabPane) {
        if (tabPane.getAttribute('id') === href) {
          tabPane.classList.add(_this2.className['PANE_ACTIVE']);
        } else {
          tabPane.classList.remove(_this2.className['PANE_ACTIVE']);
        }
      });
    }

    /**
     * Set-up NavTab.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      this._addEventListeners();
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this3 = this;

      this.tabLinks.forEach(function (tabLink) {
        tabLink.addEventListener('click', _this3.clickHandler);
      });
    }
  }, {
    key: '_dispatchNavtabChangedEvent',
    value: function _dispatchNavtabChangedEvent(linkHref) {
      var event = new CustomEvent(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* NAVIGATION_TAB_CHANGED */], { bubbles: true, detail: { tab: linkHref } });
      this.elementRef.dispatchEvent(event);
    }

    /**
     * Removes all the event listeners.
     * */

  }, {
    key: '_removeEventListeners',
    value: function _removeEventListeners() {
      var _this4 = this;

      this.tabLinks.forEach(function (tabLink) {
        tabLink.removeEventListener('click', _this4.clickHandler);
      });
    }
  }]);

  return NavTab;
}();

/* harmony default export */ __webpack_exports__["b"] = (NavTab);

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_CoreComponents_videoPlayer__ = __webpack_require__(57);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var CLASS_NAME = {
  PROGRESSIVE_VIDEO: 'progressive-video'
};

var SELECTOR = {
  PROGRESSIVE_VIDEO_ELEMENT: '[id^=progressiveVideo]'
};

var ProgressiveVideoLoader = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to progressively load a background video.
   * */
  function ProgressiveVideoLoader(elementRef) {
    _classCallCheck(this, ProgressiveVideoLoader);

    this.elementRef = elementRef;
    this.videoElement = this.elementRef.querySelector(SELECTOR['PROGRESSIVE_VIDEO_ELEMENT']);

    this.onLoad = this.onLoad.bind(this);

    this._setup();
  }

  /**
   * Load the video and setup the JWPlayer.
   * */


  _createClass(ProgressiveVideoLoader, [{
    key: 'load',
    value: function load() {
      if (window.jwplayer) {
        this._createVideoPlayer();
        this._addEventListeners();
      }
    }

    // Event Handlers

    /**
     * Event callback to be triggered after the JWPlayer has been setup.
     * */

  }, {
    key: 'onLoad',
    value: function onLoad(event) {
      var setupTime = event.setupTime;

      var moderationDurationTime = setupTime / 1000 * 2;
      var durationTime = moderationDurationTime < 0.5 ? moderationDurationTime : 0.5;

      this.overlay.style.transitionDuration = durationTime + 's';
      this.overlay.style.backgroundColor = '#000';
      this.overlay.style.opacity = 0;
    }

    // Private

    /**
     * Set-up the ProgressiveVideoLoader.
     *  1) Append the overlay element to load the container of the video player.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      this.elementRef.classList.add(CLASS_NAME['PROGRESSIVE_VIDEO']);
      this.overlay = this._createOverlay();
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.videoPlayer.onReady(this.onLoad);
    }

    /**
     * Creates the overlay.
     *
     * @return {Element} - HTML node for the overlay.
     * */

  }, {
    key: '_createOverlay',
    value: function _createOverlay() {
      var overlay = document.createElement('div');

      overlay.setAttribute('class', 'progressive-video--overlay');
      this.elementRef.prepend(overlay);

      return overlay;
    }

    /**
     * Setup the JWPlayer.
     * */

  }, {
    key: '_createVideoPlayer',
    value: function _createVideoPlayer() {
      var videoOptions = {
        file: this.videoElement.dataset.videoFile,
        title: this.videoElement.dataset.videoTitle,
        mediaid: this.videoElement.dataset.videoUuid,
        type: this.videoElement.dataset.videoType,
        controls: false
      };

      if (this.videoElement.dataset.videoPoster) {
        Object.assign(videoOptions, {
          image: this.videoElement.dataset.videoPoster
        });
      }

      this.videoPlayer = new __WEBPACK_IMPORTED_MODULE_0_CoreComponents_videoPlayer__["a" /* default */](this.videoElement, videoOptions);
    }
  }]);

  return ProgressiveVideoLoader;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProgressiveVideoLoader);

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/cleave.js/dist/cleave.js
var cleave = __webpack_require__(173);
var cleave_default = /*#__PURE__*/__webpack_require__.n(cleave);

// EXTERNAL MODULE: ./app/assets/javascripts/components/notification/index.js + 1 modules
var notification = __webpack_require__(50);

// EXTERNAL MODULE: ./app/assets/javascripts/utils/window.js
var utils_window = __webpack_require__(37);

// EXTERNAL MODULE: ./app/assets/javascripts/adapters/base.js
var base = __webpack_require__(23);

// CONCATENATED MODULE: ./app/assets/javascripts/adapters/promotionCode.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint camelcase: "off" */



var PromotionCodeAdapter = function (_BaseAdapter) {
  _inherits(PromotionCodeAdapter, _BaseAdapter);

  function PromotionCodeAdapter() {
    _classCallCheck(this, PromotionCodeAdapter);

    return _possibleConstructorReturn(this, (PromotionCodeAdapter.__proto__ || Object.getPrototypeOf(PromotionCodeAdapter)).apply(this, arguments));
  }

  _createClass(PromotionCodeAdapter, null, [{
    key: 'get',
    value: function get(code, price, photographerId) {
      var requestParams = {
        params: {
          code: code,
          price: price,
          photographer_id: photographerId
        }
      };

      return this.prototype.getRequest('/checkout/promotion', requestParams);
    }
  }]);

  return PromotionCodeAdapter;
}(base["a" /* default */]);

/* harmony default export */ var promotionCode = (PromotionCodeAdapter);
// CONCATENATED MODULE: ./app/assets/javascripts/adapters/payment.js
var payment__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function payment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function payment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function payment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var PaymentAdapter = function (_BaseAdapter) {
  payment__inherits(PaymentAdapter, _BaseAdapter);

  function PaymentAdapter() {
    payment__classCallCheck(this, PaymentAdapter);

    return payment__possibleConstructorReturn(this, (PaymentAdapter.__proto__ || Object.getPrototypeOf(PaymentAdapter)).apply(this, arguments));
  }

  payment__createClass(PaymentAdapter, null, [{
    key: 'create',

    /**
     * Get the photographer availabilities
     *
     * @param {Object} [payment] - payment attributes
     * @return {Promise} - a promise which will resolve to the payment completion status
     */
    value: function create(url, payment, promotionId) {
      /* eslint-disable camelcase */
      var requestParams = {
        payment: {
          provider_token: payment.providerToken,
          card_id: payment.cardId,
          payment_method: payment.paymentMethod
        },
        promotion_id: promotionId
      };
      /* eslint-enable camelcase */
      return this.prototype.postRequest(url, requestParams);
    }
  }]);

  return PaymentAdapter;
}(base["a" /* default */]);

/* harmony default export */ var payment = (PaymentAdapter);
// CONCATENATED MODULE: ./app/assets/javascripts/components/paymentForm/events.js
var PAYMENT_FORM_IS_PROCESSING = 'PAYMENT_FORM_IS_PROCESSING';
var PAYMENT_FORM_SUCCESS = 'PAYMENT_FORM_SUCCESS';
var PAYMENT_FORM_FAILURE = 'PAYMENT_FORM_FAILURE';
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(31);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./app/assets/javascripts/components/paymentForm/index.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var paymentForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function paymentForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










// Default timetable form selector
var DEFAULT_SELECTOR = '.form-payment';

var SELECTOR = {
  storedCard: 'input[name="[payment][card_id]"]',
  // NOTE: Here, we're using `data-name` to prevent sending credit card information fields to the backend server via HTTP Post
  // (according to the security best practice https://www.omise.co/security-best-practices#never-send-card-data-through-your-servers).
  cardNumberSection: '.form-payment__card-number',
  cardHolderSection: '.form-payment__cardholder',
  expirationSection: '.form-payment__expiration-security',
  cardNumber: 'input[data-name="cardNumber"]',
  cardholder: 'input[data-name="cardholder"]',
  expiration: 'input[data-name="expiration"]',
  securityCode: 'input[data-name="securityCode"]',
  paymentProviderToken: 'input[name="[payment][provider_token]"]',
  inputPaymentMethod: 'input[name="[payment][payment_method]"]',
  inputPromotionRow: '.booking-promotion__line-item',
  inputPromotionCode: '.promotion_code',
  inputPromotionPrice: '.booking-promotion__input__price',
  inputPromotionSubmit: '.booking-promotion__submit',
  discountText: '.booking-promotion__line-discount',
  totalPrice: '.booking-summary__total_price'
};

var CLASS_NAME = {
  processing: 'form-payment--processing'
};

var paymentForm_PaymentForm = function () {
  function PaymentForm(elementRef) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    paymentForm__classCallCheck(this, PaymentForm);

    this.elementRef = elementRef || document.querySelector(DEFAULT_SELECTOR);
    var selectorOptions = options['selector'] || {};

    // Stored cards
    this.storedCards = elementRef.querySelectorAll(selectorOptions['storedCard'] || SELECTOR['storedCard']);

    // New card details
    this.cardNumberSection = elementRef.querySelector(SELECTOR['cardNumberSection']);
    this.cardHolderSection = elementRef.querySelector(SELECTOR['cardHolderSection']);
    this.expirationSection = elementRef.querySelector(SELECTOR['expirationSection']);
    this.cardNumberInput = elementRef.querySelector(selectorOptions['cardNumber'] || SELECTOR['cardNumber']);
    this.cardholderInput = elementRef.querySelector(selectorOptions['cardholder'] || SELECTOR['cardholder']);
    this.expirationInput = elementRef.querySelector(selectorOptions['expiration'] || SELECTOR['expiration']);
    this.securityCodeInput = elementRef.querySelector(selectorOptions['securityCode'] || SELECTOR['securityCode']);
    this.paymentProviderTokenInput = elementRef.querySelector(selectorOptions['paymentProviderToken'] || SELECTOR['paymentProviderToken']);
    this.inputPromotionCode = elementRef.querySelector(SELECTOR['inputPromotionCode']);
    this.inputPaymentMethod = elementRef.querySelector(SELECTOR['inputPaymentMethod']);

    // Bind functions
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.onClickStoredCardHandler = this.onClickStoredCardHandler.bind(this);

    this.onProcessingHandler = this.onProcessingHandler.bind(this);
    this.onSuccessHandler = this.onSuccessHandler.bind(this);
    this.onFailureHandler = this.onFailureHandler.bind(this);

    this._setup();
    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler when the form is submitted.
   *
   * @param {Event} event - `submit` event.
   * */


  paymentForm__createClass(PaymentForm, [{
    key: 'onSubmitHandler',
    value: function onSubmitHandler(event) {
      var _this = this;

      event.preventDefault();

      var inputPromotionCode = '';
      var promotionId = '';
      if (this.elementRef.querySelector(SELECTOR['inputPromotionCode'])) {
        inputPromotionCode = this.elementRef.querySelector(SELECTOR['inputPromotionCode']).value;
        promotionId = this.elementRef.querySelector('.booking_promotion_id').value;
      }

      if (promotionId.length === 0 && inputPromotionCode.length !== 0) {
        this._checkPromotionCode(event);

        return;
      }

      if (jquery('#creditcard__form').attr('style').length > 0) {
        jquery('#formPaymentInternetBanking').submit();
        return;
      }

      if (this._usingStoredCard()) {
        this._processPayment();
        return;
      }

      var formParams = this._serializedFormParams();
      var card = { /* eslint-disable camelcase */
        name: formParams.cardholder,
        number: formParams.cardNumber,
        expiration_month: formParams.expiration.split('/')[0],
        expiration_year: formParams.expiration.split('/')[1],
        security_code: formParams.securityCode
      };

      var createTokenHandler = function createTokenHandler(statusCode, response) {
        if (statusCode === 200) {
          _this.paymentProviderTokenInput.value = response.id;
          _this._processPayment();
        } else {
          notification["b" /* default */].render('error', response.message);
        }
      };

      Omise.createToken('card', card, createTokenHandler);
    }

    /**
     * Event handler when a stored card is clicked.
     * Unselect the selected radio input when clicking on it a second time.
     *
     * @param {Event} event - `click` event.
     * */

  }, {
    key: 'onClickStoredCardHandler',
    value: function onClickStoredCardHandler(event) {
      var storeCardInput = event.currentTarget;
      if (storeCardInput.id === 'card-0') {
        this.cardNumberSection.style.display = 'block';
        this.cardHolderSection.style.display = 'block';
        this.expirationSection.style.display = 'flex';
      } else {
        this.cardNumberSection.style.display = 'none';
        this.cardHolderSection.style.display = 'none';
        this.expirationSection.style.display = 'none';
      }

      if (String(storeCardInput.dataset.checked) === 'true') {
        storeCardInput.checked = false;
        storeCardInput.dataset.checked = false;
      } else {
        storeCardInput.dataset.checked = true;

        // Reset any previously selected stored card
        this.storedCards.filter(function (storeCard) {
          return storeCard !== storeCardInput;
        }).forEach(function (storeCard) {
          storeCard.dataset.checked = false;
        });
      }
    }

    // Custom Event Handlers

    /**
     * Event handler when the payment form is being processed
     *
     * @param {Event} _event - custom event
     * */

  }, {
    key: 'onProcessingHandler',
    value: function onProcessingHandler(_event) {
      this._showSpinner();
    }

    /**
     * Event handler when the payment form is processed successfully
     * Redirect to the order detail page
     *
     * @param {Event} event - custom event
     * */

  }, {
    key: 'onSuccessHandler',
    value: function onSuccessHandler(event) {
      Object(utils_window["a" /* redirectTo */])(event.detail.authorize_uri);
    }

    /**
     * Event handler when the payment form is NOT processed successfully
     *
     * @param {Event} event - custom event
     * */

  }, {
    key: 'onFailureHandler',
    value: function onFailureHandler(event) {
      var _ref = event.detail.errors || [],
          _ref2 = _slicedToArray(_ref, 1),
          error = _ref2[0];

      this._hideSpinner();
      notification["b" /* default */].render('error', error.detail);
    }

    // Private

  }, {
    key: '_setup',
    value: function _setup() {
      // Setup input masks
      if (this.cardNumberInput && this.expirationInput) {
        new cleave_default.a(this.cardNumberInput, { creditCard: true });
        new cleave_default.a(this.expirationInput, { date: true, datePattern: ['m', 'y'] });
      }
    }
  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this2 = this;

      this.elementRef.addEventListener('submit', this.onSubmitHandler, false);
      this.storedCards.forEach(function (storedCard) {
        return storedCard.addEventListener('click', _this2.onClickStoredCardHandler);
      });
      // Select default
      if (this.storedCards.length > 0) {
        this.storedCards[0].click();
      }

      this.elementRef.addEventListener(PAYMENT_FORM_IS_PROCESSING, this.onProcessingHandler);
      this.elementRef.addEventListener(PAYMENT_FORM_SUCCESS, this.onSuccessHandler);
      this.elementRef.addEventListener(PAYMENT_FORM_FAILURE, this.onFailureHandler);
    }

    /**
     * Retrieve all input values.
     *
     * @return {Object} the form input values
     * */

  }, {
    key: '_serializedFormParams',
    value: function _serializedFormParams() {
      return {
        cardNumber: this.cardNumberInput.value,
        cardholder: this.cardholderInput.value,
        expiration: this.expirationInput.value || '',
        securityCode: this.securityCodeInput.value
      };
    }

    /**
     * Process the checkout payment.
     * */

  }, {
    key: '_processPayment',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var processingEvent, actionUrl, paymentParams, promotionId, authorizeUri, paymentSuccessEvent, paymentFailureEvent;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                processingEvent = new CustomEvent(PAYMENT_FORM_IS_PROCESSING);

                this.elementRef.dispatchEvent(processingEvent);
                actionUrl = this.elementRef.getAttribute('action');
                _context.prev = 3;
                paymentParams = {
                  providerToken: this.paymentProviderTokenInput.value,
                  cardId: this._usingStoredCard() && this._selectedStoredCard().value,
                  paymentMethod: this.inputPaymentMethod.value
                };
                promotionId = '';

                if (this.elementRef.querySelector('.booking_promotion_id')) {
                  promotionId = this.elementRef.querySelector('.booking_promotion_id').value;
                }

                _context.next = 9;
                return payment.create(actionUrl, paymentParams, promotionId);

              case 9:
                authorizeUri = _context.sent;
                paymentSuccessEvent = new CustomEvent(PAYMENT_FORM_SUCCESS, {
                  detail: authorizeUri
                });

                this.elementRef.dispatchEvent(paymentSuccessEvent);
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](3);
                paymentFailureEvent = new CustomEvent(PAYMENT_FORM_FAILURE, {
                  detail: _context.t0
                });

                this.elementRef.dispatchEvent(paymentFailureEvent);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 14]]);
      }));

      function _processPayment() {
        return _ref3.apply(this, arguments);
      }

      return _processPayment;
    }()
  }, {
    key: '_checkPromotionCode',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
        var inputPromotionCode, inputPromotionPrice, photographerId, responsePromotionCode, input, valid;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                inputPromotionCode = this.elementRef.querySelector(SELECTOR['inputPromotionCode']).value;
                inputPromotionPrice = document.querySelector(SELECTOR['inputPromotionPrice']).value;
                photographerId = document.querySelector('.booking-summary').getAttribute('data-photographer-id');
                _context2.next = 5;
                return promotionCode.get(inputPromotionCode, inputPromotionPrice, photographerId);

              case 5:
                responsePromotionCode = _context2.sent;
                input = this.elementRef.querySelector(SELECTOR['inputPromotionCode']);
                valid = false;

                if (responsePromotionCode && responsePromotionCode.id) {
                  this.elementRef.querySelector('.booking_promotion_id').value = responsePromotionCode.id;
                  document.querySelectorAll(SELECTOR['discountText']).forEach(function (element) {
                    element.innerHTML = '<td><span style="color: #00ca9f">Discount</span></td>\n                              <td><span style="color: #00ca9f">' + responsePromotionCode.discount_price + '</span></td>';
                  });
                  input.className = 'booking-promotion__input__code';
                  input.readOnly = true;
                  valid = true;
                } else {
                  document.querySelectorAll(SELECTOR['discountText']).forEach(function (element) {
                    element.innerHTML = '';
                  });
                  document.querySelectorAll(SELECTOR['discountText']).innerHTML = '';
                  this.elementRef.querySelector('.booking_promotion_id').value = '';
                  input.className = 'booking-promotion__input__code invalid';
                  notification["b" /* default */].render('error', responsePromotionCode.message);
                }

                document.querySelector(SELECTOR['totalPrice']).innerHTML = '' + responsePromotionCode.price;

                return _context2.abrupt('return', valid);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _checkPromotionCode(_x2) {
        return _ref4.apply(this, arguments);
      }

      return _checkPromotionCode;
    }()

    // Private Methods

  }, {
    key: '_usingStoredCard',
    value: function _usingStoredCard() {
      return Boolean(this._selectedStoredCard());
    }
  }, {
    key: '_selectedStoredCard',
    value: function _selectedStoredCard() {
      var storeCard = this.elementRef.querySelector(SELECTOR['storedCard'] + ':checked');
      if (storeCard && +storeCard.value !== 0) {
        return storeCard;
      } else {
        return null;
      }
    }
  }, {
    key: '_showSpinner',
    value: function _showSpinner() {
      this.elementRef.classList.add(CLASS_NAME['processing']);
    }
  }, {
    key: '_hideSpinner',
    value: function _hideSpinner() {
      this.elementRef.classList.remove(CLASS_NAME['processing']);
    }
  }]);

  return PaymentForm;
}();

/* harmony default export */ var paymentForm = __webpack_exports__["a"] = (paymentForm_PaymentForm);

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_OPTIONS = {
  enableHighAccuracy: false,
  cachingPeriod: 2 * 60 * 1000,
  timeoutPeriod: 15 * 1000
};

var BrowserGeolocationManager = function () {
  function BrowserGeolocationManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BrowserGeolocationManager);

    this.options = _extends({}, DEFAULT_OPTIONS, options);
  }

  /**
   * Get the current location of a user
   *
   * @param {Function} [onSuccess] - success callback
   * @param {Function} [onError] - error callback
   */


  _createClass(BrowserGeolocationManager, [{
    key: "getCurrentPosition",
    value: function getCurrentPosition(onSuccess, onError) {
      navigator.geolocation.getCurrentPosition(function (position) {
        return onSuccess(position);
      }, function (error) {
        return onError(error);
      }, {
        enableHighAccuracy: this.options.enableHighAccuracy,
        timeout: this.options.timeoutPeriod,
        maximumAge: this.options.cachingPeriod
      });
    }
  }]);

  return BrowserGeolocationManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (BrowserGeolocationManager);

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requestManager__ = __webpack_require__(84);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var BaseAdapter = function () {
  function BaseAdapter() {
    _classCallCheck(this, BaseAdapter);
  }

  _createClass(BaseAdapter, [{
    key: 'getRequest',


    /**
     * Make a GET request
     *
     * @param {string} [endpoint] - the API endpoint to use
     * @param {object} [params] - params to be sent
     * @return {Promise} a Promise that will resolve into an object or reject with
     *                   an error object for its reason
     */
    value: function getRequest(endpoint, params) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_requestManager__["a" /* default */])('GET', endpoint, params);
    }

    /**
     * Make a POST request
     *
     * @param {string} [endpoint] - the API endpoint to use
     * @param {object} [data] - data to be sent
     * @return {Promise} a Promise that will resolve into an object or reject with
     *                   an error object for its reason
     */

  }, {
    key: 'postRequest',
    value: function postRequest(endpoint, data) {
      var requestParams = _extends({}, this.constructor.requestHeaders(), {
        data: data
      });

      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_requestManager__["a" /* default */])('POST', endpoint, requestParams);
    }

    /**
     * Make a PATCH request
     *
     * @param {string} [endpoint] - the API endpoint to use
     * @param {object} [data] - data to be sent
     * @return {Promise} a Promise that will resolve into an object or reject with
     *                   an error object for its reason
     */

  }, {
    key: 'patchRequest',
    value: function patchRequest(endpoint, data) {
      var requestParams = _extends({}, this.constructor.requestHeaders(), {
        data: data
      });

      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_requestManager__["a" /* default */])('PATCH', endpoint, requestParams);
    }

    /**
     * Make a DELETE request
     *
     * @param {string} [endpoint] - the API endpoint to use
     * @return {Promise} a Promise that will resolve into an object or reject with
     *                   an error object for its reason
     */

  }, {
    key: 'deleteRequest',
    value: function deleteRequest(endpoint) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_requestManager__["a" /* default */])('DELETE', endpoint, this.constructor.requestHeaders());
    }
  }], [{
    key: 'requestHeaders',

    /**
     * Generates request headers for authenticated routes.
     *  Appends the csrf token in the header, required by protected Rails routes
     *
     * @return {Object} request headers
     */
    value: function requestHeaders() {
      return {
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          'Accept': 'application/json'
        }
      };
    }
  }]);

  return BaseAdapter;
}();

/* harmony default export */ __webpack_exports__["a"] = (BaseAdapter);

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_SELECTOR; });
/* unused harmony export DEFAULT_OPTIONS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_CoreComponents_svgIcon__ = __webpack_require__(65);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





// Default class names for select input states
var CLASS_NAME = {
  BASE_WRAPPER: 'select',
  SELECT_STYLED: 'select--styled',
  SELECT_PLACEHOLDER: 'select--placeholder',
  SELECT_OPTIONS: 'select__options',
  SELECT_OPEN: 'select--open',
  DISABLED: 'select--disabled',
  HIDDEN: 'hidden-xl-down'
};

// Default configs for popper
var CONFIG = {
  placement: 'bottom-end'
};

// Default select input selector
var DEFAULT_SELECTOR = '.select-input';

var DEFAULT_OPTIONS = {
  className: CLASS_NAME,
  config: CONFIG,
  selector: DEFAULT_SELECTOR,
  addDropdownIcon: true,
  addPopper: true,
  disabled: false,
  isSearchable: false
};

var SelectInput = function () {
  _createClass(SelectInput, null, [{
    key: 'appendAfter',

    /**
     * Appends `node` after `referenceNode`
     *
     * @param {Element} node - HTML node to be added in the DOM
     * @param {Element} referenceNode - HTML node after which `node` will be added.
     * */
    value: function appendAfter(node, referenceNode) {
      referenceNode.parentNode.insertBefore(node, referenceNode.nextSibling);
    }

    /**
     * Creates the search input inside the option list.
     * */

  }, {
    key: 'createSearchField',
    value: function createSearchField() {
      var searchableInput = document.createElement('input');
      searchableInput.setAttribute('type', 'search');

      // FIXME: allow modifications for placeholders
      searchableInput.setAttribute('placeholder', 'Search event types');

      var listItem = document.createElement('li');

      listItem.appendChild(searchableInput);
      return listItem;
    }

    /**
     * Initializer
     *
     * @param {Element} elementRef - HTML node, to add selectInput properties on.
     * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
     * */

  }]);

  function SelectInput(elementRef) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

    _classCallCheck(this, SelectInput);

    // Initialise attributes

    // Root selectInput container
    this.elementRef = elementRef;
    this.options = options;
    if (this.elementRef.disabled) {
      this.options.disabled = true;
    }

    this.selectOptions = this.elementRef.querySelectorAll('option');

    // Object to hold all the className of the selectInput
    this.className = options.className || CLASS_NAME;
    this.config = options.config || CONFIG;
    this.isSearchable = options.isSearchable;
    this.disabled = options.disabled === undefined ? DEFAULT_OPTIONS['disabled'] : options.disabled;
    this.addPopper = options.addPopper === undefined ? DEFAULT_OPTIONS['addPopper'] : options.addPopper;
    this.addDropdownIcon = options.addDropdownIcon === undefined ? DEFAULT_OPTIONS['addDropdownIcon'] : options.addDropdownIcon;

    // Bind functions
    this.selectHandler = this.selectHandler.bind(this);
    this.close = this.close.bind(this);
    this.toggle = this.toggle.bind(this);

    this._setup();
  }

  /**
   * Disable the selectInput.
   *  1) Disables click actions by enabling `this.disabled`.
   *  2) Closes the option lists in case its open.
   *  3) Adds `DISABLED` class to the base wrapper.
   * */


  _createClass(SelectInput, [{
    key: 'disable',
    value: function disable() {
      this.disabled = true;
      this.close();
      this.baseWrapper.classList.add('' + this.className['DISABLED']);
    }

    /**
     * Enable the selectInput.
     *  1) Enables click actions by disabling `this.disabled`.
     *  2) Removes `DISABLED` class from the base wrapper.
     * */

  }, {
    key: 'enable',
    value: function enable() {
      this.disabled = false;
      this.baseWrapper.classList.remove('' + this.className['DISABLED']);
    }

    // Event Handlers

    /**
     * Event handler to select the option.
     *
     * @param {Event} event - click event on the option.
     * @param {Element} option - HTML node clicked
     * */

  }, {
    key: 'selectHandler',
    value: function selectHandler(event, option) {
      event.preventDefault();
      event.stopPropagation();

      this.elementRef.value = option.getAttribute('rel');

      this.styledSelect.classList.remove(this.className['SELECT_PLACEHOLDER']);

      // Update the text and icon inside the dropdown
      this.styledSelect.querySelector('div').textContent = option.textContent;

      // Change event on select is only triggered when the user commits the change explicitly
      // (e.g. by selecting a value from a <select>'s dropdown with a mouse click
      // https://developer.mozilla.org/en-US/docs/Web/Events/change#Description
      //
      // Create and dispatch a manual change event
      var changeEvent = new Event('change');
      this.elementRef.dispatchEvent(changeEvent);

      this.toggle(event);
    }

    /**
     * Event handler to toggle the selectInput.
     *
     * @param {Event} event - click event on the selectInput `this.elementRef`.
     * */

  }, {
    key: 'toggle',
    value: function toggle(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.disabled) {
        return;
      }

      this.baseWrapper.classList.toggle('' + this.className['SELECT_OPEN']);
      this.addPopper && this.popper.update();
    }

    /**
     * Closes the option list.
     * */

  }, {
    key: 'close',
    value: function close() {
      this.baseWrapper.classList.remove('' + this.className['SELECT_OPEN']);
    }

    /**
     * Resets the select input. Deletes the current DOM element and re-renders them.
     * */

  }, {
    key: 'reset',
    value: function reset() {
      this.destroy();
      this.elementRef.selectedOptions[0].selected = false;

      return new SelectInput(this.elementRef, this.options);
    }

    /**
     * Destroy all the associated DOM elements.
     * */

  }, {
    key: 'destroy',
    value: function destroy() {
      this.baseWrapper.remove();
    }

    // private

    /**
     * Set-up the selectInput.
     *  1) Prepares all the DOM Nodes needed for the selectInput.
     *  2) If `this.addPopper` is true, it initializes `Popper` with the optionList.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      this.baseWrapper = this._createBaseWrapper();
      this.styledSelect = this._createStyledSelect();
      this.optionList = this._createStyledOptionList();

      this.baseWrapper.appendChild(this.styledSelect);
      this.baseWrapper.appendChild(this.optionList);

      if (this.addPopper) {
        this.popper = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](this.styledSelect, this.optionList, this.config);
      }

      this._addEventListeners();
    }

    /**
     * Creates the root container of the selectInput.
     *
     * @return {Element} - HTML node, root container of the selectInput.
     * */

  }, {
    key: '_createBaseWrapper',
    value: function _createBaseWrapper() {
      var baseWrapper = document.createElement('div');
      baseWrapper.setAttribute('class', this.className['BASE_WRAPPER']);

      this._baseWrapperAttributes().forEach(function (attribute) {
        baseWrapper.setAttribute(attribute.name, attribute.nodeValue);
      });

      this.constructor.appendAfter(baseWrapper, this.elementRef);

      return baseWrapper;
    }

    /**
     * Creates the visible selected option.
     *
     * @return {Element} - HTML node, visible selected option.
     * */

  }, {
    key: '_createStyledSelect',
    value: function _createStyledSelect() {
      var styledSelect = document.createElement('div');
      styledSelect.setAttribute('class', this.className['SELECT_STYLED']);
      styledSelect.appendChild(document.createElement('div'));

      var selectedItem = this.elementRef.selectedOptions[0];

      if (selectedItem && selectedItem.innerText) {
        styledSelect.querySelector('div').textContent = this.elementRef.selectedOptions[0].innerText;
      } else {
        styledSelect.classList.add(this.className['SELECT_PLACEHOLDER']);
        styledSelect.querySelector('div').textContent = this.elementRef.dataset.placeholder;
      }

      if (this.addDropdownIcon) {
        var selectIcon = Object(__WEBPACK_IMPORTED_MODULE_1_CoreComponents_svgIcon__["a" /* default */])({ name: 'icon-dropdown', width: 10, height: 10 });
        styledSelect.appendChild(selectIcon);
      }

      return styledSelect;
    }

    /**
     * Creates the styled option list.
     *
     * @return {Element} - HTML node, styled option list.
     * */

  }, {
    key: '_createStyledOptionList',
    value: function _createStyledOptionList() {
      var optionList = document.createElement('ul');
      optionList.setAttribute('class', this.className['SELECT_OPTIONS']);

      if (this.isSearchable) {
        var searchField = this.constructor.createSearchField();
        optionList.appendChild(searchField);
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.selectOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;

          var listItem = document.createElement('li');

          listItem.innerHTML = option.innerText;
          listItem.setAttribute('rel', option.value);

          option.classList.value && listItem.classList.add(option.classList.value);

          optionList.appendChild(listItem);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return optionList;
    }

    /**
     * Filter out the attributes to copy/clone from the original element to the custom select.
     *
     * @return {Array} - the list of attributes to copy
     * */

  }, {
    key: '_baseWrapperAttributes',
    value: function _baseWrapperAttributes() {
      var reservedAttributes = ['id', 'class', 'name'];

      return this.elementRef.attributes.filter(function (attribute) {
        return !reservedAttributes.includes(attribute.name);
      });
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this = this;

      this.styledSelect.addEventListener('click', this.toggle);

      var _loop = function _loop(option) {
        option.addEventListener('click', function (event) {
          _this.selectHandler(event, option);
        });
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.optionList.querySelectorAll('li[rel]')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var option = _step2.value;

          _loop(option);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      document.addEventListener('click', this.close);
    }
  }]);

  return SelectInput;
}();

/* harmony default export */ __webpack_exports__["b"] = (SelectInput);

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(66);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Default class names for modal states
var CLASS_NAME = {
  MODAL: 'modal',
  OVERLAY: 'modal__overlay',
  SHOW: 'modal--show',
  OPEN: 'modal__open',
  CLOSE: 'modal__close'
};



var DEFAULT_OPTIONS = {
  className: CLASS_NAME
};

var Modal = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to add modal properties on.
   * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
   * */
  function Modal(elementRef) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

    _classCallCheck(this, Modal);

    // Initialise attributes

    // Root modal container
    this.elementRef = elementRef;
    // Object to hold all the className of the modal
    this.className = options.className || CLASS_NAME;
    // Button to show the modal
    this.showButton = this._getOpenButton();
    // Button to close the modal
    this.closeButton = this._getCloseButton();

    // Bind functions
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.overlayClickHandler = this.overlayClickHandler.bind(this);

    this._setup();
    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler to open the modal.
   *
   * @param {Event} event - click event on the show button `this.showButton`.
   * */


  _createClass(Modal, [{
    key: 'show',
    value: function show(event) {
      var _this = this;

      event.preventDefault();

      this.elementRef.classList.add(this.className['SHOW']);
      document.body.classList.add(this.className['OPEN']);

      this.elementRef.classList.remove(this.className['CLOSE']);

      setTimeout(function () {
        _this.elementRef.dispatchEvent(new CustomEvent(__WEBPACK_IMPORTED_MODULE_0__events__["c" /* SHOWED_MODAL */]));
      }, 300);
      setTimeout(function () {
        _this.elementRef.setAttribute('style', 'display: block;');
      }, 100);
    }

    /**
     * Event handler to fire when the modal has been made visible to the user.
     *
     * @param {Function} callback - The callback function.
     * */

  }, {
    key: 'onShowed',
    value: function onShowed(callback) {
      return this.elementRef.addEventListener(__WEBPACK_IMPORTED_MODULE_0__events__["c" /* SHOWED_MODAL */], function (event) {
        callback(event);
      });
    }

    /**
     * Event handler to hide the modal.
     *
     * @param {Event} event - click event on the close button `this.closeButton`.
     * */

  }, {
    key: 'hide',
    value: function hide(event) {
      var _this2 = this;

      event.preventDefault();

      this.elementRef.classList.remove(this.className['SHOW']);
      document.body.classList.remove(this.className['OPEN']);

      this.elementRef.classList.add(this.className['CLOSE']);

      setTimeout(function () {
        _this2.elementRef.dispatchEvent(new CustomEvent(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* CLOSED_MODAL */]));
      }, 300);
    }

    /**
     * Event handler to fire when the modal has finished being hidden from the user.
     *
     * @param {Function} callback - The callback function.
     * */

  }, {
    key: 'onHidden',
    value: function onHidden(callback) {
      return this.elementRef.addEventListener(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* CLOSED_MODAL */], function (event) {
        callback(event);
      });
    }

    /**
     * Click event handler on modal overlay.
     *  Iterates over all modals in the page.
     *  If any modal is NOT dismissible and is already open, do not trigger modal hide action.
     *
     * @param {Event} event - click event on the overlay `this.overlay`.
     * */

  }, {
    key: 'overlayClickHandler',
    value: function overlayClickHandler(event) {
      var modals = document.querySelectorAll('.' + CLASS_NAME['MODAL']);

      modals.forEach(function (modal) {
        var isDismissible = modal.dataset.dismissible !== 'false';

        if (isDismissible) {
          modal.querySelector("[data-hide='modal']").click();
        }
      });
    }

    // private

    /**
     * Set-up the modal.
     *  1) Prepares all the DOM Nodes needed for the modal.
     *  2) Appropriately binds all necessary event callbacks.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      this.overlay = this._createOverlay();
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this3 = this;

      this.showButton.forEach(function (button) {
        button.addEventListener('click', _this3.show);
      });

      this.closeButton.forEach(function (button) {
        button.addEventListener('click', _this3.hide);
      });

      this.elementRef.addEventListener(__WEBPACK_IMPORTED_MODULE_0__events__["b" /* CLOSE_MODAL */], this.hide);
      this.elementRef.addEventListener(__WEBPACK_IMPORTED_MODULE_0__events__["d" /* SHOW_MODAL */], this.show);

      this.overlay && this.overlay.addEventListener('click', this.overlayClickHandler);
    }

    /**
     * Returns the button to open the modal.
     *  - Immediate sibling of `this.elementRef` that has
     *      `data-toggle=modal` and `data-target=#[ID_OF_MODAL]`
     *
     * @return {Element} - HTML node that opens the modal.
     * */

  }, {
    key: '_getOpenButton',
    value: function _getOpenButton() {
      var _this4 = this;

      return document.querySelectorAll('[data-toggle="' + this.className['MODAL'] + '"]').filter(function (elem) {
        return elem.dataset.target === '#' + _this4.elementRef.id;
      });
    }

    /**
     * Returns the button to close the modal.
     *  - First children of `this.elementRef` that has `data-hide='modal'`
     *
     * @return {Element} - HTML node that closes the modal.
     * */

  }, {
    key: '_getCloseButton',
    value: function _getCloseButton() {
      return this.elementRef.querySelectorAll("[data-hide='modal']");
    }

    /**
     * Creates the overlay for the modal.
     *
     * @return {Element} - HTML node for the overlay.
     * */

  }, {
    key: '_createOverlay',
    value: function _createOverlay() {
      var overlay = document.querySelector('.' + this.className['OVERLAY']);

      if (overlay) {
        return null;
      }

      overlay = document.createElement('div');
      overlay.setAttribute('class', this.className['OVERLAY']);
      document.body.appendChild(overlay);

      return overlay;
    }
  }]);

  return Modal;
}();

/* harmony default export */ __webpack_exports__["b"] = (Modal);

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = redirectTo;
/**
 * Wrapper around the window location object.
 *
 * This makes JS unit testing possible as the window method cannot be spied on.
 * See: https://railsware.com/blog/2017/01/10/mocking-es6-module-import-without-dependency-injection/
 *
 * @param {String} [url] the page url to redirect to.
 * */
function redirectTo(url) {
  window.location = url;
}

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_SEARCH_IS_FETCHING_SUGGESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOCATION_SEARCH_SUGGESTIONS_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOCATION_SEARCH_SUGGESTIONS_FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCATION_SEARCH_IS_SELECTING_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOCATION_SEARCH_SELECT_LOCATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOCATION_SEARCH_SELECT_LOCATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOCATION_SEARCH_SELECT_LOCATION_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOCATION_SEARCH_RESET_LOCATION; });
var LOCATION_SEARCH_IS_FETCHING_SUGGESTIONS = 'LOCATION_SEARCH_IS_FETCHING_SUGGESTIONS';
var LOCATION_SEARCH_SUGGESTIONS_FETCH_SUCCESS = 'LOCATION_SEARCH_SUGGESTIONS_FETCH_SUCCESS';
var LOCATION_SEARCH_SUGGESTIONS_FETCH_FAILURE = 'LOCATION_SEARCH_SUGGESTIONS_FETCH_FAILURE';

var LOCATION_SEARCH_IS_SELECTING_LOCATION = 'LOCATION_SEARCH_IS_SELECTING_LOCATION';
var LOCATION_SEARCH_SELECT_LOCATION_SUCCESS = 'LOCATION_SEARCH_SELECT_LOCATION_SUCCESS';
var LOCATION_SEARCH_SELECT_LOCATION_FAILURE = 'LOCATION_SEARCH_SELECT_LOCATION_FAILURE';
var LOCATION_SEARCH_SELECT_LOCATION_COMPLETE = 'LOCATION_SEARCH_SELECT_LOCATION_COMPLETE';

var LOCATION_SEARCH_RESET_LOCATION = 'LOCATION_SEARCH_RESET_LOCATION';

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./app/assets/javascripts/components/notification/template.js
var NOTIFICATION_ICON_MAPPING = {
  alert: 'icon-warning',
  error: 'icon-error',
  notice: 'icon-warning',
  success: 'icon-complete-circle'
};

/* harmony default export */ var template = (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var iconHref = NOTIFICATION_ICON_MAPPING[options['type']] || NOTIFICATION_ICON_MAPPING['success'];

  return '\n      <div class="notification">\n        <div class="notification__close">\n          <button type="button" class="btn">&times;</button>\n        </div>\n        <div class="notification__icon">\n          <svg width="40" height="35" viewBox="0 0 40 35">\n            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + iconHref + '"></use>\n          </svg>\n        </div>\n\n        <div class="notification__' + options['type'] + '">' + options['message'] + '</div>\n      </div>\n    ';
});
// CONCATENATED MODULE: ./app/assets/javascripts/components/notification/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_SELECTOR; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var CLASS_NAME = {
  CLOSED: 'notification--closed'
};

var SELECTOR = {
  NOTIFICATION_CLOSE_BUTTON: '.btn'
};

var DEFAULT_SELECTOR = '.notification';

var notification_Notification = function () {
  _createClass(Notification, null, [{
    key: 'render',
    value: function render(type, message) {
      var notificationElementTemplate = document.createElement('template');

      notificationElementTemplate.innerHTML = template({
        type: 'error',
        message: message
      });

      var notificationElement = notificationElementTemplate.content.children[0];

      document.body.appendChild(notificationElement);

      new Notification(notificationElement);
    }

    /**
     * Initializer
     *
     * @param {Element} elementRef - the notification target element.
     * */

  }]);

  function Notification(elementRef) {
    _classCallCheck(this, Notification);

    this.notification = elementRef;
    this.notificationCloseButton = this.notification.querySelector(SELECTOR['NOTIFICATION_CLOSE_BUTTON']);

    this.onCloseNotification = this.onCloseNotification.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler for close notification.
   * */


  _createClass(Notification, [{
    key: 'onCloseNotification',
    value: function onCloseNotification() {
      this.notification.classList.add(CLASS_NAME['CLOSED']);
    }

    // private

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.notificationCloseButton.addEventListener('click', this.onCloseNotification);
    }
  }]);

  return Notification;
}();

/* harmony default export */ var notification = __webpack_exports__["b"] = (notification_Notification);

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87);
__webpack_require__(61);
__webpack_require__(62);
__webpack_require__(63);
__webpack_require__(64);
module.exports = __webpack_require__(535);


/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./app/assets/javascripts/components/backButton/index.js
var components_backButton = __webpack_require__(116);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/backButton.js


document.querySelectorAll(components_backButton["a" /* DEFAULT_SELECTOR */]).forEach(function (backButton) {
  new components_backButton["b" /* default */](backButton);
});
// EXTERNAL MODULE: ./node_modules/nouislider/distribute/nouislider.js
var nouislider = __webpack_require__(536);
var nouislider_default = /*#__PURE__*/__webpack_require__.n(nouislider);

// CONCATENATED MODULE: ./app/assets/javascripts/components/slider/index.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var SELECTOR = {
  slider: '.slider',
  container: '.slider__container',
  minContainer: '.slider__min-value',
  maxContainer: '.slider__max-value'
};

var numberFormats = {
  thai: 'th'
};

var DEFAULT_OPTIONS = {
  selector: SELECTOR
};

var slider_Slider = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to add slider properties on.
   * */
  function Slider(elementRef) {
    _classCallCheck(this, Slider);

    // Initialise attributes

    this.elementRef = elementRef;
    this.sliderContainer = elementRef.querySelector(SELECTOR['container']);
    this.sliderMinContainer = elementRef.querySelector(SELECTOR['minContainer']);
    this.sliderMaxContainer = elementRef.querySelector(SELECTOR['maxContainer']);

    this.numberFormat = elementRef.dataset.numberFormat || numberFormats.thai;
    this.numberFormatter = new Intl.NumberFormat(this.numberFormat);

    // Bind functions
    this.changeHandler = this.changeHandler.bind(this);
    this.updateHandler = this.updateHandler.bind(this);

    this._setup();
  }

  // Event Handlers

  /**
   * Event handler when the slider value has changed.
   *  Trigerred at the end of drag
   *
   * @param {Array} _values - Current slider values
   * @param {Number} _handle - Index of handle that caused the event
   * @param {Array} unencoded - Current slider values
   * @param {Boolean} _tap - Event was caused by the user tapping the slider
   * @param {Array} _positions - Left offset of the handles in relation to the slider
   * */


  _createClass(Slider, [{
    key: 'changeHandler',
    value: function changeHandler(_values, _handle, unencoded, _tap, _positions) {
      var changeEvent = new Event('change');
      this.elementRef.dispatchEvent(changeEvent);
    }

    /**
     * Event handler when the slider value has updated.
     *
     * @param {Array} _values - Current slider values
     * @param {Number} _handle - Index of handle that caused the event
     * @param {Array} unencoded - Current slider values
     * @param {Boolean} _tap - Event was caused by the user tapping the slider
     * @param {Array} _positions - Left offset of the handles in relation to the slider
     * */

  }, {
    key: 'updateHandler',
    value: function updateHandler(_values, _handle, unencoded, _tap, _positions) {
      var _unencoded = _slicedToArray(unencoded, 2),
          minValue = _unencoded[0],
          maxValue = _unencoded[1];

      this.sliderMinContainer.innerText = this.numberFormatter.format(minValue);
      this.sliderMaxContainer.innerText = this.numberFormatter.format(maxValue);
    }

    // Private

    /**
     * Checks if the provided slider range is valid or not.
     *  Checks:
     *    - Minimum range value MUST be less than the Maximum range value.
     *    - Minimum slider value MUST be less than or equal to the Maximum slider value.
     *
     * @return {Boolean}
     * */

  }, {
    key: '_isRangeValid',
    value: function _isRangeValid() {
      var _rangeValue2 = this._rangeValue(),
          _rangeValue3 = _slicedToArray(_rangeValue2, 4),
          rangeMin = _rangeValue3[0],
          rangeMax = _rangeValue3[1],
          sliderStart = _rangeValue3[2],
          sliderEnd = _rangeValue3[3];

      return rangeMin < rangeMax && sliderStart <= sliderEnd;
    }

    /**
     * Reads the range values from the data attributes and converts them to integer.
     *
     * @return {Array} - an array of range values.
     * */

  }, {
    key: '_rangeValue',
    value: function _rangeValue() {
      return Object.values(this.sliderContainer.dataset).map(function (x) {
        return parseInt(x);
      });
    }

    /**
     * Set-up the slider.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      var _rangeValue4 = this._rangeValue(),
          _rangeValue5 = _slicedToArray(_rangeValue4, 4),
          rangeMin = _rangeValue5[0],
          rangeMax = _rangeValue5[1],
          sliderStart = _rangeValue5[2],
          sliderEnd = _rangeValue5[3];

      nouislider_default.a.create(this.sliderContainer, {
        start: [sliderStart >= rangeMin ? sliderStart : rangeMin, sliderEnd <= rangeMax ? sliderEnd : rangeMax],
        step: 1,
        range: {
          'min': [rangeMin],
          'max': [rangeMax]
        }
      });

      !this._isRangeValid() && this.sliderContainer.setAttribute('disabled', true);

      this._addEventListeners();
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.sliderContainer.noUiSlider.on('end', this.changeHandler);
      this.sliderContainer.noUiSlider.on('update', this.updateHandler);
    }
  }]);

  return Slider;
}();

/* harmony default export */ var components_slider = (slider_Slider);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/slider.js


document.querySelectorAll(DEFAULT_OPTIONS['selector']['slider']).forEach(function (slider) {
  new components_slider(slider);
});
// EXTERNAL MODULE: ./node_modules/flatpickr/dist/flatpickr.js
var flatpickr = __webpack_require__(537);
var flatpickr_default = /*#__PURE__*/__webpack_require__.n(flatpickr);

// CONCATENATED MODULE: ./app/assets/javascripts/components/calendar/index.js
var calendar__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function calendar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// Default calendar selector
var DEFAULT_SELECTOR = '.calendar';

var calendar_DEFAULT_OPTIONS = {
  selector: DEFAULT_SELECTOR
};

var calendar_Calendar = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to add calendar properties on.
   * */
  function Calendar(elementRef) {
    calendar__classCallCheck(this, Calendar);

    // Initialise attributes

    // Root dropdown container
    this.elementRef = elementRef;

    // Bind functions

    this._setup();
  }

  // Event Handlers

  // private

  /**
   * Set-up the calendar.
   * */


  calendar__createClass(Calendar, [{
    key: '_setup',
    value: function _setup() {
      flatpickr_default()(this.elementRef, {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d',
        minDate: new Date().fp_incr(1),
        disableMobile: "true",
        locale: {
          firstDayOfWeek: 1 // start week on Monday
        }
      });
    }
  }]);

  return Calendar;
}();

/* harmony default export */ var components_calendar = (calendar_Calendar);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/calendar.js


document.querySelectorAll(calendar_DEFAULT_OPTIONS['selector']).forEach(function (calendar) {
  new components_calendar(calendar);
});
// EXTERNAL MODULE: ./app/assets/javascripts/components/dropdown/index.js
var components_dropdown = __webpack_require__(117);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/dropdown.js


document.querySelectorAll(components_dropdown["a" /* DEFAULT_OPTIONS */]['selector']).forEach(function (dropdown) {
  new components_dropdown["b" /* default */](dropdown);
});
// EXTERNAL MODULE: ./app/assets/javascripts/components/locationSearch/index.js + 4 modules
var locationSearch = __webpack_require__(118);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/locationSearch.js


document.querySelectorAll(locationSearch["a" /* DEFAULT_OPTIONS */]['selector']).forEach(function (locationSearchInput) {
  new locationSearch["b" /* default */](locationSearchInput);
});
// EXTERNAL MODULE: ./app/assets/javascripts/components/modal/index.js
var components_modal = __webpack_require__(36);

// EXTERNAL MODULE: ./node_modules/intl-tel-input/index.js
var intl_tel_input = __webpack_require__(130);
var intl_tel_input_default = /*#__PURE__*/__webpack_require__.n(intl_tel_input);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/modal.js
var modal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function modal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




document.querySelectorAll('.' + components_modal["a" /* DEFAULT_OPTIONS */]['className']['MODAL']).forEach(function (modal) {
  if (!modal.classList.contains('modal-video')) {
    new components_modal["b" /* default */](modal);
  }
});

var modal_CustomerDetail = function () {
  function CustomerDetail() {
    modal__classCallCheck(this, CustomerDetail);

    this._setup();
  }

  modal__createClass(CustomerDetail, [{
    key: '_setup',
    value: function _setup() {
      var telInput = document.querySelector('#user_phone_number');
      var iti = intl_tel_input_default()(telInput, {
        initialCountry: 'th'
      });

      var numberType = iti.selectedCountryData.dialCode;
      telInput.value = telInput.value.replace('+' + numberType, '');

      var submit = document.querySelector('.form-user-profile button[type="submit"]');
      submit.addEventListener('click', this.clickHandler);
    }
  }, {
    key: 'clickHandler',
    value: function clickHandler(event) {
      var telInput = document.querySelector('#user_phone_number');
      var iti = window.intlTelInputGlobals.getInstance(telInput);

      var numberType = iti.selectedCountryData.dialCode;
      var phoneNumber = telInput.value;

      telInput.value = '+' + numberType + phoneNumber;
    }
  }]);

  return CustomerDetail;
}();

if (document.querySelector('#user_phone_number')) {
  new modal_CustomerDetail();
}
// EXTERNAL MODULE: ./app/assets/javascripts/components/navTab/index.js
var components_navTab = __webpack_require__(126);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/navTab.js


document.querySelectorAll(components_navTab["a" /* DEFAULT_OPTIONS */]['selector']).forEach(function (navTab) {
  new components_navTab["b" /* default */](navTab);
});
// EXTERNAL MODULE: ./app/assets/javascripts/components/progressiveImageLoader/index.js
var progressiveImageLoader = __webpack_require__(85);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/progressiveImageLoader.js


document.querySelectorAll(progressiveImageLoader["a" /* SELECTOR */]).forEach(function (elem) {
  var loader = new progressiveImageLoader["b" /* default */](elem);

  loader.load();
});
// EXTERNAL MODULE: ./app/assets/javascripts/components/progressiveVideoLoader/index.js
var progressiveVideoLoader = __webpack_require__(127);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/progressiveVideoLoader.js


document.querySelectorAll('.list-media__card--video').forEach(function (videoCard) {
  var loader = new progressiveVideoLoader["a" /* default */](videoCard);

  loader.load();
});
// EXTERNAL MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/registerServiceWorker.js
var registerServiceWorker = __webpack_require__(538);
var registerServiceWorker_default = /*#__PURE__*/__webpack_require__.n(registerServiceWorker);

// EXTERNAL MODULE: ./app/assets/javascripts/components/sideNav/index.js
var sideNav = __webpack_require__(124);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/sideNav.js


// Setup the side nav only if it's there
if (document.querySelector('.side-nav')) {
  new sideNav["a" /* default */]();
}
// EXTERNAL MODULE: ./app/assets/javascripts/components/userProfileForm/index.js
var userProfileForm = __webpack_require__(122);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/userProfileForm.js


document.querySelectorAll(userProfileForm["a" /* DEFAULT_OPTIONS */]['selectors']['FORM']).forEach(function (form) {
  new userProfileForm["b" /* default */](form);
});
// EXTERNAL MODULE: ./app/assets/javascripts/components/localeForm/index.js
var localeForm = __webpack_require__(123);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/localeForm.js


if (document.querySelector('.form-locale')) {
  new localeForm["a" /* default */]();
}
// EXTERNAL MODULE: ./app/assets/javascripts/components/notification/index.js + 1 modules
var components_notification = __webpack_require__(50);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/notification.js


document.querySelectorAll(components_notification["a" /* DEFAULT_SELECTOR */]).forEach(function (notification) {
  new components_notification["b" /* default */](notification);
});
// EXTERNAL MODULE: ./app/assets/javascripts/components/selectInput/index.js
var components_selectInput = __webpack_require__(24);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/selectInput.js


document.querySelectorAll(components_selectInput["a" /* DEFAULT_SELECTOR */]).forEach(function (selectInput) {
  new components_selectInput["b" /* default */](selectInput);
});
// CONCATENATED MODULE: ./app/assets/javascripts/components/map/markers/CircleMarker.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CircleMarker_DEFAULT_OPTIONS = {
  size: 48,
  borderSize: 6,
  borderColor: 'rgba(106,122,255,0.2)',
  borderColorHover: '#6a7aff',
  backgroundColor: '#00dbad',
  markerTextClass: 'map__marker-text',
  text: 'P'
};

CircleMarker.prototype = new google.maps.OverlayView();

/**
 * Initializer
 *
 * @param {Number} latitude - Latitude location.
 * @param {Number} longitude - Longitude location.
 * @param {String} link - A link url.
 * @param {String} image - An image url.
 * @param {Object} map - The Google map object.
 * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
 * */
function CircleMarker(latitude, longitude, link, image, map) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  this.latitude = latitude;
  this.longitude = longitude;
  this.link = link;
  this.image = image;
  this.map = map;
  this.options = _extends({}, CircleMarker_DEFAULT_OPTIONS, options);

  this.div = null;
  this.mouseoverListener = null;
  this.mouseoutListener = null;

  this.setMap(map);
}

/**
 * Override methods for create custom overlay (onAdd, onRemove, draw).
 * For more information: https://developers.google.com/maps/documentation/javascript/customoverlays
 * */
CircleMarker.prototype.onAdd = function () {
  var _this = this;

  var div = document.createElement('div');
  var a = document.createElement('a');
  var img = document.createElement('img');

  var circleSize = this.options.size + 'px';
  var borderSize = this.options.borderSize + 'px';
  var linkSize = this.options.size - this.options.borderSize * 2 + 'px';

  div.style.position = 'absolute';
  div.style.width = circleSize;
  div.style.height = circleSize;
  div.style.borderStyle = 'solid';
  div.style.borderWidth = borderSize;
  div.style.borderColor = this.options.borderColor;
  div.style.borderRadius = '50%';
  div.style.boxSizing = 'border-box';

  if (!this.image) {
    div.style.backgroundColor = this.options.backgroundColor;
    div.innerHTML = '<span class=\'' + this.options.markerTextClass + '\'>' + this.options.text + '</span>';
  }

  a.href = this.link;
  a.style.position = 'absolute';
  a.style.width = linkSize;
  a.style.height = linkSize;
  a.style.borderRadius = '50%';

  img.src = this.image;
  img.style.width = '100%';
  img.style.width = '100%';
  img.style.borderRadius = '50%';

  a.appendChild(img);
  div.appendChild(a);

  this.div = div;
  this.getPanes().overlayImage.appendChild(div);

  this.mouseoverListener = google.maps.event.addDomListener(div, 'mouseover', function () {
    div.style.borderColor = _this.options.borderColorHover;
  });

  this.mouseoutListener = google.maps.event.addDomListener(div, 'mouseout', function () {
    div.style.borderColor = _this.options.borderColor;
  });
};

CircleMarker.prototype.onRemove = function () {
  google.maps.event.removeListener(this.mouseoverListener);
  google.maps.event.removeListener(this.mouseoutListener);

  this.div.parentNode.removeChild(this.div);
  this.div = null;
};

CircleMarker.prototype.draw = function () {
  var photographerLatLng = new google.maps.LatLng(this.latitude, this.longitude);
  var point = this.getProjection().fromLatLngToDivPixel(photographerLatLng);

  var div = this.div;

  div.style.top = point.y + 'px';
  div.style.left = point.x + 'px';
};

/* harmony default export */ var markers_CircleMarker = (CircleMarker);
// CONCATENATED MODULE: ./app/assets/javascripts/components/map/markers/SVGMarker.js
var SVGMarker__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SVGMarker__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SVGMarker_DEFAULT_OPTIONS = {
  icon: "\n    <?xml version=\"1.0\" encoding=\"UTF-8\"?>\n    <svg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n      <title>icon-location-map</title>\n      <desc>Created with Sketch.</desc>\n      <defs></defs>\n      <g id=\"Asset\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-location-map\">\n          <g id=\"Group-2-Copy\" transform=\"translate(5.000000, 0.000000)\">\n            <path d=\"M12.329587,29.5536746 C18.3320846,20.5705956 21.3333333,14.2749263 21.3333333,10.6666667 C21.3333333,4.77562934 16.557704,0 10.6666667,0 C4.77562934,0 0,4.77562934 0,10.6666667 C0,14.274927 3.00124993,20.570598 9.0037498,29.5536798 L9.00375749,29.5536747 C9.61743448,30.4720772 10.8594303,30.7191059 11.7778327,30.105429 C11.9961929,29.9595206 12.1836786,29.7720348 12.329587,29.5536746 Z\" id=\"Oval-3\" fill=\"#6A7AFF\"></path>\n            <circle id=\"Oval-2\" fill=\"#FFFFFF\" cx=\"10.6666667\" cy=\"10.6666667\" r=\"5.33333333\"></circle>\n          </g>\n        </g>\n      </g>\n    </svg>\n  ",
  size: 32
};

/**
 * Initializer
 *
 * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
 * */

var SVGMarker = function () {
  function SVGMarker() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SVGMarker_DEFAULT_OPTIONS;

    SVGMarker__classCallCheck(this, SVGMarker);

    this.options = options;
  }

  /**
   * Get encoded icon url.
   *
   * * @return {Object} - Configuration icon object for Google map.
   * */


  SVGMarker__createClass(SVGMarker, [{
    key: "getIcon",
    value: function getIcon() {
      return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(this.options.icon.trim()),
        size: new google.maps.Size(this.options.size, this.options.size)
      };
    }
  }]);

  return SVGMarker;
}();

/* harmony default export */ var markers_SVGMarker = (SVGMarker);
// CONCATENATED MODULE: ./app/assets/javascripts/components/map/index.js
var map__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var map__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function map__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var map_DEFAULT_OPTIONS = {
  selector: '.map',
  disableDefaultUI: true,
  zoom: 16
};

var map_Map = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node for mount google map.
   * @param {Object} center - Object for set lat, lng (latitude, longitude) properties.
   * @param {Array} markers - Array of objects that consist of markers data.
   * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
   * */
  function Map(elementRef) {
    var center = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { lat: 0, lng: 0 };
    var markers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : map_DEFAULT_OPTIONS;

    map__classCallCheck(this, Map);

    this.elementRef = elementRef;
    this.center = this._getCenter(center);
    this.markers = this._getMarkers(markers);
    this.options = options;
    this.map = null;

    this._setup();
  }

  // Private

  /**
   * Set-up the Google map with markers.
   * */


  map__createClass(Map, [{
    key: '_setup',
    value: function _setup() {
      var _this = this;

      this._createMap();
      this._createPinPointOnMapLocation();
      var latLngBounds = new google.maps.LatLngBounds().extend(this.center);
      /* eslint-disable camelcase */
      this.markers.map(function (m) {
        var marker = m.marker,
            geolocation = m.geolocation;
        var link = marker.link,
            image_url = marker.image_url,
            text = marker.text;
        var lat = geolocation.lat,
            lng = geolocation.lng;


        _this._drawCircleMarker(lat, lng, link, image_url, text);
        latLngBounds.extend({ lat: lat, lng: lng });
      });

      // this would set zoom of the map to fit all the markers
      this.map.fitBounds(latLngBounds);
    }

    /**
     * Creates the Google map.
     * */

  }, {
    key: '_createMap',
    value: function _createMap() {
      this.map = new google.maps.Map(this.elementRef, map__extends({
        center: this.center
      }, this.options));
    }

    /**
     * Set center from data attribute if available, otherwise fallback on the default value
     *
     * @param {Object} defaultCenter - location geocoordinates
     * @return {Object} - location geocoordinates
     * */

  }, {
    key: '_getCenter',
    value: function _getCenter(defaultCenter) {
      return this.elementRef.dataset.center ? JSON.parse(this.elementRef.dataset.center) : defaultCenter;
    }

    /**
     * Set markers from data attribute if available, otherwise fallback on the default value
     *
     * @param {Object} defaultMarkers - array of map markers
     * @return {Object} - array of map markers
     * */

  }, {
    key: '_getMarkers',
    value: function _getMarkers(defaultMarkers) {
      return this.elementRef.dataset.markers ? JSON.parse(this.elementRef.dataset.markers) : defaultMarkers;
    }

    /**
     * Creates the Google map's marker for map location.
     *
     * @return {Object} - Google map marker object.
     * */

  }, {
    key: '_createPinPointOnMapLocation',
    value: function _createPinPointOnMapLocation() {
      return new google.maps.Marker({
        position: {
          lat: this.center.lat,
          lng: this.center.lng
        },
        map: this.map,
        icon: new markers_SVGMarker().getIcon()
      });
    }

    /**
     * Creates the Google map's "Custom Overlay" for make a circle shape marker.
     *
     * @return {Object} - Google map overlay object.
     * */

  }, {
    key: '_drawCircleMarker',
    value: function _drawCircleMarker(lat, lng, link, image, text) {
      return new markers_CircleMarker(lat, lng, link, image, this.map, { text: text });
    }
  }]);

  return Map;
}();

/* harmony default export */ var components_map = (map_Map);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/map.js


document.querySelectorAll(map_DEFAULT_OPTIONS['selector']).forEach(function (map) {
  new components_map(map);
});
// EXTERNAL MODULE: ./app/assets/javascripts/components/lightbox/index.js
var lightbox = __webpack_require__(125);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/lightbox.js


if (document.querySelector('.list-media__item a')) {
  new lightbox["a" /* default */]();
}
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(31);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./app/assets/javascripts/components/carousel/util.js
var util = __webpack_require__(539);
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./app/assets/javascripts/components/carousel/index.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var carousel__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var carousel__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function carousel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable */
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.3.1): carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */




/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME = 'carousel';
var VERSION = '4.3.1';
var DATA_KEY = 'bs.carousel';
var EVENT_KEY = '.' + DATA_KEY;
var DATA_API_KEY = '.data-api';
var JQUERY_NO_CONFLICT = jquery_default.a.fn[NAME];
var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
var SWIPE_THRESHOLD = 40;

var Default = {
  interval: 5000,
  keyboard: true,
  slide: false,
  pause: 'hover',
  wrap: true,
  touch: true
};

var DefaultType = {
  interval: '(number|boolean)',
  keyboard: 'boolean',
  slide: '(boolean|string)',
  pause: '(string|boolean)',
  wrap: 'boolean',
  touch: 'boolean'
};

var Direction = {
  NEXT: 'next',
  PREV: 'prev',
  LEFT: 'left',
  RIGHT: 'right'
};

var carousel_Event = {
  SLIDE: 'slide' + EVENT_KEY,
  SLID: 'slid' + EVENT_KEY,
  KEYDOWN: 'keydown' + EVENT_KEY,
  MOUSEENTER: 'mouseenter' + EVENT_KEY,
  MOUSELEAVE: 'mouseleave' + EVENT_KEY,
  TOUCHSTART: 'touchstart' + EVENT_KEY,
  TOUCHMOVE: 'touchmove' + EVENT_KEY,
  TOUCHEND: 'touchend' + EVENT_KEY,
  POINTERDOWN: 'pointerdown' + EVENT_KEY,
  POINTERUP: 'pointerup' + EVENT_KEY,
  DRAG_START: 'dragstart' + EVENT_KEY,
  LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY,
  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
};

var ClassName = {
  CAROUSEL: 'carousel',
  ACTIVE: 'active',
  SLIDE: 'slide',
  RIGHT: 'carousel-item-right',
  LEFT: 'carousel-item-left',
  NEXT: 'carousel-item-next',
  PREV: 'carousel-item-prev',
  ITEM: 'carousel-item',
  POINTER_EVENT: 'pointer-event'
};

var Selector = {
  ACTIVE: '.active',
  ACTIVE_ITEM: '.active.carousel-item',
  ITEM: '.carousel-item',
  ITEM_IMG: '.carousel-item img',
  NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
  INDICATORS: '.carousel-indicators',
  DATA_SLIDE: '[data-slide], [data-slide-to]',
  DATA_RIDE: '[data-ride="carousel"]'
};

var PointerType = {
  TOUCH: 'touch',
  PEN: 'pen'

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
};
var carousel_Carousel = function () {
  function Carousel(element, config) {
    carousel__classCallCheck(this, Carousel);

    this._items = null;
    this._interval = null;
    this._activeElement = null;
    this._isPaused = false;
    this._isSliding = false;
    this.touchTimeout = null;
    this.touchStartX = 0;
    this.touchDeltaX = 0;

    this._config = this._getConfig(config);
    this._element = element;
    this._indicatorsElement = this._element.querySelector(Selector.INDICATORS);
    this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);

    this._addEventListeners();
  }

  // Getters

  carousel__createClass(Carousel, [{
    key: 'next',


    // Public

    value: function next() {
      if (!this._isSliding) {
        this._slide(Direction.NEXT);
      }
    }
  }, {
    key: 'nextWhenVisible',
    value: function nextWhenVisible() {
      // Don't call next when the page isn't visible
      // or the carousel or its parent isn't visible
      if (!document.hidden && jquery_default()(this._element).is(':visible') && jquery_default()(this._element).css('visibility') !== 'hidden') {
        this.next();
      }
    }
  }, {
    key: 'prev',
    value: function prev() {
      if (!this._isSliding) {
        this._slide(Direction.PREV);
      }
    }
  }, {
    key: 'pause',
    value: function pause(event) {
      if (!event) {
        this._isPaused = true;
      }

      if (this._element.querySelector(Selector.NEXT_PREV)) {
        util_default.a.triggerTransitionEnd(this._element);
        this.cycle(true);
      }

      clearInterval(this._interval);
      this._interval = null;
    }
  }, {
    key: 'cycle',
    value: function cycle(event) {
      if (!event) {
        this._isPaused = false;
      }

      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }

      if (this._config.interval && !this._isPaused) {
        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
      }
    }
  }, {
    key: 'to',
    value: function to(index) {
      var _this = this;

      this._activeElement = this._element.querySelector(Selector.ACTIVE_ITEM);

      var activeIndex = this._getItemIndex(this._activeElement);

      if (index > this._items.length - 1 || index < 0) {
        return;
      }

      if (this._isSliding) {
        jquery_default()(this._element).one(carousel_Event.SLID, function () {
          return _this.to(index);
        });
        return;
      }

      if (activeIndex === index) {
        this.pause();
        this.cycle();
        return;
      }

      var direction = index > activeIndex ? Direction.NEXT : Direction.PREV;

      this._slide(direction, this._items[index]);
    }
  }, {
    key: 'dispose',
    value: function dispose() {
      jquery_default()(this._element).off(EVENT_KEY);
      jquery_default.a.removeData(this._element, DATA_KEY);

      this._items = null;
      this._config = null;
      this._element = null;
      this._interval = null;
      this._isPaused = null;
      this._isSliding = null;
      this._activeElement = null;
      this._indicatorsElement = null;
    }

    // Private

  }, {
    key: '_getConfig',
    value: function _getConfig(config) {
      config = carousel__extends({}, Default, config);
      util_default.a.typeCheckConfig(NAME, config, DefaultType);
      return config;
    }
  }, {
    key: '_handleSwipe',
    value: function _handleSwipe() {
      var absDeltax = Math.abs(this.touchDeltaX);

      if (absDeltax <= SWIPE_THRESHOLD) {
        return;
      }

      var direction = absDeltax / this.touchDeltaX;

      // swipe left
      if (direction > 0) {
        this.prev();
      }

      // swipe right
      if (direction < 0) {
        this.next();
      }
    }
  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this2 = this;

      if (this._config.keyboard) {
        jquery_default()(this._element).on(carousel_Event.KEYDOWN, function (event) {
          return _this2._keydown(event);
        });
      }

      if (this._config.pause === 'hover') {
        jquery_default()(this._element).on(carousel_Event.MOUSEENTER, function (event) {
          return _this2.pause(event);
        }).on(carousel_Event.MOUSELEAVE, function (event) {
          return _this2.cycle(event);
        });
      }

      if (this._config.touch) {
        this._addTouchEventListeners();
      }
    }
  }, {
    key: '_addTouchEventListeners',
    value: function _addTouchEventListeners() {
      var _this3 = this;

      if (!this._touchSupported) {
        return;
      }

      var start = function start(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchStartX = event.originalEvent.clientX;
        } else if (!_this3._pointerEvent) {
          _this3.touchStartX = event.originalEvent.touches[0].clientX;
        }
      };

      var move = function move(event) {
        // ensure swiping with one touch and not pinching
        if (event.originalEvent.touches && event.originalEvent.touches.length > 1) {
          _this3.touchDeltaX = 0;
        } else {
          _this3.touchDeltaX = event.originalEvent.touches[0].clientX - _this3.touchStartX;
        }
      };

      var end = function end(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
        }

        _this3._handleSwipe();
        if (_this3._config.pause === 'hover') {
          // If it's a touch-enabled device, mouseenter/leave are fired as
          // part of the mouse compatibility events on first tap - the carousel
          // would stop cycling until user tapped out of it;
          // here, we listen for touchend, explicitly pause the carousel
          // (as if it's the second time we tap on it, mouseenter compat event
          // is NOT fired) and after a timeout (to allow for mouse compatibility
          // events to fire) we explicitly restart cycling

          _this3.pause();
          if (_this3.touchTimeout) {
            clearTimeout(_this3.touchTimeout);
          }
          _this3.touchTimeout = setTimeout(function (event) {
            return _this3.cycle(event);
          }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
        }
      };

      jquery_default()(this._element.querySelectorAll(Selector.ITEM_IMG)).on(carousel_Event.DRAG_START, function (e) {
        return e.preventDefault();
      });
      if (this._pointerEvent) {
        jquery_default()(this._element).on(carousel_Event.POINTERDOWN, function (event) {
          return start(event);
        });
        jquery_default()(this._element).on(carousel_Event.POINTERUP, function (event) {
          return end(event);
        });

        this._element.classList.add(ClassName.POINTER_EVENT);
      } else {
        jquery_default()(this._element).on(carousel_Event.TOUCHSTART, function (event) {
          return start(event);
        });
        jquery_default()(this._element).on(carousel_Event.TOUCHMOVE, function (event) {
          return move(event);
        });
        jquery_default()(this._element).on(carousel_Event.TOUCHEND, function (event) {
          return end(event);
        });
      }
    }
  }, {
    key: '_keydown',
    value: function _keydown(event) {
      if (/input|textarea/i.test(event.target.tagName)) {
        return;
      }

      switch (event.which) {
        case ARROW_LEFT_KEYCODE:
          event.preventDefault();
          this.prev();
          break;
        case ARROW_RIGHT_KEYCODE:
          event.preventDefault();
          this.next();
          break;
        default:
      }
    }
  }, {
    key: '_getItemIndex',
    value: function _getItemIndex(element) {
      this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(Selector.ITEM)) : [];
      return this._items.indexOf(element);
    }
  }, {
    key: '_getItemByDirection',
    value: function _getItemByDirection(direction, activeElement) {
      var isNextDirection = direction === Direction.NEXT;
      var isPrevDirection = direction === Direction.PREV;
      var activeIndex = this._getItemIndex(activeElement);
      var lastItemIndex = this._items.length - 1;
      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

      if (isGoingToWrap && !this._config.wrap) {
        return activeElement;
      }

      var delta = direction === Direction.PREV ? -1 : 1;
      var itemIndex = (activeIndex + delta) % this._items.length;

      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
    }
  }, {
    key: '_triggerSlideEvent',
    value: function _triggerSlideEvent(relatedTarget, eventDirectionName) {
      var targetIndex = this._getItemIndex(relatedTarget);
      var fromIndex = this._getItemIndex(this._element.querySelector(Selector.ACTIVE_ITEM));
      var slideEvent = jquery_default.a.Event(carousel_Event.SLIDE, {
        relatedTarget: relatedTarget,
        direction: eventDirectionName,
        from: fromIndex,
        to: targetIndex
      });

      jquery_default()(this._element).trigger(slideEvent);

      return slideEvent;
    }
  }, {
    key: '_setActiveIndicatorElement',
    value: function _setActiveIndicatorElement(element) {
      if (this._indicatorsElement) {
        var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(Selector.ACTIVE));
        jquery_default()(indicators).removeClass(ClassName.ACTIVE);

        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

        if (nextIndicator) {
          jquery_default()(nextIndicator).addClass(ClassName.ACTIVE);
        }
      }
    }
  }, {
    key: '_slide',
    value: function _slide(direction, element) {
      var _this4 = this;

      var activeElement = this._element.querySelector(Selector.ACTIVE_ITEM);
      var activeElementIndex = this._getItemIndex(activeElement);
      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
      var nextElementIndex = this._getItemIndex(nextElement);
      var isCycling = Boolean(this._interval);

      var directionalClassName = void 0;
      var orderClassName = void 0;
      var eventDirectionName = void 0;

      if (direction === Direction.NEXT) {
        directionalClassName = ClassName.LEFT;
        orderClassName = ClassName.NEXT;
        eventDirectionName = Direction.LEFT;
      } else {
        directionalClassName = ClassName.RIGHT;
        orderClassName = ClassName.PREV;
        eventDirectionName = Direction.RIGHT;
      }

      if (nextElement && jquery_default()(nextElement).hasClass(ClassName.ACTIVE)) {
        this._isSliding = false;
        return;
      }

      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
      if (slideEvent.isDefaultPrevented()) {
        return;
      }

      if (!activeElement || !nextElement) {
        // Some weirdness is happening, so we bail
        return;
      }

      this._isSliding = true;

      if (isCycling) {
        this.pause();
      }

      this._setActiveIndicatorElement(nextElement);

      var slidEvent = jquery_default.a.Event(carousel_Event.SLID, {
        relatedTarget: nextElement,
        direction: eventDirectionName,
        from: activeElementIndex,
        to: nextElementIndex
      });

      if (jquery_default()(this._element).hasClass(ClassName.SLIDE)) {
        jquery_default()(nextElement).addClass(orderClassName);

        util_default.a.reflow(nextElement);

        jquery_default()(activeElement).addClass(directionalClassName);
        jquery_default()(nextElement).addClass(directionalClassName);

        var nextElementInterval = parseInt(nextElement.getAttribute('data-interval'), 10);
        if (nextElementInterval) {
          this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
          this._config.interval = nextElementInterval;
        } else {
          this._config.interval = this._config.defaultInterval || this._config.interval;
        }

        var transitionDuration = util_default.a.getTransitionDurationFromElement(activeElement);

        jquery_default()(activeElement).one(util_default.a.TRANSITION_END, function () {
          jquery_default()(nextElement).removeClass(directionalClassName + ' ' + orderClassName).addClass(ClassName.ACTIVE);

          jquery_default()(activeElement).removeClass(ClassName.ACTIVE + ' ' + orderClassName + ' ' + directionalClassName);

          _this4._isSliding = false;

          setTimeout(function () {
            return jquery_default()(_this4._element).trigger(slidEvent);
          }, 0);
        }).emulateTransitionEnd(transitionDuration);
      } else {
        jquery_default()(activeElement).removeClass(ClassName.ACTIVE);
        jquery_default()(nextElement).addClass(ClassName.ACTIVE);

        this._isSliding = false;
        jquery_default()(this._element).trigger(slidEvent);
      }

      if (isCycling) {
        this.cycle();
      }
    }

    // Static

  }], [{
    key: '_jQueryInterface',
    value: function _jQueryInterface(config) {
      return this.each(function () {
        var data = jquery_default()(this).data(DATA_KEY);
        var _config = carousel__extends({}, Default, jquery_default()(this).data());

        if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
          _config = carousel__extends({}, _config, config);
        }

        var action = typeof config === 'string' ? config : _config.slide;

        if (!data) {
          data = new Carousel(this, _config);
          jquery_default()(this).data(DATA_KEY, data);
        }

        if (typeof config === 'number') {
          data.to(config);
        } else if (typeof action === 'string') {
          if (typeof data[action] === 'undefined') {
            throw new TypeError('No method named "' + action + '"');
          }
          data[action]();
        } else if (_config.interval && _config.ride) {
          data.pause();
          data.cycle();
        }
      });
    }
  }, {
    key: '_dataApiClickHandler',
    value: function _dataApiClickHandler(event) {
      var selector = util_default.a.getSelectorFromElement(this);

      if (!selector) {
        return;
      }

      var target = jquery_default()(selector)[0];

      if (!target || !jquery_default()(target).hasClass(ClassName.CAROUSEL)) {
        return;
      }

      var config = carousel__extends({}, jquery_default()(target).data(), jquery_default()(this).data());
      var slideIndex = this.getAttribute('data-slide-to');

      if (slideIndex) {
        config.interval = false;
      }

      Carousel._jQueryInterface.call(jquery_default()(target), config);

      if (slideIndex) {
        jquery_default()(target).data(DATA_KEY).to(slideIndex);
      }

      event.preventDefault();
    }
  }, {
    key: 'VERSION',
    get: function get() {
      return VERSION;
    }
  }, {
    key: 'Default',
    get: function get() {
      return Default;
    }
  }]);

  return Carousel;
}();

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */

jquery_default()(document).on(carousel_Event.CLICK_DATA_API, Selector.DATA_SLIDE, carousel_Carousel._dataApiClickHandler);

jquery_default()(window).on(carousel_Event.LOAD_DATA_API, function () {
  var carousels = [].slice.call(document.querySelectorAll(Selector.DATA_RIDE));
  for (var i = 0, len = carousels.length; i < len; i++) {
    var $carousel = jquery_default()(carousels[i]);
    carousel_Carousel._jQueryInterface.call($carousel, $carousel.data());
  }
});

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

jquery_default.a.fn[NAME] = carousel_Carousel._jQueryInterface;
jquery_default.a.fn[NAME].Constructor = carousel_Carousel;
jquery_default.a.fn[NAME].noConflict = function () {
  jquery_default.a.fn[NAME] = JQUERY_NO_CONFLICT;
  return carousel_Carousel._jQueryInterface;
};

/* harmony default export */ var components_carousel = (carousel_Carousel);

/* eslint-enable */
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/carousel.js


if (document.querySelector('.carousel')) {
  new components_carousel(document.querySelector('.carousel'), {});
}
// EXTERNAL MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/Object.keys.js
var Object_keys = __webpack_require__(540);
var Object_keys_default = /*#__PURE__*/__webpack_require__.n(Object_keys);

// EXTERNAL MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/childNode.remove.js
var childNode_remove = __webpack_require__(541);
var childNode_remove_default = /*#__PURE__*/__webpack_require__.n(childNode_remove);

// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/raf.js
var raf_win = window;

var raf = raf_win.requestAnimationFrame || raf_win.webkitRequestAnimationFrame || raf_win.mozRequestAnimationFrame || raf_win.msRequestAnimationFrame || function (cb) {
  return setTimeout(cb, 16);
};
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/caf.js
var caf_win = window;

var caf = caf_win.cancelAnimationFrame || caf_win.mozCancelAnimationFrame || function (id) {
  clearTimeout(id);
};
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/extend.js
function extend() {
  var obj,
      name,
      copy,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length;

  for (; i < length; i++) {
    if ((obj = arguments[i]) !== null) {
      for (name in obj) {
        copy = obj[name];

        if (target === copy) {
          continue;
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }
  return target;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/checkStorageValue.js
function checkStorageValue(value) {
  return ['true', 'false'].indexOf(value) >= 0 ? JSON.parse(value) : value;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/setLocalStorage.js
function setLocalStorage(storage, key, value, access) {
  if (access) {
    try {
      storage.setItem(key, value);
    } catch (e) {}
  }
  return value;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/getSlideId.js
function getSlideId() {
  var id = window.tnsId;
  window.tnsId = !id ? 1 : id + 1;

  return 'tns' + window.tnsId;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/getBody.js
function getBody() {
  var doc = document,
      body = doc.body;

  if (!body) {
    body = doc.createElement('body');
    body.fake = true;
  }

  return body;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/docElement.js
var docElement = document.documentElement;
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/setFakeBody.js


function setFakeBody(body) {
  var docOverflow = '';
  if (body.fake) {
    docOverflow = docElement.style.overflow;
    // avoid crashing IE8, if background image is used
    body.style.background = '';
    // Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
    body.style.overflow = docElement.style.overflow = 'hidden';
    docElement.appendChild(body);
  }

  return docOverflow;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/resetFakeBody.js


function resetFakeBody(body, docOverflow) {
  if (body.fake) {
    body.remove();
    docElement.style.overflow = docOverflow;
    // Trigger layout so kinetic scrolling isn't disabled in iOS6+
    // eslint-disable-next-line
    docElement.offsetHeight;
  }
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/calc.js
// get css-calc 
// @return - false | calc | -webkit-calc | -moz-calc
// @usage - var calc = getCalc(); 




function calc() {
  var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      div = doc.createElement('div'),
      result = false;

  body.appendChild(div);
  try {
    var str = '(10px * 10)',
        vals = ['calc' + str, '-moz-calc' + str, '-webkit-calc' + str],
        val;
    for (var i = 0; i < 3; i++) {
      val = vals[i];
      div.style.width = val;
      if (div.offsetWidth === 100) {
        result = val.replace(str, '');
        break;
      }
    }
  } catch (e) {}

  body.fake ? resetFakeBody(body, docOverflow) : div.remove();

  return result;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/percentageLayout.js
// get subpixel support value
// @return - boolean




function percentageLayout() {
  // check subpixel layout supporting
  var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      wrapper = doc.createElement('div'),
      outer = doc.createElement('div'),
      str = '',
      count = 70,
      perPage = 3,
      supported = false;

  wrapper.className = 'tns-t-subp2';
  outer.className = 'tns-t-ct';

  for (var i = 0; i < count; i++) {
    str += '<div></div>';
  }

  outer.innerHTML = str;
  wrapper.appendChild(outer);
  body.appendChild(wrapper);

  supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;

  body.fake ? resetFakeBody(body, docOverflow) : wrapper.remove();

  return supported;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/mediaquerySupport.js




function mediaquerySupport() {
  var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      div = doc.createElement('div'),
      style = doc.createElement('style'),
      rule = '@media all and (min-width:1px){.tns-mq-test{position:absolute}}',
      position;

  style.type = 'text/css';
  div.className = 'tns-mq-test';

  body.appendChild(style);
  body.appendChild(div);

  if (style.styleSheet) {
    style.styleSheet.cssText = rule;
  } else {
    style.appendChild(doc.createTextNode(rule));
  }

  position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle['position'];

  body.fake ? resetFakeBody(body, docOverflow) : div.remove();

  return position === 'absolute';
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/createStyleSheet.js
// create and append style sheet
function createStyleSheet(media) {
  // Create the <style> tag
  var style = document.createElement('style');
  // style.setAttribute("type", "text/css");

  // Add a media (and/or media query) here if you'd like!
  // style.setAttribute("media", "screen")
  // style.setAttribute("media", "only screen and (max-width : 1024px)")
  if (media) {
    style.setAttribute('media', media);
  }

  // WebKit hack :(
  // style.appendChild(document.createTextNode(""));

  // Add the <style> element to the page
  document.querySelector('head').appendChild(style);

  return style.sheet ? style.sheet : style.styleSheet;
};
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/addCSSRule.js
// cross browsers addRule method

function addCSSRule(sheet, selector, rules, index) {
  // return raf(function() {
  'insertRule' in sheet ? sheet.insertRule(selector + '{' + rules + '}', index) : sheet.addRule(selector, rules, index);
  // });
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/removeCSSRule.js
// cross browsers addRule method

function removeCSSRule(sheet, index) {
  // return raf(function() {
  'deleteRule' in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
  // });
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/getCssRulesLength.js
function getCssRulesLength(sheet) {
  var rule = 'insertRule' in sheet ? sheet.cssRules : sheet.rules;
  return rule.length;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/toDegree.js
function toDegree(y, x) {
  return Math.atan2(y, x) * (180 / Math.PI);
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/getTouchDirection.js
function getTouchDirection(angle, range) {
  var direction = false,
      gap = Math.abs(90 - Math.abs(angle));

  if (gap >= 90 - range) {
    direction = 'horizontal';
  } else if (gap <= range) {
    direction = 'vertical';
  }

  return direction;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/forEach.js
// https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
function forEach(arr, callback, scope) {
  for (var i = 0, l = arr.length; i < l; i++) {
    callback.call(scope, arr[i], i);
  }
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/classListSupport.js
var classListSupport = 'classList' in document.createElement('_');
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/hasClass.js


var hasClass = classListSupport ? function (el, str) {
  return el.classList.contains(str);
} : function (el, str) {
  return el.className.indexOf(str) >= 0;
};


// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/addClass.js

var addClass = classListSupport ? function (el, str) {
  if (!hasClass(el, str)) {
    el.classList.add(str);
  }
} : function (el, str) {
  if (!hasClass(el, str)) {
    el.className += ' ' + str;
  }
};


// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/removeClass.js

var removeClass = classListSupport ? function (el, str) {
  if (hasClass(el, str)) {
    el.classList.remove(str);
  }
} : function (el, str) {
  if (hasClass(el, str)) {
    el.className = el.className.replace(str, '');
  }
};


// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/hasAttr.js
function hasAttr(el, attr) {
  return el.hasAttribute(attr);
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/getAttr.js
function getAttr(el, attr) {
  return el.getAttribute(attr);
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/isNodeList.js
function isNodeList(el) {
  // Only NodeList has the "item()" function
  return typeof el.item !== 'undefined';
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/setAttrs.js


function setAttrs(els, attrs) {
  els = isNodeList(els) || els instanceof Array ? els : [els];
  if (Object.prototype.toString.call(attrs) !== '[object Object]') {
    return;
  }

  for (var i = els.length; i--;) {
    for (var key in attrs) {
      els[i].setAttribute(key, attrs[key]);
    }
  }
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/removeAttrs.js


function removeAttrs(els, attrs) {
  els = isNodeList(els) || els instanceof Array ? els : [els];
  attrs = attrs instanceof Array ? attrs : [attrs];

  var attrLength = attrs.length;
  for (var i = els.length; i--;) {
    for (var j = attrLength; j--;) {
      els[i].removeAttribute(attrs[j]);
    }
  }
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/arrayFromNodeList.js
function arrayFromNodeList(nl) {
  var arr = [];
  for (var i = 0, l = nl.length; i < l; i++) {
    arr.push(nl[i]);
  }
  return arr;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/hideElement.js
function hideElement(el, forceHide) {
  if (el.style.display !== 'none') {
    el.style.display = 'none';
  }
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/showElement.js
function showElement(el, forceHide) {
  if (el.style.display === 'none') {
    el.style.display = '';
  }
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/isVisible.js
function isVisible(el) {
  return window.getComputedStyle(el).display !== 'none';
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/whichProperty.js
function whichProperty(props) {
  if (typeof props === 'string') {
    var arr = [props],
        Props = props.charAt(0).toUpperCase() + props.substr(1),
        prefixes = ['Webkit', 'Moz', 'ms', 'O'];

    prefixes.forEach(function (prefix) {
      if (prefix !== 'ms' || props === 'transform') {
        arr.push(prefix + Props);
      }
    });

    props = arr;
  }

  var el = document.createElement('fakeelement'),
      len = props.length;
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    if (el.style[prop] !== undefined) {
      return prop;
    }
  }

  return false; // explicit for ie9-
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/has3DTransforms.js




function has3DTransforms(tf) {
  if (!tf) {
    return false;
  }
  if (!window.getComputedStyle) {
    return false;
  }

  var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      el = doc.createElement('p'),
      has3d,
      cssTF = tf.length > 9 ? '-' + tf.slice(0, -9).toLowerCase() + '-' : '';

  cssTF += 'transform';

  // Add it to the body to get the computed style
  body.insertBefore(el, null);

  el.style[tf] = 'translate3d(1px,1px,1px)';
  has3d = window.getComputedStyle(el).getPropertyValue(cssTF);

  body.fake ? resetFakeBody(body, docOverflow) : el.remove();

  return has3d !== undefined && has3d.length > 0 && has3d !== 'none';
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/getEndProperty.js
// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
function getEndProperty(propIn, propOut) {
  var endProp = false;
  if (/^Webkit/.test(propIn)) {
    endProp = 'webkit' + propOut + 'End';
  } else if (/^O/.test(propIn)) {
    endProp = 'o' + propOut + 'End';
  } else if (propIn) {
    endProp = propOut.toLowerCase() + 'end';
  }
  return endProp;
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/passiveOption.js
// Test via a getter in the options object to see if the passive property is accessed
var supportsPassive = false;
try {
  var passiveOption_opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
    }
  });
  window.addEventListener('test', null, passiveOption_opts);
} catch (e) {}
var passiveOption = supportsPassive ? { passive: true } : false;
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/addEvents.js


function addEvents(el, obj, preventScrolling) {
  for (var prop in obj) {
    var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 && !preventScrolling ? passiveOption : false;
    el.addEventListener(prop, obj[prop], option);
  }
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/removeEvents.js


function removeEvents(el, obj) {
  for (var prop in obj) {
    var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 ? passiveOption : false;
    el.removeEventListener(prop, obj[prop], option);
  }
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/events.js
function Events() {
  return {
    topics: {},
    on: function on(eventName, fn) {
      this.topics[eventName] = this.topics[eventName] || [];
      this.topics[eventName].push(fn);
    },
    off: function off(eventName, fn) {
      if (this.topics[eventName]) {
        for (var i = 0; i < this.topics[eventName].length; i++) {
          if (this.topics[eventName][i] === fn) {
            this.topics[eventName].splice(i, 1);
            break;
          }
        }
      }
    },
    emit: function emit(eventName, data) {
      data.type = eventName;
      if (this.topics[eventName]) {
        this.topics[eventName].forEach(function (fn) {
          fn(data, eventName);
        });
      }
    }
  };
};
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/helpers/jsTransform.js
function jsTransform(element, attr, prefix, postfix, to, duration, callback) {
  var tick = Math.min(duration, 10),
      unit = to.indexOf('%') >= 0 ? '%' : 'px',
      to = to.replace(unit, ''),
      from = Number(element.style[attr].replace(prefix, '').replace(postfix, '').replace(unit, '')),
      positionTick = (to - from) / duration * tick,
      running;

  setTimeout(moveElement, tick);
  function moveElement() {
    duration -= tick;
    from += positionTick;
    element.style[attr] = prefix + from + unit + postfix;
    if (duration > 0) {
      setTimeout(moveElement, tick);
    } else {
      callback();
    }
  }
}
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/lib/tiny-slider.js
var tiny_slider__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






































var tiny_slider_tns = function tns(options) {
  options = extend({
    container: '.slider',
    mode: 'carousel',
    axis: 'horizontal',
    items: 1,
    gutter: 0,
    edgePadding: 0,
    fixedWidth: false,
    autoWidth: false,
    viewportMax: false,
    slideBy: 1,
    center: false,
    controls: true,
    controlsPosition: 'top',
    controlsText: ['prev', 'next'],
    controlsContainer: false,
    prevButton: false,
    nextButton: false,
    nav: true,
    navPosition: 'top',
    navContainer: false,
    navAsThumbnails: false,
    arrowKeys: false,
    speed: 300,
    autoplay: false,
    autoplayPosition: 'top',
    autoplayTimeout: 5000,
    autoplayDirection: 'forward',
    autoplayText: ['start', 'stop'],
    autoplayHoverPause: false,
    autoplayButton: false,
    autoplayButtonOutput: true,
    autoplayResetOnVisibility: true,
    animateIn: 'tns-fadeIn',
    animateOut: 'tns-fadeOut',
    animateNormal: 'tns-normal',
    animateDelay: false,
    loop: true,
    rewind: false,
    autoHeight: false,
    responsive: false,
    lazyload: false,
    lazyloadSelector: '.tns-lazy-img',
    touch: true,
    mouseDrag: false,
    swipeAngle: 15,
    nested: false,
    preventActionWhenRunning: false,
    preventScrollOnTouch: false,
    freezable: true,
    onInit: false,
    useLocalStorage: true
  }, options || {});

  var doc = document,
      win = window,
      KEYS = {
    ENTER: 13,
    SPACE: 32,
    LEFT: 37,
    RIGHT: 39
  },
      tnsStorage = {},
      localStorageAccess = options.useLocalStorage;

  if (localStorageAccess) {
    // check browser version and local storage access
    var browserInfo = navigator.userAgent;
    var uid = new Date();

    try {
      tnsStorage = win.localStorage;
      if (tnsStorage) {
        tnsStorage.setItem(uid, uid);
        localStorageAccess = tnsStorage.getItem(uid) == uid;
        tnsStorage.removeItem(uid);
      } else {
        localStorageAccess = false;
      }
      if (!localStorageAccess) {
        tnsStorage = {};
      }
    } catch (e) {
      localStorageAccess = false;
    }

    if (localStorageAccess) {
      // remove storage when browser version changes
      if (tnsStorage['tnsApp'] && tnsStorage['tnsApp'] !== browserInfo) {
        ['tC', 'tPL', 'tMQ', 'tTf', 't3D', 'tTDu', 'tTDe', 'tADu', 'tADe', 'tTE', 'tAE'].forEach(function (item) {
          tnsStorage.removeItem(item);
        });
      }
      // update browserInfo
      localStorage['tnsApp'] = browserInfo;
    }
  }

  var CALC = tnsStorage['tC'] ? checkStorageValue(tnsStorage['tC']) : setLocalStorage(tnsStorage, 'tC', calc(), localStorageAccess),
      PERCENTAGELAYOUT = tnsStorage['tPL'] ? checkStorageValue(tnsStorage['tPL']) : setLocalStorage(tnsStorage, 'tPL', percentageLayout(), localStorageAccess),
      CSSMQ = tnsStorage['tMQ'] ? checkStorageValue(tnsStorage['tMQ']) : setLocalStorage(tnsStorage, 'tMQ', mediaquerySupport(), localStorageAccess),
      TRANSFORM = tnsStorage['tTf'] ? checkStorageValue(tnsStorage['tTf']) : setLocalStorage(tnsStorage, 'tTf', whichProperty('transform'), localStorageAccess),
      HAS3DTRANSFORMS = tnsStorage['t3D'] ? checkStorageValue(tnsStorage['t3D']) : setLocalStorage(tnsStorage, 't3D', has3DTransforms(TRANSFORM), localStorageAccess),
      TRANSITIONDURATION = tnsStorage['tTDu'] ? checkStorageValue(tnsStorage['tTDu']) : setLocalStorage(tnsStorage, 'tTDu', whichProperty('transitionDuration'), localStorageAccess),
      TRANSITIONDELAY = tnsStorage['tTDe'] ? checkStorageValue(tnsStorage['tTDe']) : setLocalStorage(tnsStorage, 'tTDe', whichProperty('transitionDelay'), localStorageAccess),
      ANIMATIONDURATION = tnsStorage['tADu'] ? checkStorageValue(tnsStorage['tADu']) : setLocalStorage(tnsStorage, 'tADu', whichProperty('animationDuration'), localStorageAccess),
      ANIMATIONDELAY = tnsStorage['tADe'] ? checkStorageValue(tnsStorage['tADe']) : setLocalStorage(tnsStorage, 'tADe', whichProperty('animationDelay'), localStorageAccess),
      TRANSITIONEND = tnsStorage['tTE'] ? checkStorageValue(tnsStorage['tTE']) : setLocalStorage(tnsStorage, 'tTE', getEndProperty(TRANSITIONDURATION, 'Transition'), localStorageAccess),
      ANIMATIONEND = tnsStorage['tAE'] ? checkStorageValue(tnsStorage['tAE']) : setLocalStorage(tnsStorage, 'tAE', getEndProperty(ANIMATIONDURATION, 'Animation'), localStorageAccess);

  // get element nodes from selectors
  var supportConsoleWarn = win.console && typeof win.console.warn === 'function',
      tnsList = ['container', 'controlsContainer', 'prevButton', 'nextButton', 'navContainer', 'autoplayButton'],
      optionsElements = {};

  tnsList.forEach(function (item) {
    if (typeof options[item] === 'string') {
      var str = options[item],
          el = doc.querySelector(str);
      optionsElements[item] = str;

      if (el && el.nodeName) {
        options[item] = el;
      } else {
        if (supportConsoleWarn) {
          console.warn('Can\'t find', options[item]);
        }
      }
    }
  });

  // make sure at least 1 slide
  if (options.container.children.length < 1) {
    if (supportConsoleWarn) {
      console.warn('No slides found in', options.container);
    }
    return;
  }

  // update options
  var responsive = options.responsive,
      nested = options.nested,
      carousel = options.mode === 'carousel';

  if (responsive) {
    // apply responsive[0] to options and remove it
    if (0 in responsive) {
      options = extend(options, responsive[0]);
      delete responsive[0];
    }

    var responsiveTem = {};
    for (var key in responsive) {
      var val = responsive[key];
      // update responsive
      // from: 300: 2
      // to:
      //   300: {
      //     items: 2
      //   }
      val = typeof val === 'number' ? { items: val } : val;
      responsiveTem[key] = val;
    }
    responsive = responsiveTem;
    responsiveTem = null;
  }

  // update options
  function updateOptions(obj) {
    for (var key in obj) {
      if (!carousel) {
        if (key === 'slideBy') {
          obj[key] = 'page';
        }
        if (key === 'edgePadding') {
          obj[key] = false;
        }
        if (key === 'autoHeight') {
          obj[key] = false;
        }
      }

      // update responsive options
      if (key === 'responsive') {
        updateOptions(obj[key]);
      }
    }
  }
  if (!carousel) {
    updateOptions(options);
  }

  // === define and set variables ===
  if (!carousel) {
    options.axis = 'horizontal';
    options.slideBy = 'page';
    options.edgePadding = false;

    var animateIn = options.animateIn,
        animateOut = options.animateOut,
        animateDelay = options.animateDelay,
        animateNormal = options.animateNormal;
  }

  var horizontal = options.axis === 'horizontal',
      outerWrapper = doc.createElement('div'),
      innerWrapper = doc.createElement('div'),
      middleWrapper,
      container = options.container,
      containerParent = container.parentNode,
      containerHTML = container.outerHTML,
      slideItems = container.children,
      slideCount = slideItems.length,
      breakpointZone,
      windowWidth = getWindowWidth(),
      isOn = false;
  if (responsive) {
    setBreakpointZone();
  }
  if (carousel) {
    container.className += ' tns-vpfix';
  }

  // fixedWidth: viewport > rightBoundary > indexMax
  var autoWidth = options.autoWidth,
      fixedWidth = getOption('fixedWidth'),
      edgePadding = getOption('edgePadding'),
      gutter = getOption('gutter'),
      viewport = getViewportWidth(),
      center = getOption('center'),
      items = !autoWidth ? Math.floor(getOption('items')) : 1,
      slideBy = getOption('slideBy'),
      viewportMax = options.viewportMax || options.fixedWidthViewportWidth,
      arrowKeys = getOption('arrowKeys'),
      speed = getOption('speed'),
      rewind = options.rewind,
      loop = rewind ? false : options.loop,
      autoHeight = getOption('autoHeight'),
      controls = getOption('controls'),
      controlsText = getOption('controlsText'),
      nav = getOption('nav'),
      touch = getOption('touch'),
      mouseDrag = getOption('mouseDrag'),
      autoplay = getOption('autoplay'),
      autoplayTimeout = getOption('autoplayTimeout'),
      autoplayText = getOption('autoplayText'),
      autoplayHoverPause = getOption('autoplayHoverPause'),
      autoplayResetOnVisibility = getOption('autoplayResetOnVisibility'),
      sheet = createStyleSheet(),
      lazyload = options.lazyload,
      lazyloadSelector = options.lazyloadSelector,
      slidePositions,
      // collection of slide positions
  slideItemsOut = [],
      cloneCount = loop ? getCloneCountForLoop() : 0,
      slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2,
      hasRightDeadZone = !!((fixedWidth || autoWidth) && !loop),
      rightBoundary = fixedWidth ? getRightBoundary() : null,
      updateIndexBeforeTransform = !!(!carousel || !loop),

  // transform
  transformAttr = horizontal ? 'left' : 'top',
      transformPrefix = '',
      transformPostfix = '',

  // index
  getIndexMax = function () {
    if (fixedWidth) {
      return function () {
        return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
      };
    } else if (autoWidth) {
      return function () {
        for (var i = slideCountNew; i--;) {
          if (slidePositions[i] >= -rightBoundary) {
            return i;
          }
        }
      };
    } else {
      return function () {
        if (center && carousel && !loop) {
          return slideCount - 1;
        } else {
          return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
        }
      };
    }
  }(),
      index = getStartIndex(getOption('startIndex')),
      indexCached = index,
      displayIndex = getCurrentSlide(),
      indexMin = 0,
      indexMax = !autoWidth ? getIndexMax() : null,

  // resize
  resizeTimer,
      preventActionWhenRunning = options.preventActionWhenRunning,
      swipeAngle = options.swipeAngle,
      moveDirectionExpected = swipeAngle ? '?' : true,
      running = false,
      onInit = options.onInit,
      events = new Events(),

  // id, class
  newContainerClasses = ' tns-slider tns-' + options.mode,
      slideId = container.id || getSlideId(),
      disable = getOption('disable'),
      disabled = false,
      freezable = options.freezable,
      freeze = freezable && !autoWidth ? getFreeze() : false,
      frozen = false,
      controlsEvents = {
    'click': onControlsClick,
    'keydown': onControlsKeydown
  },
      navEvents = {
    'click': onNavClick,
    'keydown': onNavKeydown
  },
      hoverEvents = {
    'mouseover': mouseoverPause,
    'mouseout': mouseoutRestart
  },
      visibilityEvent = { 'visibilitychange': onVisibilityChange },
      docmentKeydownEvent = { 'keydown': onDocumentKeydown },
      touchEvents = {
    'touchstart': onPanStart,
    'touchmove': onPanMove,
    'touchend': onPanEnd,
    'touchcancel': onPanEnd
  },
      dragEvents = {
    'mousedown': onPanStart,
    'mousemove': onPanMove,
    'mouseup': onPanEnd,
    'mouseleave': onPanEnd
  },
      hasControls = hasOption('controls'),
      hasNav = hasOption('nav'),
      navAsThumbnails = autoWidth ? true : options.navAsThumbnails,
      hasAutoplay = hasOption('autoplay'),
      hasTouch = hasOption('touch'),
      hasMouseDrag = hasOption('mouseDrag'),
      slideActiveClass = 'tns-slide-active',
      imgCompleteClass = 'tns-complete',
      imgEvents = {
    'load': onImgLoaded,
    'error': onImgFailed
  },
      imgsComplete,
      liveregionCurrent,
      preventScroll = options.preventScrollOnTouch === 'force';

  // controls
  if (hasControls) {
    var controlsContainer = options.controlsContainer,
        controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : '',
        prevButton = options.prevButton,
        nextButton = options.nextButton,
        prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : '',
        nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : '',
        prevIsButton,
        nextIsButton;
  }

  // nav
  if (hasNav) {
    var navContainer = options.navContainer,
        navContainerHTML = options.navContainer ? options.navContainer.outerHTML : '',
        navItems,
        pages = autoWidth ? slideCount : getPages(),
        pagesCached = 0,
        navClicked = -1,
        navCurrentIndex = getCurrentNavIndex(),
        navCurrentIndexCached = navCurrentIndex,
        navActiveClass = 'tns-nav-active',
        navStr = 'Carousel Page ',
        navStrCurrent = ' (Current Slide)';
  }

  // autoplay
  if (hasAutoplay) {
    var autoplayDirection = options.autoplayDirection === 'forward' ? 1 : -1,
        autoplayButton = options.autoplayButton,
        autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : '',
        autoplayHtmlStrings = ['<span class=\'tns-visually-hidden\'>', ' animation</span>'],
        autoplayTimer,
        animating,
        autoplayHoverPaused,
        autoplayUserPaused,
        autoplayVisibilityPaused;
  }

  if (hasTouch || hasMouseDrag) {
    var initPosition = {},
        lastPosition = {},
        translateInit,
        disX,
        disY,
        panStart = false,
        rafIndex,
        getDist = horizontal ? function (a, b) {
      return a.x - b.x;
    } : function (a, b) {
      return a.y - b.y;
    };
  }

  // disable slider when slidecount <= items
  if (!autoWidth) {
    resetVariblesWhenDisable(disable || freeze);
  }

  if (TRANSFORM) {
    transformAttr = TRANSFORM;
    transformPrefix = 'translate';

    if (HAS3DTRANSFORMS) {
      transformPrefix += horizontal ? '3d(' : '3d(0px, ';
      transformPostfix = horizontal ? ', 0px, 0px)' : ', 0px)';
    } else {
      transformPrefix += horizontal ? 'X(' : 'Y(';
      transformPostfix = ')';
    }
  }

  if (carousel) {
    container.className = container.className.replace('tns-vpfix', '');
  }
  initStructure();
  initSheet();
  initSliderTransform();

  // === COMMON FUNCTIONS === //
  function resetVariblesWhenDisable(condition) {
    if (condition) {
      controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
    }
  }

  function getCurrentSlide() {
    var tem = carousel ? index - cloneCount : index;
    while (tem < 0) {
      tem += slideCount;
    }
    return tem % slideCount + 1;
  }

  function getStartIndex(ind) {
    ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
    return carousel ? ind + cloneCount : ind;
  }

  function getAbsIndex(i) {
    if (i == null) {
      i = index;
    }

    if (carousel) {
      i -= cloneCount;
    }
    while (i < 0) {
      i += slideCount;
    }

    return Math.floor(i % slideCount);
  }

  function getCurrentNavIndex() {
    var absIndex = getAbsIndex(),
        result;

    result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items);

    // set active nav to the last one when reaches the right edge
    if (!loop && carousel && index === indexMax) {
      result = pages - 1;
    }

    return result;
  }

  function getItemsMax() {
    // fixedWidth or autoWidth while viewportMax is not available
    if (autoWidth || fixedWidth && !viewportMax) {
      return slideCount - 1;
      // most cases
    } else {
      var str = fixedWidth ? 'fixedWidth' : 'items',
          arr = [];

      if (fixedWidth || options[str] < slideCount) {
        arr.push(options[str]);
      }

      if (responsive) {
        for (var bp in responsive) {
          var tem = responsive[bp][str];
          if (tem && (fixedWidth || tem < slideCount)) {
            arr.push(tem);
          }
        }
      }

      if (!arr.length) {
        arr.push(0);
      }

      return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
    }
  }

  function getCloneCountForLoop() {
    var itemsMax = getItemsMax(),
        result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
    result = Math.max(itemsMax, result);

    return hasOption('edgePadding') ? result + 1 : result;
  }

  function getWindowWidth() {
    return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
  }

  function getInsertPosition(pos) {
    return pos === 'top' ? 'afterbegin' : 'beforeend';
  }

  function getClientWidth(el) {
    var div = doc.createElement('div'),
        rect,
        width;
    el.appendChild(div);
    rect = div.getBoundingClientRect();
    width = rect.right - rect.left;
    div.remove();
    return width || getClientWidth(el.parentNode);
  }

  function getViewportWidth() {
    var gap = edgePadding ? edgePadding * 2 - gutter : 0;
    return getClientWidth(containerParent) - gap;
  }

  function hasOption(item) {
    if (options[item]) {
      return true;
    } else {
      if (responsive) {
        for (var bp in responsive) {
          if (responsive[bp][item]) {
            return true;
          }
        }
      }
      return false;
    }
  }

  // get option:
  // fixed width: viewport, fixedWidth, gutter => items
  // others: window width => all variables
  // all: items => slideBy
  function getOption(item, ww) {
    if (ww == null) {
      ww = windowWidth;
    }

    if (item === 'items' && fixedWidth) {
      return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
    } else {
      var result = options[item];

      if (responsive) {
        for (var bp in responsive) {
          // bp: convert string to number
          if (ww >= parseInt(bp)) {
            if (item in responsive[bp]) {
              result = responsive[bp][item];
            }
          }
        }
      }

      if (item === 'slideBy' && result === 'page') {
        result = getOption('items');
      }
      if (!carousel && (item === 'slideBy' || item === 'items')) {
        result = Math.floor(result);
      }

      return result;
    }
  }

  function getSlideMarginLeft(i) {
    return CALC ? CALC + '(' + i * 100 + '% / ' + slideCountNew + ')' : i * 100 / slideCountNew + '%';
  }

  function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
    var str = '';

    if (edgePaddingTem !== undefined) {
      var gap = edgePaddingTem;
      if (gutterTem) {
        gap -= gutterTem;
      }
      str = horizontal ? 'margin: 0 ' + gap + 'px 0 ' + edgePaddingTem + 'px;' : 'margin: ' + edgePaddingTem + 'px 0 ' + gap + 'px 0;';
    } else if (gutterTem && !fixedWidthTem) {
      var gutterTemUnit = '-' + gutterTem + 'px',
          dir = horizontal ? gutterTemUnit + ' 0 0' : '0 ' + gutterTemUnit + ' 0';
      str = 'margin: 0 ' + dir + ';';
    }

    if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) {
      str += getTransitionDurationStyle(speedTem);
    }
    return str;
  }

  function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
    if (fixedWidthTem) {
      return (fixedWidthTem + gutterTem) * slideCountNew + 'px';
    } else {
      return CALC ? CALC + '(' + slideCountNew * 100 + '% / ' + itemsTem + ')' : slideCountNew * 100 / itemsTem + '%';
    }
  }

  function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
    var width;

    if (fixedWidthTem) {
      width = fixedWidthTem + gutterTem + 'px';
    } else {
      if (!carousel) {
        itemsTem = Math.floor(itemsTem);
      }
      var dividend = carousel ? slideCountNew : itemsTem;
      width = CALC ? CALC + '(100% / ' + dividend + ')' : 100 / dividend + '%';
    }

    width = 'width:' + width;

    // inner slider: overwrite outer slider styles
    return nested !== 'inner' ? width + ';' : width + ' !important;';
  }

  function getSlideGutterStyle(gutterTem) {
    var str = '';

    // gutter maybe interger || 0
    // so can't use 'if (gutter)'
    if (gutterTem !== false) {
      var prop = horizontal ? 'padding-' : 'margin-',
          dir = horizontal ? 'right' : 'bottom';
      str = prop + dir + ': ' + gutterTem + 'px;';
    }

    return str;
  }

  function getCSSPrefix(name, num) {
    var prefix = name.substring(0, name.length - num).toLowerCase();
    if (prefix) {
      prefix = '-' + prefix + '-';
    }

    return prefix;
  }

  function getTransitionDurationStyle(speed) {
    return getCSSPrefix(TRANSITIONDURATION, 18) + 'transition-duration:' + speed / 1000 + 's;';
  }

  function getAnimationDurationStyle(speed) {
    return getCSSPrefix(ANIMATIONDURATION, 17) + 'animation-duration:' + speed / 1000 + 's;';
  }

  function initStructure() {
    var classOuter = 'tns-outer',
        classInner = 'tns-inner',
        hasGutter = hasOption('gutter');

    outerWrapper.className = classOuter;
    innerWrapper.className = classInner;
    outerWrapper.id = slideId + '-ow';
    innerWrapper.id = slideId + '-iw';

    // set container properties
    if (container.id === '') {
      container.id = slideId;
    }
    newContainerClasses += PERCENTAGELAYOUT || autoWidth ? ' tns-subpixel' : ' tns-no-subpixel';
    newContainerClasses += CALC ? ' tns-calc' : ' tns-no-calc';
    if (autoWidth) {
      newContainerClasses += ' tns-autowidth';
    }
    newContainerClasses += ' tns-' + options.axis;
    container.className += newContainerClasses;

    // add constrain layer for carousel
    if (carousel) {
      middleWrapper = doc.createElement('div');
      middleWrapper.id = slideId + '-mw';
      middleWrapper.className = 'tns-ovh';

      outerWrapper.appendChild(middleWrapper);
      middleWrapper.appendChild(innerWrapper);
    } else {
      outerWrapper.appendChild(innerWrapper);
    }

    if (autoHeight) {
      var wp = middleWrapper || innerWrapper;
      wp.className += ' tns-ah';
    }

    containerParent.insertBefore(outerWrapper, container);
    innerWrapper.appendChild(container);

    // add id, class, aria attributes
    // before clone slides
    forEach(slideItems, function (item, i) {
      addClass(item, 'tns-item');
      if (!item.id) {
        item.id = slideId + '-item' + i;
      }
      if (!carousel && animateNormal) {
        addClass(item, animateNormal);
      }
      setAttrs(item, {
        'aria-hidden': 'true',
        'tabindex': '-1'
      });
    });

    // ## clone slides
    // carousel: n + slides + n
    // gallery:      slides + n
    if (cloneCount) {
      var fragmentBefore = doc.createDocumentFragment(),
          fragmentAfter = doc.createDocumentFragment();

      for (var j = cloneCount; j--;) {
        var num = j % slideCount,
            cloneFirst = slideItems[num].cloneNode(true);
        removeAttrs(cloneFirst, 'id');
        fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);

        if (carousel) {
          var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
          removeAttrs(cloneLast, 'id');
          fragmentBefore.appendChild(cloneLast);
        }
      }

      container.insertBefore(fragmentBefore, container.firstChild);
      container.appendChild(fragmentAfter);
      slideItems = container.children;
    }
  }

  function initSliderTransform() {
    // ## images loaded/failed
    if (hasOption('autoHeight') || autoWidth || !horizontal) {
      var imgs = container.querySelectorAll('img');

      // add complete class if all images are loaded/failed
      forEach(imgs, function (img) {
        var src = img.src;

        if (src && src.indexOf('data:image') < 0) {
          addEvents(img, imgEvents);
          img.src = '';
          img.src = src;
          addClass(img, 'loading');
        } else if (!lazyload) {
          imgLoaded(img);
        }
      });

      // All imgs are completed
      raf(function () {
        imgsLoadedCheck(arrayFromNodeList(imgs), function () {
          imgsComplete = true;
        });
      });

      // Check imgs in window only for auto height
      if (!autoWidth && horizontal) {
        imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
      }

      lazyload ? initSliderTransformStyleCheck() : raf(function () {
        imgsLoadedCheck(arrayFromNodeList(imgs), initSliderTransformStyleCheck);
      });
    } else {
      // set container transform property
      if (carousel) {
        doContainerTransformSilent();
      }

      // update slider tools and events
      initTools();
      initEvents();
    }
  }

  function initSliderTransformStyleCheck() {
    if (autoWidth) {
      // check styles application
      var num = loop ? index : slideCount - 1;
      (function stylesApplicationCheck() {
        slideItems[num - 1].getBoundingClientRect().right.toFixed(2) === slideItems[num].getBoundingClientRect().left.toFixed(2) ? initSliderTransformCore() : setTimeout(function () {
          stylesApplicationCheck();
        }, 16);
      })();
    } else {
      initSliderTransformCore();
    }
  }

  function initSliderTransformCore() {
    // run Fn()s which are rely on image loading
    if (!horizontal || autoWidth) {
      setSlidePositions();

      if (autoWidth) {
        rightBoundary = getRightBoundary();
        if (freezable) {
          freeze = getFreeze();
        }
        indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
        resetVariblesWhenDisable(disable || freeze);
      } else {
        updateContentWrapperHeight();
      }
    }

    // set container transform property
    if (carousel) {
      doContainerTransformSilent();
    }

    // update slider tools and events
    initTools();
    initEvents();
  }

  function initSheet() {
    // gallery:
    // set animation classes and left value for gallery slider
    if (!carousel) {
      for (var i = index, l = index + Math.min(slideCount, items); i < l; i++) {
        var item = slideItems[i];
        item.style.left = (i - index) * 100 / items + '%';
        addClass(item, animateIn);
        removeClass(item, animateNormal);
      }
    }

    // #### LAYOUT

    // ## INLINE-BLOCK VS FLOAT

    // ## PercentageLayout:
    // slides: inline-block
    // remove blank space between slides by set font-size: 0

    // ## Non PercentageLayout:
    // slides: float
    //         margin-right: -100%
    //         margin-left: ~

    // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
    if (horizontal) {
      if (PERCENTAGELAYOUT || autoWidth) {
        addCSSRule(sheet, '#' + slideId + ' > .tns-item', 'font-size:' + win.getComputedStyle(slideItems[0]).fontSize + ';', getCssRulesLength(sheet));
        addCSSRule(sheet, '#' + slideId, 'font-size:0;', getCssRulesLength(sheet));
      } else if (carousel) {
        forEach(slideItems, function (slide, i) {
          slide.style.marginLeft = getSlideMarginLeft(i);
        });
      }
    }

    // ## BASIC STYLES
    if (CSSMQ) {
      // middle wrapper style
      if (TRANSITIONDURATION) {
        var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : '';
        addCSSRule(sheet, '#' + slideId + '-mw', str, getCssRulesLength(sheet));
      }

      // inner wrapper styles
      str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
      addCSSRule(sheet, '#' + slideId + '-iw', str, getCssRulesLength(sheet));

      // container styles
      if (carousel) {
        str = horizontal && !autoWidth ? 'width:' + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ';' : '';
        if (TRANSITIONDURATION) {
          str += getTransitionDurationStyle(speed);
        }
        addCSSRule(sheet, '#' + slideId, str, getCssRulesLength(sheet));
      }

      // slide styles
      str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : '';
      if (options.gutter) {
        str += getSlideGutterStyle(options.gutter);
      }
      // set gallery items transition-duration
      if (!carousel) {
        if (TRANSITIONDURATION) {
          str += getTransitionDurationStyle(speed);
        }
        if (ANIMATIONDURATION) {
          str += getAnimationDurationStyle(speed);
        }
      }
      if (str) {
        addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
      }

      // non CSS mediaqueries: IE8
      // ## update inner wrapper, container, slides if needed
      // set inline styles for inner wrapper & container
      // insert stylesheet (one line) for slides only (since slides are many)
    } else {
      // middle wrapper styles
      update_carousel_transition_duration();

      // inner wrapper styles
      innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight);

      // container styles
      if (carousel && horizontal && !autoWidth) {
        container.style.width = getContainerWidth(fixedWidth, gutter, items);
      }

      // slide styles
      var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : '';
      if (gutter) {
        str += getSlideGutterStyle(gutter);
      }

      // append to the last line
      if (str) {
        addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
      }
    }

    // ## MEDIAQUERIES
    if (responsive && CSSMQ) {
      for (var bp in responsive) {
        // bp: convert string to number
        bp = parseInt(bp);

        var opts = responsive[bp],
            str = '',
            middleWrapperStr = '',
            innerWrapperStr = '',
            containerStr = '',
            slideStr = '',
            itemsBP = !autoWidth ? getOption('items', bp) : null,
            fixedWidthBP = getOption('fixedWidth', bp),
            speedBP = getOption('speed', bp),
            edgePaddingBP = getOption('edgePadding', bp),
            autoHeightBP = getOption('autoHeight', bp),
            gutterBP = getOption('gutter', bp);

        // middle wrapper string
        if (TRANSITIONDURATION && middleWrapper && getOption('autoHeight', bp) && 'speed' in opts) {
          middleWrapperStr = '#' + slideId + '-mw{' + getTransitionDurationStyle(speedBP) + '}';
        }

        // inner wrapper string
        if ('edgePadding' in opts || 'gutter' in opts) {
          innerWrapperStr = '#' + slideId + '-iw{' + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + '}';
        }

        // container string
        if (carousel && horizontal && !autoWidth && ('fixedWidth' in opts || 'items' in opts || fixedWidth && 'gutter' in opts)) {
          containerStr = 'width:' + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ';';
        }
        if (TRANSITIONDURATION && 'speed' in opts) {
          containerStr += getTransitionDurationStyle(speedBP);
        }
        if (containerStr) {
          containerStr = '#' + slideId + '{' + containerStr + '}';
        }

        // slide string
        if ('fixedWidth' in opts || fixedWidth && 'gutter' in opts || !carousel && 'items' in opts) {
          slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
        }
        if ('gutter' in opts) {
          slideStr += getSlideGutterStyle(gutterBP);
        }
        // set gallery items transition-duration
        if (!carousel && 'speed' in opts) {
          if (TRANSITIONDURATION) {
            slideStr += getTransitionDurationStyle(speedBP);
          }
          if (ANIMATIONDURATION) {
            slideStr += getAnimationDurationStyle(speedBP);
          }
        }
        if (slideStr) {
          slideStr = '#' + slideId + ' > .tns-item{' + slideStr + '}';
        }

        // add up
        str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;

        if (str) {
          sheet.insertRule('@media (min-width: ' + bp / 16 + 'em) {' + str + '}', sheet.cssRules.length);
        }
      }
    }
  }

  function initTools() {
    // == slides ==
    updateSlideStatus();

    // == live region ==
    outerWrapper.insertAdjacentHTML('afterbegin', '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + '</span>  of ' + slideCount + '</div>');
    liveregionCurrent = outerWrapper.querySelector('.tns-liveregion .current');

    // == autoplayInit ==
    if (hasAutoplay) {
      var txt = autoplay ? 'stop' : 'start';
      if (autoplayButton) {
        setAttrs(autoplayButton, { 'data-action': txt });
      } else if (options.autoplayButtonOutput) {
        outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + '</button>');
        autoplayButton = outerWrapper.querySelector('[data-action]');
      }

      // add event
      if (autoplayButton) {
        addEvents(autoplayButton, { 'click': toggleAutoplay });
      }

      if (autoplay) {
        startAutoplay();
        if (autoplayHoverPause) {
          addEvents(container, hoverEvents);
        }
        if (autoplayResetOnVisibility) {
          addEvents(container, visibilityEvent);
        }
      }
    }

    // == navInit ==
    if (hasNav) {
      var initIndex = !carousel ? 0 : cloneCount;
      // customized nav
      // will not hide the navs in case they're thumbnails
      if (navContainer) {
        setAttrs(navContainer, { 'aria-label': 'Carousel Pagination' });
        navItems = navContainer.children;
        forEach(navItems, function (item, i) {
          setAttrs(item, {
            'data-nav': i,
            'tabindex': '-1',
            'aria-label': navStr + (i + 1),
            'aria-controls': slideId
          });
        });

        // generated nav
      } else {
        var navHtml = '',
            hiddenStr = navAsThumbnails ? '' : 'style="display:none"';
        for (var i = 0; i < slideCount; i++) {
          // hide nav items by default
          navHtml += '<a href="javascript:;" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></a>';
        }
        navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + '</div>';
        outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);

        navContainer = outerWrapper.querySelector('.tns-nav');
        navItems = navContainer.children;
      }

      updateNavVisibility();

      // add transition
      if (TRANSITIONDURATION) {
        var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(),
            str = 'transition: all ' + speed / 1000 + 's';

        if (prefix) {
          str = '-' + prefix + '-' + str;
        }

        addCSSRule(sheet, '[aria-controls^=' + slideId + '-item]', str, getCssRulesLength(sheet));
      }

      setAttrs(navItems[navCurrentIndex], { 'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent });
      removeAttrs(navItems[navCurrentIndex], 'tabindex');
      addClass(navItems[navCurrentIndex], navActiveClass);

      // add events
      addEvents(navContainer, navEvents);
    }

    // == controlsInit ==
    if (hasControls) {
      if (!controlsContainer && (!prevButton || !nextButton)) {
        outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + '</button></div>');

        controlsContainer = outerWrapper.querySelector('.tns-controls');
      }

      if (!prevButton || !nextButton) {
        prevButton = controlsContainer.children[0];
        nextButton = controlsContainer.children[1];
      }

      if (options.controlsContainer) {
        setAttrs(controlsContainer, {
          'aria-label': 'Carousel Navigation',
          'tabindex': '0'
        });
      }

      if (options.controlsContainer || options.prevButton && options.nextButton) {
        setAttrs([prevButton, nextButton], {
          'aria-controls': slideId,
          'tabindex': '-1'
        });
      }

      if (options.controlsContainer || options.prevButton && options.nextButton) {
        setAttrs(prevButton, { 'data-controls': 'prev' });
        setAttrs(nextButton, { 'data-controls': 'next' });
      }

      prevIsButton = isButton(prevButton);
      nextIsButton = isButton(nextButton);

      updateControlsStatus();

      // add events
      if (controlsContainer) {
        addEvents(controlsContainer, controlsEvents);
      } else {
        addEvents(prevButton, controlsEvents);
        addEvents(nextButton, controlsEvents);
      }
    }

    // hide tools if needed
    disableUI();
  }

  function initEvents() {
    // add events
    if (carousel && TRANSITIONEND) {
      var eve = {};
      eve[TRANSITIONEND] = onTransitionEnd;
      addEvents(container, eve);
    }

    if (touch) {
      addEvents(container, touchEvents, options.preventScrollOnTouch);
    }
    if (mouseDrag) {
      addEvents(container, dragEvents);
    }
    if (arrowKeys) {
      addEvents(doc, docmentKeydownEvent);
    }

    if (nested === 'inner') {
      events.on('outerResized', function () {
        resizeTasks();
        events.emit('innerLoaded', info());
      });
    } else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) {
      addEvents(win, { 'resize': onResize });
    }

    if (autoHeight) {
      if (nested === 'outer') {
        events.on('innerLoaded', doAutoHeight);
      } else if (!disable) {
        doAutoHeight();
      }
    }

    doLazyLoad();
    if (disable) {
      disableSlider();
    } else if (freeze) {
      freezeSlider();
    }

    events.on('indexChanged', additionalUpdates);
    if (nested === 'inner') {
      events.emit('innerLoaded', info());
    }
    if (typeof onInit === 'function') {
      onInit(info());
    }
    isOn = true;
  }

  function destroy() {
    // sheet
    sheet.disabled = true;
    if (sheet.ownerNode) {
      sheet.ownerNode.remove();
    }

    // remove win event listeners
    removeEvents(win, { 'resize': onResize });

    // arrowKeys, controls, nav
    if (arrowKeys) {
      removeEvents(doc, docmentKeydownEvent);
    }
    if (controlsContainer) {
      removeEvents(controlsContainer, controlsEvents);
    }
    if (navContainer) {
      removeEvents(navContainer, navEvents);
    }

    // autoplay
    removeEvents(container, hoverEvents);
    removeEvents(container, visibilityEvent);
    if (autoplayButton) {
      removeEvents(autoplayButton, { 'click': toggleAutoplay });
    }
    if (autoplay) {
      clearInterval(autoplayTimer);
    }

    // container
    if (carousel && TRANSITIONEND) {
      var eve = {};
      eve[TRANSITIONEND] = onTransitionEnd;
      removeEvents(container, eve);
    }
    if (touch) {
      removeEvents(container, touchEvents);
    }
    if (mouseDrag) {
      removeEvents(container, dragEvents);
    }

    // cache Object values in options && reset HTML
    var htmlList = [containerHTML, controlsContainerHTML, prevButtonHTML, nextButtonHTML, navContainerHTML, autoplayButtonHTML];

    tnsList.forEach(function (item, i) {
      var el = item === 'container' ? outerWrapper : options[item];

      if ((typeof el === 'undefined' ? 'undefined' : tiny_slider__typeof(el)) === 'object') {
        var prevEl = el.previousElementSibling ? el.previousElementSibling : false,
            parentEl = el.parentNode;
        el.outerHTML = htmlList[i];
        options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
      }
    });

    // reset variables
    tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
    // check variables
    // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });

    for (var a in this) {
      if (a !== 'rebuild') {
        this[a] = null;
      }
    }
    isOn = false;
  }

  // === ON RESIZE ===
  // responsive || fixedWidth || autoWidth || !horizontal
  function onResize(e) {
    raf(function () {
      resizeTasks(getEvent(e));
    });
  }

  function resizeTasks(e) {
    if (!isOn) {
      return;
    }
    if (nested === 'outer') {
      events.emit('outerResized', info(e));
    }
    windowWidth = getWindowWidth();
    var bpChanged,
        breakpointZoneTem = breakpointZone,
        needContainerTransform = false;

    if (responsive) {
      setBreakpointZone();
      bpChanged = breakpointZoneTem !== breakpointZone;
      // if (hasRightDeadZone) { needContainerTransform = true; } // *?
      if (bpChanged) {
        events.emit('newBreakpointStart', info(e));
      }
    }

    var indChanged,
        itemsChanged,
        itemsTem = items,
        disableTem = disable,
        freezeTem = freeze,
        arrowKeysTem = arrowKeys,
        controlsTem = controls,
        navTem = nav,
        touchTem = touch,
        mouseDragTem = mouseDrag,
        autoplayTem = autoplay,
        autoplayHoverPauseTem = autoplayHoverPause,
        autoplayResetOnVisibilityTem = autoplayResetOnVisibility,
        indexTem = index;

    if (bpChanged) {
      var fixedWidthTem = fixedWidth,
          autoHeightTem = autoHeight,
          controlsTextTem = controlsText,
          centerTem = center,
          autoplayTextTem = autoplayText;

      if (!CSSMQ) {
        var gutterTem = gutter,
            edgePaddingTem = edgePadding;
      }
    }

    // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy
    arrowKeys = getOption('arrowKeys');
    controls = getOption('controls');
    nav = getOption('nav');
    touch = getOption('touch');
    center = getOption('center');
    mouseDrag = getOption('mouseDrag');
    autoplay = getOption('autoplay');
    autoplayHoverPause = getOption('autoplayHoverPause');
    autoplayResetOnVisibility = getOption('autoplayResetOnVisibility');

    if (bpChanged) {
      disable = getOption('disable');
      fixedWidth = getOption('fixedWidth');
      speed = getOption('speed');
      autoHeight = getOption('autoHeight');
      controlsText = getOption('controlsText');
      autoplayText = getOption('autoplayText');
      autoplayTimeout = getOption('autoplayTimeout');

      if (!CSSMQ) {
        edgePadding = getOption('edgePadding');
        gutter = getOption('gutter');
      }
    }
    // update options
    resetVariblesWhenDisable(disable);

    viewport = getViewportWidth(); // <= edgePadding, gutter
    if ((!horizontal || autoWidth) && !disable) {
      setSlidePositions();
      if (!horizontal) {
        updateContentWrapperHeight(); // <= setSlidePositions
        needContainerTransform = true;
      }
    }
    if (fixedWidth || autoWidth) {
      rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
      // fixedWidth: <= viewport, fixedWidth, gutter
      indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
      // fixedWidth: <= rightBoundary, fixedWidth, gutter
    }

    if (bpChanged || fixedWidth) {
      items = getOption('items');
      slideBy = getOption('slideBy');
      itemsChanged = items !== itemsTem;

      if (itemsChanged) {
        if (!fixedWidth && !autoWidth) {
          indexMax = getIndexMax();
        } // <= items
        // check index before transform in case
        // slider reach the right edge then items become bigger
        updateIndex();
      }
    }

    if (bpChanged) {
      if (disable !== disableTem) {
        if (disable) {
          disableSlider();
        } else {
          enableSlider(); // <= slidePositions, rightBoundary, indexMax
        }
      }
    }

    if (freezable && (bpChanged || fixedWidth || autoWidth)) {
      freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
      // <= fixedWidth: fixedWidth, gutter, rightBoundary
      // <= others: items

      if (freeze !== freezeTem) {
        if (freeze) {
          doContainerTransform(getContainerTransformValue(getStartIndex(0)));
          freezeSlider();
        } else {
          unfreezeSlider();
          needContainerTransform = true;
        }
      }
    }

    resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
    if (!autoplay) {
      autoplayHoverPause = autoplayResetOnVisibility = false;
    }

    if (arrowKeys !== arrowKeysTem) {
      arrowKeys ? addEvents(doc, docmentKeydownEvent) : removeEvents(doc, docmentKeydownEvent);
    }
    if (controls !== controlsTem) {
      if (controls) {
        if (controlsContainer) {
          showElement(controlsContainer);
        } else {
          if (prevButton) {
            showElement(prevButton);
          }
          if (nextButton) {
            showElement(nextButton);
          }
        }
      } else {
        if (controlsContainer) {
          hideElement(controlsContainer);
        } else {
          if (prevButton) {
            hideElement(prevButton);
          }
          if (nextButton) {
            hideElement(nextButton);
          }
        }
      }
    }
    if (nav !== navTem) {
      nav ? showElement(navContainer) : hideElement(navContainer);
    }
    if (touch !== touchTem) {
      touch ? addEvents(container, touchEvents, options.preventScrollOnTouch) : removeEvents(container, touchEvents);
    }
    if (mouseDrag !== mouseDragTem) {
      mouseDrag ? addEvents(container, dragEvents) : removeEvents(container, dragEvents);
    }
    if (autoplay !== autoplayTem) {
      if (autoplay) {
        if (autoplayButton) {
          showElement(autoplayButton);
        }
        if (!animating && !autoplayUserPaused) {
          startAutoplay();
        }
      } else {
        if (autoplayButton) {
          hideElement(autoplayButton);
        }
        if (animating) {
          stopAutoplay();
        }
      }
    }
    if (autoplayHoverPause !== autoplayHoverPauseTem) {
      autoplayHoverPause ? addEvents(container, hoverEvents) : removeEvents(container, hoverEvents);
    }
    if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) {
      autoplayResetOnVisibility ? addEvents(doc, visibilityEvent) : removeEvents(doc, visibilityEvent);
    }

    if (bpChanged) {
      if (fixedWidth !== fixedWidthTem || center !== centerTem) {
        needContainerTransform = true;
      }

      if (autoHeight !== autoHeightTem) {
        if (!autoHeight) {
          innerWrapper.style.height = '';
        }
      }

      if (controls && controlsText !== controlsTextTem) {
        prevButton.innerHTML = controlsText[0];
        nextButton.innerHTML = controlsText[1];
      }

      if (autoplayButton && autoplayText !== autoplayTextTem) {
        var i = autoplay ? 1 : 0,
            html = autoplayButton.innerHTML,
            len = html.length - autoplayTextTem[i].length;
        if (html.substring(len) === autoplayTextTem[i]) {
          autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
        }
      }
    } else {
      if (center && (fixedWidth || autoWidth)) {
        needContainerTransform = true;
      }
    }

    if (itemsChanged || fixedWidth && !autoWidth) {
      pages = getPages();
      updateNavVisibility();
    }

    indChanged = index !== indexTem;
    if (indChanged) {
      events.emit('indexChanged', info());
      needContainerTransform = true;
    } else if (itemsChanged) {
      if (!indChanged) {
        additionalUpdates();
      }
    } else if (fixedWidth || autoWidth) {
      doLazyLoad();
      updateSlideStatus();
      updateLiveRegion();
    }

    if (itemsChanged && !carousel) {
      updateGallerySlidePositions();
    }

    if (!disable && !freeze) {
      // non-meduaqueries: IE8
      if (bpChanged && !CSSMQ) {
        // middle wrapper styles
        if (autoHeight !== autoheightTem || speed !== speedTem) {
          update_carousel_transition_duration();
        }

        // inner wrapper styles
        if (edgePadding !== edgePaddingTem || gutter !== gutterTem) {
          innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
        }

        if (horizontal) {
          // container styles
          if (carousel) {
            container.style.width = getContainerWidth(fixedWidth, gutter, items);
          }

          // slide styles
          var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);

          // remove the last line and
          // add new styles
          removeCSSRule(sheet, getCssRulesLength(sheet) - 1);
          addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
        }
      }

      // auto height
      if (autoHeight) {
        doAutoHeight();
      }

      if (needContainerTransform) {
        doContainerTransformSilent();
        indexCached = index;
      }
    }

    if (bpChanged) {
      events.emit('newBreakpointEnd', info(e));
    }
  }

  // === INITIALIZATION FUNCTIONS === //
  function getFreeze() {
    if (!fixedWidth && !autoWidth) {
      var a = center ? items - (items - 1) / 2 : items;
      return slideCount <= a;
    }

    var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount],
        vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;

    if (center) {
      vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
    }

    return width <= vp;
  }

  function setBreakpointZone() {
    breakpointZone = 0;
    for (var bp in responsive) {
      bp = parseInt(bp); // convert string to number
      if (windowWidth >= bp) {
        breakpointZone = bp;
      }
    }
  }

  // (slideBy, indexMin, indexMax) => index
  var updateIndex = function () {
    return loop ? carousel
    // loop + carousel
    ? function () {
      var leftEdge = indexMin,
          rightEdge = indexMax;

      leftEdge += slideBy;
      rightEdge -= slideBy;

      // adjust edges when has edge paddings
      // or fixed-width slider with extra space on the right side
      if (edgePadding) {
        leftEdge += 1;
        rightEdge -= 1;
      } else if (fixedWidth) {
        if ((viewport + gutter) % (fixedWidth + gutter)) {
          rightEdge -= 1;
        }
      }

      if (cloneCount) {
        if (index > rightEdge) {
          index -= slideCount;
        } else if (index < leftEdge) {
          index += slideCount;
        }
      }
    }
    // loop + gallery
    : function () {
      if (index > indexMax) {
        while (index >= indexMin + slideCount) {
          index -= slideCount;
        }
      } else if (index < indexMin) {
        while (index <= indexMax - slideCount) {
          index += slideCount;
        }
      }
    }
    // non-loop
    : function () {
      index = Math.max(indexMin, Math.min(indexMax, index));
    };
  }();

  function disableUI() {
    if (!autoplay && autoplayButton) {
      hideElement(autoplayButton);
    }
    if (!nav && navContainer) {
      hideElement(navContainer);
    }
    if (!controls) {
      if (controlsContainer) {
        hideElement(controlsContainer);
      } else {
        if (prevButton) {
          hideElement(prevButton);
        }
        if (nextButton) {
          hideElement(nextButton);
        }
      }
    }
  }

  function enableUI() {
    if (autoplay && autoplayButton) {
      showElement(autoplayButton);
    }
    if (nav && navContainer) {
      showElement(navContainer);
    }
    if (controls) {
      if (controlsContainer) {
        showElement(controlsContainer);
      } else {
        if (prevButton) {
          showElement(prevButton);
        }
        if (nextButton) {
          showElement(nextButton);
        }
      }
    }
  }

  function freezeSlider() {
    if (frozen) {
      return;
    }

    // remove edge padding from inner wrapper
    if (edgePadding) {
      innerWrapper.style.margin = '0px';
    }

    // add class tns-transparent to cloned slides
    if (cloneCount) {
      var str = 'tns-transparent';
      for (var i = cloneCount; i--;) {
        if (carousel) {
          addClass(slideItems[i], str);
        }
        addClass(slideItems[slideCountNew - i - 1], str);
      }
    }

    // update tools
    disableUI();

    frozen = true;
  }

  function unfreezeSlider() {
    if (!frozen) {
      return;
    }

    // restore edge padding for inner wrapper
    // for mordern browsers
    if (edgePadding && CSSMQ) {
      innerWrapper.style.margin = '';
    }

    // remove class tns-transparent to cloned slides
    if (cloneCount) {
      var str = 'tns-transparent';
      for (var i = cloneCount; i--;) {
        if (carousel) {
          removeClass(slideItems[i], str);
        }
        removeClass(slideItems[slideCountNew - i - 1], str);
      }
    }

    // update tools
    enableUI();

    frozen = false;
  }

  function disableSlider() {
    if (disabled) {
      return;
    }

    sheet.disabled = true;
    container.className = container.className.replace(newContainerClasses.substring(1), '');
    removeAttrs(container, ['style']);
    if (loop) {
      for (var j = cloneCount; j--;) {
        if (carousel) {
          hideElement(slideItems[j]);
        }
        hideElement(slideItems[slideCountNew - j - 1]);
      }
    }

    // vertical slider
    if (!horizontal || !carousel) {
      removeAttrs(innerWrapper, ['style']);
    }

    // gallery
    if (!carousel) {
      for (var i = index, l = index + slideCount; i < l; i++) {
        var item = slideItems[i];
        removeAttrs(item, ['style']);
        removeClass(item, animateIn);
        removeClass(item, animateNormal);
      }
    }

    // update tools
    disableUI();

    disabled = true;
  }

  function enableSlider() {
    if (!disabled) {
      return;
    }

    sheet.disabled = false;
    container.className += newContainerClasses;
    doContainerTransformSilent();

    if (loop) {
      for (var j = cloneCount; j--;) {
        if (carousel) {
          showElement(slideItems[j]);
        }
        showElement(slideItems[slideCountNew - j - 1]);
      }
    }

    // gallery
    if (!carousel) {
      for (var i = index, l = index + slideCount; i < l; i++) {
        var item = slideItems[i],
            classN = i < index + items ? animateIn : animateNormal;
        item.style.left = (i - index) * 100 / items + '%';
        addClass(item, classN);
      }
    }

    // update tools
    enableUI();

    disabled = false;
  }

  function updateLiveRegion() {
    var str = getLiveRegionStr();
    if (liveregionCurrent.innerHTML !== str) {
      liveregionCurrent.innerHTML = str;
    }
  }

  function getLiveRegionStr() {
    var arr = getVisibleSlideRange(),
        start = arr[0] + 1,
        end = arr[1] + 1;
    return start === end ? start + '' : start + ' to ' + end;
  }

  function getVisibleSlideRange(val) {
    if (val == null) {
      val = getContainerTransformValue();
    }
    var start = index,
        end,
        rangestart,
        rangeend;

    // get range start, range end for autoWidth and fixedWidth
    if (center || edgePadding) {
      if (autoWidth || fixedWidth) {
        rangestart = -(parseFloat(val) + edgePadding);
        rangeend = rangestart + viewport + edgePadding * 2;
      }
    } else {
      if (autoWidth) {
        rangestart = slidePositions[index];
        rangeend = rangestart + viewport;
      }
    }

    // get start, end
    // - check auto width
    if (autoWidth) {
      slidePositions.forEach(function (point, i) {
        if (i < slideCountNew) {
          if ((center || edgePadding) && point <= rangestart + 0.5) {
            start = i;
          }
          if (rangeend - point >= 0.5) {
            end = i;
          }
        }
      });

      // - check percentage width, fixed width
    } else {
      if (fixedWidth) {
        var cell = fixedWidth + gutter;
        if (center || edgePadding) {
          start = Math.floor(rangestart / cell);
          end = Math.ceil(rangeend / cell - 1);
        } else {
          end = start + Math.ceil(viewport / cell) - 1;
        }
      } else {
        if (center || edgePadding) {
          var a = items - 1;
          if (center) {
            start -= a / 2;
            end = index + a / 2;
          } else {
            end = index + a;
          }

          if (edgePadding) {
            var b = edgePadding * items / viewport;
            start -= b;
            end += b;
          }

          start = Math.floor(start);
          end = Math.ceil(end);
        } else {
          end = start + items - 1;
        }
      }

      start = Math.max(start, 0);
      end = Math.min(end, slideCountNew - 1);
    }

    return [start, end];
  }

  function doLazyLoad() {
    if (lazyload && !disable) {
      getImageArray.apply(null, getVisibleSlideRange()).forEach(function (img) {
        if (!hasClass(img, imgCompleteClass)) {
          // stop propagation transitionend event to container
          var eve = {};
          eve[TRANSITIONEND] = function (e) {
            e.stopPropagation();
          };
          addEvents(img, eve);

          addEvents(img, imgEvents);

          // update src
          img.src = getAttr(img, 'data-src');

          // update srcset
          var srcset = getAttr(img, 'data-srcset');
          if (srcset) {
            img.srcset = srcset;
          }

          addClass(img, 'loading');
        }
      });
    }
  }

  function onImgLoaded(e) {
    imgLoaded(getTarget(e));
  }

  function onImgFailed(e) {
    imgFailed(getTarget(e));
  }

  function imgLoaded(img) {
    addClass(img, 'loaded');
    imgCompleted(img);
  }

  function imgFailed(img) {
    addClass(img, 'failed');
    imgCompleted(img);
  }

  function imgCompleted(img) {
    addClass(img, 'tns-complete');
    removeClass(img, 'loading');
    removeEvents(img, imgEvents);
  }

  function getImageArray(start, end) {
    var imgs = [];
    while (start <= end) {
      forEach(slideItems[start].querySelectorAll('img'), function (img) {
        imgs.push(img);
      });
      start++;
    }

    return imgs;
  }

  // check if all visible images are loaded
  // and update container height if it's done
  function doAutoHeight() {
    var imgs = getImageArray.apply(null, getVisibleSlideRange());
    raf(function () {
      imgsLoadedCheck(imgs, updateInnerWrapperHeight);
    });
  }

  function imgsLoadedCheck(imgs, cb) {
    // directly execute callback function if all images are complete
    if (imgsComplete) {
      return cb();
    }

    // check selected image classes otherwise
    imgs.forEach(function (img, index) {
      if (hasClass(img, imgCompleteClass)) {
        imgs.splice(index, 1);
      }
    });

    // execute callback function if selected images are all complete
    if (!imgs.length) {
      return cb();
    }

    // otherwise execute this functiona again
    raf(function () {
      imgsLoadedCheck(imgs, cb);
    });
  }

  function additionalUpdates() {
    doLazyLoad();
    updateSlideStatus();
    updateLiveRegion();
    updateControlsStatus();
    updateNavStatus();
  }

  function update_carousel_transition_duration() {
    if (carousel && autoHeight) {
      middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + 's';
    }
  }

  function getMaxSlideHeight(slideStart, slideRange) {
    var heights = [];
    for (var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++) {
      heights.push(slideItems[i].offsetHeight);
    }

    return Math.max.apply(null, heights);
  }

  // update inner wrapper height
  // 1. get the max-height of the visible slides
  // 2. set transitionDuration to speed
  // 3. update inner wrapper height to max-height
  // 4. set transitionDuration to 0s after transition done
  function updateInnerWrapperHeight() {
    var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount),
        wp = middleWrapper || innerWrapper;

    if (wp.style.height !== maxHeight) {
      wp.style.height = maxHeight + 'px';
    }
  }

  // get the distance from the top edge of the first slide to each slide
  // (init) => slidePositions
  function setSlidePositions() {
    slidePositions = [0];
    var attr = horizontal ? 'left' : 'top',
        attr2 = horizontal ? 'right' : 'bottom',
        base = slideItems[0].getBoundingClientRect()[attr];

    forEach(slideItems, function (item, i) {
      // skip the first slide
      if (i) {
        slidePositions.push(item.getBoundingClientRect()[attr] - base);
      }
      // add the end edge
      if (i === slideCountNew - 1) {
        slidePositions.push(item.getBoundingClientRect()[attr2] - base);
      }
    });
  }

  // update slide
  function updateSlideStatus() {
    var range = getVisibleSlideRange(),
        start = range[0],
        end = range[1];

    forEach(slideItems, function (item, i) {
      // show slides
      if (i >= start && i <= end) {
        if (hasAttr(item, 'aria-hidden')) {
          removeAttrs(item, ['aria-hidden', 'tabindex']);
          addClass(item, slideActiveClass);
        }
        // hide slides
      } else {
        if (!hasAttr(item, 'aria-hidden')) {
          setAttrs(item, {
            'aria-hidden': 'true',
            'tabindex': '-1'
          });
          removeClass(item, slideActiveClass);
        }
      }
    });
  }

  // gallery: update slide position
  function updateGallerySlidePositions() {
    var l = index + Math.min(slideCount, items);
    for (var i = slideCountNew; i--;) {
      var item = slideItems[i];

      if (i >= index && i < l) {
        // add transitions to visible slides when adjusting their positions
        addClass(item, 'tns-moving');

        item.style.left = (i - index) * 100 / items + '%';
        addClass(item, animateIn);
        removeClass(item, animateNormal);
      } else if (item.style.left) {
        item.style.left = '';
        addClass(item, animateNormal);
        removeClass(item, animateIn);
      }

      // remove outlet animation
      removeClass(item, animateOut);
    }

    // removing '.tns-moving'
    setTimeout(function () {
      forEach(slideItems, function (el) {
        removeClass(el, 'tns-moving');
      });
    }, 300);
  }

  // set tabindex on Nav
  function updateNavStatus() {
    // get current nav
    if (nav) {
      navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
      navClicked = -1;

      if (navCurrentIndex !== navCurrentIndexCached) {
        var navPrev = navItems[navCurrentIndexCached],
            navCurrent = navItems[navCurrentIndex];

        setAttrs(navPrev, {
          'tabindex': '-1',
          'aria-label': navStr + (navCurrentIndexCached + 1)
        });
        removeClass(navPrev, navActiveClass);

        setAttrs(navCurrent, { 'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent });
        removeAttrs(navCurrent, 'tabindex');
        addClass(navCurrent, navActiveClass);

        navCurrentIndexCached = navCurrentIndex;
      }
    }
  }

  function getLowerCaseNodeName(el) {
    return el.nodeName.toLowerCase();
  }

  function isButton(el) {
    return getLowerCaseNodeName(el) === 'button';
  }

  function isAriaDisabled(el) {
    return el.getAttribute('aria-disabled') === 'true';
  }

  function disEnableElement(isButton, el, val) {
    if (isButton) {
      el.disabled = val;
    } else {
      el.setAttribute('aria-disabled', val.toString());
    }
  }

  // set 'disabled' to true on controls when reach the edges
  function updateControlsStatus() {
    if (!controls || rewind || loop) {
      return;
    }

    var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton),
        nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton),
        disablePrev = index <= indexMin,
        disableNext = !!(!rewind && index >= indexMax);

    if (disablePrev && !prevDisabled) {
      disEnableElement(prevIsButton, prevButton, true);
    }
    if (!disablePrev && prevDisabled) {
      disEnableElement(prevIsButton, prevButton, false);
    }
    if (disableNext && !nextDisabled) {
      disEnableElement(nextIsButton, nextButton, true);
    }
    if (!disableNext && nextDisabled) {
      disEnableElement(nextIsButton, nextButton, false);
    }
  }

  // set duration
  function resetDuration(el, str) {
    if (TRANSITIONDURATION) {
      el.style[TRANSITIONDURATION] = str;
    }
  }

  function getSliderWidth() {
    return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
  }

  function getCenterGap(num) {
    if (num == null) {
      num = index;
    }

    var gap = edgePadding ? gutter : 0;
    return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
  }

  function getRightBoundary() {
    var gap = edgePadding ? gutter : 0,
        result = viewport + gap - getSliderWidth();

    if (center && !loop) {
      result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
    }
    if (result > 0) {
      result = 0;
    }

    return result;
  }

  function getContainerTransformValue(num) {
    if (num == null) {
      num = index;
    }

    var val;
    if (horizontal && !autoWidth) {
      if (fixedWidth) {
        val = -(fixedWidth + gutter) * num;
        if (center) {
          val += getCenterGap();
        }
      } else {
        var denominator = TRANSFORM ? slideCountNew : items;
        if (center) {
          num -= getCenterGap();
        }
        val = -num * 100 / denominator;
      }
    } else {
      val = -slidePositions[num];
      if (center && autoWidth) {
        val += getCenterGap();
      }
    }

    if (hasRightDeadZone) {
      val = Math.max(val, rightBoundary);
    }

    val += horizontal && !autoWidth && !fixedWidth ? '%' : 'px';

    return val;
  }

  function doContainerTransformSilent(val) {
    resetDuration(container, '0s');
    doContainerTransform(val);
  }

  function doContainerTransform(val) {
    if (val == null) {
      val = getContainerTransformValue();
    }
    container.style[transformAttr] = transformPrefix + val + transformPostfix;
  }

  function animateSlide(number, classOut, classIn, isOut) {
    var l = number + items;
    if (!loop) {
      l = Math.min(l, slideCountNew);
    }

    for (var i = number; i < l; i++) {
      var item = slideItems[i];

      // set item positions
      if (!isOut) {
        item.style.left = (i - index) * 100 / items + '%';
      }

      if (animateDelay && TRANSITIONDELAY) {
        item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + 's';
      }
      removeClass(item, classOut);
      addClass(item, classIn);

      if (isOut) {
        slideItemsOut.push(item);
      }
    }
  }

  // make transfer after click/drag:
  // 1. change 'transform' property for mordern browsers
  // 2. change 'left' property for legacy browsers
  var transformCore = function () {
    return carousel ? function () {
      resetDuration(container, '');
      if (TRANSITIONDURATION || !speed) {
        // for morden browsers with non-zero duration or
        // zero duration for all browsers
        doContainerTransform();
        // run fallback function manually
        // when duration is 0 / container is hidden
        if (!speed || !isVisible(container)) {
          onTransitionEnd();
        }
      } else {
        // for old browser with non-zero duration
        jsTransform(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
      }

      if (!horizontal) {
        updateContentWrapperHeight();
      }
    } : function () {
      slideItemsOut = [];

      var eve = {};
      eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
      removeEvents(slideItems[indexCached], eve);
      addEvents(slideItems[index], eve);

      animateSlide(indexCached, animateIn, animateOut, true);
      animateSlide(index, animateNormal, animateIn);

      // run fallback function manually
      // when transition or animation not supported / duration is 0
      if (!TRANSITIONEND || !ANIMATIONEND || !speed || !isVisible(container)) {
        onTransitionEnd();
      }
    };
  }();

  function render(e, sliderMoved) {
    if (updateIndexBeforeTransform) {
      updateIndex();
    }

    // render when slider was moved (touch or drag) even though index may not change
    if (index !== indexCached || sliderMoved) {
      // events
      events.emit('indexChanged', info());
      events.emit('transitionStart', info());
      if (autoHeight) {
        doAutoHeight();
      }

      // pause autoplay when click or keydown from user
      if (animating && e && ['click', 'keydown'].indexOf(e.type) >= 0) {
        stopAutoplay();
      }

      running = true;
      transformCore();
    }
  }

  /*
   * Transfer prefixed properties to the same format
   * CSS: -Webkit-Transform => webkittransform
   * JS: WebkitTransform => webkittransform
   * @param {string} str - property
   *
   */
  function strTrans(str) {
    return str.toLowerCase().replace(/-/g, '');
  }

  // AFTER TRANSFORM
  // Things need to be done after a transfer:
  // 1. check index
  // 2. add classes to visible slide
  // 3. disable controls buttons when reach the first/last slide in non-loop slider
  // 4. update nav status
  // 5. lazyload images
  // 6. update container height
  function onTransitionEnd(event) {
    // check running on gallery mode
    // make sure trantionend/animationend events run only once
    if (carousel || running) {
      events.emit('transitionEnd', info(event));

      if (!carousel && slideItemsOut.length > 0) {
        for (var i = 0; i < slideItemsOut.length; i++) {
          var item = slideItemsOut[i];
          // set item positions
          item.style.left = '';

          if (ANIMATIONDELAY && TRANSITIONDELAY) {
            item.style[ANIMATIONDELAY] = '';
            item.style[TRANSITIONDELAY] = '';
          }
          removeClass(item, animateOut);
          addClass(item, animateNormal);
        }
      }

      /* update slides, nav, controls after checking ...
       * => legacy browsers who don't support 'event'
       *    have to check event first, otherwise event.target will cause an error
       * => or 'gallery' mode:
       *   + event target is slide item
       * => or 'carousel' mode:
       *   + event target is container,
       *   + event.property is the same with transform attribute
       */
      if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
        if (!updateIndexBeforeTransform) {
          var indexTem = index;
          updateIndex();
          if (index !== indexTem) {
            events.emit('indexChanged', info());

            doContainerTransformSilent();
          }
        }

        if (nested === 'inner') {
          events.emit('innerLoaded', info());
        }
        running = false;
        indexCached = index;
      }
    }
  }

  // # ACTIONS
  function goTo(targetIndex, e) {
    if (freeze) {
      return;
    }

    // prev slideBy
    if (targetIndex === 'prev') {
      onControlsClick(e, -1);

      // next slideBy
    } else if (targetIndex === 'next') {
      onControlsClick(e, 1);

      // go to exact slide
    } else {
      if (running) {
        if (preventActionWhenRunning) {
          return;
        } else {
          onTransitionEnd();
        }
      }

      var absIndex = getAbsIndex(),
          indexGap = 0;

      if (targetIndex === 'first') {
        indexGap = -absIndex;
      } else if (targetIndex === 'last') {
        indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
      } else {
        if (typeof targetIndex !== 'number') {
          targetIndex = parseInt(targetIndex);
        }

        if (!isNaN(targetIndex)) {
          // from directly called goTo function
          if (!e) {
            targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
          }

          indexGap = targetIndex - absIndex;
        }
      }

      // gallery: make sure new page won't overlap with current page
      if (!carousel && indexGap && Math.abs(indexGap) < items) {
        var factor = indexGap > 0 ? 1 : -1;
        indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
      }

      index += indexGap;

      // make sure index is in range
      if (carousel && loop) {
        if (index < indexMin) {
          index += slideCount;
        }
        if (index > indexMax) {
          index -= slideCount;
        }
      }

      // if index is changed, start rendering
      if (getAbsIndex(index) !== getAbsIndex(indexCached)) {
        render(e);
      }
    }
  }

  // on controls click
  function onControlsClick(e, dir) {
    if (running) {
      if (preventActionWhenRunning) {
        return;
      } else {
        onTransitionEnd();
      }
    }
    var passEventObject;

    if (!dir) {
      e = getEvent(e);
      var target = getTarget(e);

      while (target !== controlsContainer && [prevButton, nextButton].indexOf(target) < 0) {
        target = target.parentNode;
      }

      var targetIn = [prevButton, nextButton].indexOf(target);
      if (targetIn >= 0) {
        passEventObject = true;
        dir = targetIn === 0 ? -1 : 1;
      }
    }

    if (rewind) {
      if (index === indexMin && dir === -1) {
        goTo('last', e);
        return;
      } else if (index === indexMax && dir === 1) {
        goTo('first', e);
        return;
      }
    }

    if (dir) {
      index += slideBy * dir;
      if (autoWidth) {
        index = Math.floor(index);
      }
      // pass e when click control buttons or keydown
      render(passEventObject || e && e.type === 'keydown' ? e : null);
    }
  }

  // on nav click
  function onNavClick(e) {
    if (running) {
      if (preventActionWhenRunning) {
        return;
      } else {
        onTransitionEnd();
      }
    }

    e = getEvent(e);
    var target = getTarget(e),
        navIndex;

    // find the clicked nav item
    while (target !== navContainer && !hasAttr(target, 'data-nav')) {
      target = target.parentNode;
    }
    if (hasAttr(target, 'data-nav')) {
      var navIndex = navClicked = Number(getAttr(target, 'data-nav')),
          targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items,
          targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
      goTo(targetIndex, e);

      if (navCurrentIndex === navIndex) {
        if (animating) {
          stopAutoplay();
        }
        navClicked = -1; // reset navClicked
      }
    }
  }

  // autoplay functions
  function setAutoplayTimer() {
    autoplayTimer = setInterval(function () {
      onControlsClick(null, autoplayDirection);
    }, autoplayTimeout);

    animating = true;
  }

  function stopAutoplayTimer() {
    clearInterval(autoplayTimer);
    animating = false;
  }

  function updateAutoplayButton(action, txt) {
    setAttrs(autoplayButton, { 'data-action': action });
    autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
  }

  function startAutoplay() {
    setAutoplayTimer();
    if (autoplayButton) {
      updateAutoplayButton('stop', autoplayText[1]);
    }
  }

  function stopAutoplay() {
    stopAutoplayTimer();
    if (autoplayButton) {
      updateAutoplayButton('start', autoplayText[0]);
    }
  }

  // programaitcally play/pause the slider
  function play() {
    if (autoplay && !animating) {
      startAutoplay();
      autoplayUserPaused = false;
    }
  }
  function pause() {
    if (animating) {
      stopAutoplay();
      autoplayUserPaused = true;
    }
  }

  function toggleAutoplay() {
    if (animating) {
      stopAutoplay();
      autoplayUserPaused = true;
    } else {
      startAutoplay();
      autoplayUserPaused = false;
    }
  }

  function onVisibilityChange() {
    if (doc.hidden) {
      if (animating) {
        stopAutoplayTimer();
        autoplayVisibilityPaused = true;
      }
    } else if (autoplayVisibilityPaused) {
      setAutoplayTimer();
      autoplayVisibilityPaused = false;
    }
  }

  function mouseoverPause() {
    if (animating) {
      stopAutoplayTimer();
      autoplayHoverPaused = true;
    }
  }

  function mouseoutRestart() {
    if (autoplayHoverPaused) {
      setAutoplayTimer();
      autoplayHoverPaused = false;
    }
  }

  // keydown events on document
  function onDocumentKeydown(e) {
    e = getEvent(e);
    var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);

    if (keyIndex >= 0) {
      onControlsClick(e, keyIndex === 0 ? -1 : 1);
    }
  }

  // on key control
  function onControlsKeydown(e) {
    e = getEvent(e);
    var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);

    if (keyIndex >= 0) {
      if (keyIndex === 0) {
        if (!prevButton.disabled) {
          onControlsClick(e, -1);
        }
      } else if (!nextButton.disabled) {
        onControlsClick(e, 1);
      }
    }
  }

  // set focus
  function setFocus(el) {
    el.focus();
  }

  // on key nav
  function onNavKeydown(e) {
    e = getEvent(e);
    var curElement = doc.activeElement;
    if (!hasAttr(curElement, 'data-nav')) {
      return;
    }

    // var code = e.keyCode,
    var keyIndex = [KEYS.LEFT, KEYS.RIGHT, KEYS.ENTER, KEYS.SPACE].indexOf(e.keyCode),
        navIndex = Number(getAttr(curElement, 'data-nav'));

    if (keyIndex >= 0) {
      if (keyIndex === 0) {
        if (navIndex > 0) {
          setFocus(navItems[navIndex - 1]);
        }
      } else if (keyIndex === 1) {
        if (navIndex < pages - 1) {
          setFocus(navItems[navIndex + 1]);
        }
      } else {
        navClicked = navIndex;
        goTo(navIndex, e);
      }
    }
  }

  function getEvent(e) {
    e = e || win.event;
    return isTouchEvent(e) ? e.changedTouches[0] : e;
  }
  function getTarget(e) {
    return e.target || win.event.srcElement;
  }

  function isTouchEvent(e) {
    return e.type.indexOf('touch') >= 0;
  }

  function preventDefaultBehavior(e) {
    e.preventDefault ? e.preventDefault() : e.returnValue = false;
  }

  function getMoveDirectionExpected() {
    return getTouchDirection(toDegree(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
  }

  function onPanStart(e) {
    if (running) {
      if (preventActionWhenRunning) {
        return;
      } else {
        onTransitionEnd();
      }
    }

    if (autoplay && animating) {
      stopAutoplayTimer();
    }

    panStart = true;
    if (rafIndex) {
      caf(rafIndex);
      rafIndex = null;
    }

    var $ = getEvent(e);
    events.emit(isTouchEvent(e) ? 'touchStart' : 'dragStart', info(e));

    if (!isTouchEvent(e) && ['img', 'a'].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) {
      preventDefaultBehavior(e);
    }

    lastPosition.x = initPosition.x = $.clientX;
    lastPosition.y = initPosition.y = $.clientY;
    if (carousel) {
      translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ''));
      resetDuration(container, '0s');
    }
  }

  function onPanMove(e) {
    if (panStart) {
      var $ = getEvent(e);
      lastPosition.x = $.clientX;
      lastPosition.y = $.clientY;

      if (carousel) {
        if (!rafIndex) {
          rafIndex = raf(function () {
            panUpdate(e);
          });
        }
      } else {
        if (moveDirectionExpected === '?') {
          moveDirectionExpected = getMoveDirectionExpected();
        }
        if (moveDirectionExpected) {
          preventScroll = true;
        }
      }

      if (preventScroll) {
        e.preventDefault();
      }
    }
  }

  function panUpdate(e) {
    if (!moveDirectionExpected) {
      panStart = false;
      return;
    }
    caf(rafIndex);
    if (panStart) {
      rafIndex = raf(function () {
        panUpdate(e);
      });
    }

    if (moveDirectionExpected === '?') {
      moveDirectionExpected = getMoveDirectionExpected();
    }
    if (moveDirectionExpected) {
      if (!preventScroll && isTouchEvent(e)) {
        preventScroll = true;
      }

      try {
        if (e.type) {
          events.emit(isTouchEvent(e) ? 'touchMove' : 'dragMove', info(e));
        }
      } catch (err) {}

      var x = translateInit,
          dist = getDist(lastPosition, initPosition);
      if (!horizontal || fixedWidth || autoWidth) {
        x += dist;
        x += 'px';
      } else {
        var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
        x += percentageX;
        x += '%';
      }

      container.style[transformAttr] = transformPrefix + x + transformPostfix;
    }
  }

  function onPanEnd(e) {
    if (panStart) {
      if (rafIndex) {
        caf(rafIndex);
        rafIndex = null;
      }
      if (carousel) {
        resetDuration(container, '');
      }
      panStart = false;

      var $ = getEvent(e);
      lastPosition.x = $.clientX;
      lastPosition.y = $.clientY;
      var dist = getDist(lastPosition, initPosition);

      if (Math.abs(dist)) {
        // drag vs click
        if (!isTouchEvent(e)) {
          // prevent "click"
          var target = getTarget(e);
          addEvents(target, { 'click': function preventClick(e) {
              preventDefaultBehavior(e);
              removeEvents(target, { 'click': preventClick });
            } });
        }

        if (carousel) {
          rafIndex = raf(function () {
            if (horizontal && !autoWidth) {
              var indexMoved = -dist * items / (viewport + gutter);
              indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
              index += indexMoved;
            } else {
              var moved = -(translateInit + dist);
              if (moved <= 0) {
                index = indexMin;
              } else if (moved >= slidePositions[slideCountNew - 1]) {
                index = indexMax;
              } else {
                var i = 0;
                while (i < slideCountNew && moved >= slidePositions[i]) {
                  index = i;
                  if (moved > slidePositions[i] && dist < 0) {
                    index += 1;
                  }
                  i++;
                }
              }
            }

            render(e, dist);
            events.emit(isTouchEvent(e) ? 'touchEnd' : 'dragEnd', info(e));
          });
        } else {
          if (moveDirectionExpected) {
            onControlsClick(e, dist > 0 ? -1 : 1);
          }
        }
      }
    }

    // reset
    if (options.preventScrollOnTouch === 'auto') {
      preventScroll = false;
    }
    if (swipeAngle) {
      moveDirectionExpected = '?';
    }
    if (autoplay && !animating) {
      setAutoplayTimer();
    }
  }

  // === RESIZE FUNCTIONS === //
  // (slidePositions, index, items) => vertical_conentWrapper.height
  function updateContentWrapperHeight() {
    var wp = middleWrapper || innerWrapper;
    wp.style.height = slidePositions[index + items] - slidePositions[index] + 'px';
  }

  function getPages() {
    var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
    return Math.min(Math.ceil(rough), slideCount);
  }

  /*
   * 1. update visible nav items list
   * 2. add "hidden" attributes to previous visible nav items
   * 3. remove "hidden" attrubutes to new visible nav items
   */
  function updateNavVisibility() {
    if (!nav || navAsThumbnails) {
      return;
    }

    if (pages !== pagesCached) {
      var min = pagesCached,
          max = pages,
          fn = showElement;

      if (pagesCached > pages) {
        min = pages;
        max = pagesCached;
        fn = hideElement;
      }

      while (min < max) {
        fn(navItems[min]);
        min++;
      }

      // cache pages
      pagesCached = pages;
    }
  }

  function info(e) {
    return {
      container: container,
      slideItems: slideItems,
      navContainer: navContainer,
      navItems: navItems,
      controlsContainer: controlsContainer,
      hasControls: hasControls,
      prevButton: prevButton,
      nextButton: nextButton,
      items: items,
      slideBy: slideBy,
      cloneCount: cloneCount,
      slideCount: slideCount,
      slideCountNew: slideCountNew,
      index: index,
      indexCached: indexCached,
      displayIndex: getCurrentSlide(),
      navCurrentIndex: navCurrentIndex,
      navCurrentIndexCached: navCurrentIndexCached,
      pages: pages,
      pagesCached: pagesCached,
      sheet: sheet,
      isOn: isOn,
      event: e || {}
    };
  }

  return {
    version: '2.9.2',
    getInfo: info,
    events: events,
    goTo: goTo,
    play: play,
    pause: pause,
    isOn: isOn,
    updateSliderHeight: updateInnerWrapperHeight,
    refresh: initSliderTransform,
    destroy: destroy,
    rebuild: function rebuild() {
      return tns(extend(options, optionsElements));
    }
  };
};
// CONCATENATED MODULE: ./app/assets/javascripts/components/tinySlider/index.js
var tinySlider__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tinySlider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var tinySlider_TinySlider = function () {
  function TinySlider() {
    tinySlider__classCallCheck(this, TinySlider);

    this._setup();
  }

  tinySlider__createClass(TinySlider, [{
    key: '_setup',
    value: function _setup() {
      var slider = tiny_slider_tns({
        container: '#tiny-slider',
        mouseDrag: true,
        swipeAngle: false,
        gutter: 10,
        speed: 400,
        loop: true,
        autoplay: true,
        controlsPosition: "bottom",
        navPosition: "bottom",
        autoplayButtonOutput: false,
        controlsText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
        edgePadding: 50,
        responsive: {
          548: {
            items: 1,
            slideBy: 1
          },
          768: {
            items: 2,
            slideBy: 2
          },
          1024: {
            items: 4,
            slideBy: 4
          }
        }
      });

      jquery_default()('#tiny-slider').show();
    }
  }]);

  return TinySlider;
}();

/* harmony default export */ var tinySlider = (tinySlider_TinySlider);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/tinySlider.js


if (document.querySelector('#tiny-slider')) {
  new tinySlider();
}
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/index.js



















// EXTERNAL MODULE: ./app/assets/javascripts/utils/window.js
var utils_window = __webpack_require__(37);

// EXTERNAL MODULE: ./app/assets/javascripts/components/locationSearch/events.js
var locationSearch_events = __webpack_require__(49);

// CONCATENATED MODULE: ./app/assets/javascripts/utils/queryString.js
/**
 * Convert an object to queryString
 * */
function toQueryString(params) {
  return Object.keys(params).map(function (key) {
    return key + '=' + params[key];
  }).join('&');
}
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/photographerFilterForm/index.js
var photographerFilterForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function photographerFilterForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var photographerFilterForm_SELECTOR = {
  headerCategorySelect: '#headerCategorySelect',
  asideCategorySelect: '#asideCategorySelect',
  headerCalendar: '#headerCalendar',
  asideCalendar: '#asideCalendar',
  locationFilter: '.form-photographer-filter__group--location .location-search__input',
  priceFilter: '.form-photographer-filter__slider',
  toggleFilterButton: '.form-photographer-filter__btn-toggle-advanced-filter',
  advancedFilter: '.form-photographer-filter__advanced-filter',
  sliderContainer: '.slider__container',
  bookingType: '.form-photographer-filter__booking-type',
  buttonBookingType: '.form-photographer-filter__btn-booking-type',
  locationPlaceIdInput: '.form-photographer-filter__location-place-id-input'
};

var CLASS_NAME = {
  advancedFilterExpanded: 'form-photographer-filter__advanced-filter--expanded'
};

var photographerFilterForm_PhotographerFilterForm = function () {
  function PhotographerFilterForm(elementRef) {
    photographerFilterForm__classCallCheck(this, PhotographerFilterForm);

    // Initialise attributes
    this.elementRef = elementRef;
    this.toggleFilterButton = elementRef.querySelector(photographerFilterForm_SELECTOR['toggleFilterButton']);
    this.advancedFilter = elementRef.querySelector(photographerFilterForm_SELECTOR['advancedFilter']);

    // Bind functions
    this.changeHandler = this.changeHandler.bind(this);
    this.categoryChangeHandler = this.categoryChangeHandler.bind(this);
    this.dateChangeHandler = this.dateChangeHandler.bind(this);
    this.toggleFilterButtonClickHandler = this.toggleFilterButtonClickHandler.bind(this);
    this.changeBookingTypeHandler = this.changeBookingTypeHandler.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler triggered when the form elements are changed.
   *
   * @param {Event} _event - click event.
   * */


  photographerFilterForm__createClass(PhotographerFilterForm, [{
    key: 'changeHandler',
    value: function changeHandler(_event) {
      this._submitForm();
    }

    /**
     * Event handler triggered when category select elements are changed.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'categoryChangeHandler',
    value: function categoryChangeHandler(event) {
      document.querySelector(photographerFilterForm_SELECTOR['headerCategorySelect']).value = event.target.value;
      document.querySelector(photographerFilterForm_SELECTOR['asideCategorySelect']).value = event.target.value;
    }

    /**
     * Event handler triggered when calendar elements are changed.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'dateChangeHandler',
    value: function dateChangeHandler(event) {
      document.querySelector(photographerFilterForm_SELECTOR['headerCalendar']).value = event.target.value;
      document.querySelector(photographerFilterForm_SELECTOR['asideCalendar']).value = event.target.value;
    }

    /**
     * Event handler triggered when toggleFilterButton is clicked.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'toggleFilterButtonClickHandler',
    value: function toggleFilterButtonClickHandler(event) {
      this.advancedFilter.classList.toggle(CLASS_NAME['advancedFilterExpanded']);
    }

    /**
     * Event handler triggered when the button to switch booking type is clicked.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'changeBookingTypeHandler',
    value: function changeBookingTypeHandler(event) {
      event.preventDefault();

      var bookingType = event.currentTarget.dataset['bookingType'];
      var redirectPath = bookingType === 'instant' ? '/photographers/now' : '/photographers';
      var formData = this._serialiseLocationForm();
      var queryString = toQueryString(formData);

      Object(utils_window["a" /* redirectTo */])('' + window.location.origin + redirectPath + '?' + queryString);
    }

    // Private Methods

    /**
     * Serialises the form values into request params.
     * */

  }, {
    key: '_serialiseForm',
    value: function _serialiseForm() {
      var priceFilterValue = this._priceFilterValue();

      return {
        'filter[location]': document.querySelector(photographerFilterForm_SELECTOR['locationFilter']).value,
        'filter[category_id]': document.querySelector(photographerFilterForm_SELECTOR['asideCategorySelect']).value,
        'filter[date]': document.querySelector(photographerFilterForm_SELECTOR['asideCalendar']).value,
        'filter[price][min]': priceFilterValue[0],
        'filter[price][max]': priceFilterValue[1],
        'filter[location_place_id]': document.querySelector(photographerFilterForm_SELECTOR['locationPlaceIdInput']).value
      };
    }

    /**
     * Serialises the only the location-related form values into request params.
     * */

  }, {
    key: '_serialiseLocationForm',
    value: function _serialiseLocationForm() {
      return {
        'filter[location]': document.querySelector(photographerFilterForm_SELECTOR['locationFilter']).value
      };
    }

    /**
     * Serialize form values and redirects to the search results page
     * */

  }, {
    key: '_submitForm',
    value: function _submitForm() {
      var formData = this._serialiseForm();
      var queryString = toQueryString(formData);
      Object(utils_window["a" /* redirectTo */])('' + window.location.origin + window.location.pathname + '?' + queryString);
    }

    /**
     * Reads the price range from the slider filter
     * */

  }, {
    key: '_priceFilterValue',
    value: function _priceFilterValue() {
      var sliderElement = document.querySelector(photographerFilterForm_SELECTOR['sliderContainer']);

      if (sliderElement.getAttribute('disabled') === 'true') {
        return '';
      }

      var priceRange = sliderElement.noUiSlider.get();

      return priceRange.map(function (price) {
        return parseInt(price);
      });
    }

    /**
     * Adds scroll event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var headerCategorySelect = document.querySelector(photographerFilterForm_SELECTOR['headerCategorySelect']);
      var asideCategorySelect = document.querySelector(photographerFilterForm_SELECTOR['asideCategorySelect']);
      var headerCalendar = document.querySelector(photographerFilterForm_SELECTOR['headerCalendar']);
      var asideCalendar = document.querySelector(photographerFilterForm_SELECTOR['asideCalendar']);
      var priceFilter = document.querySelector(photographerFilterForm_SELECTOR['priceFilter']);
      var buttonBookingType = document.querySelector(photographerFilterForm_SELECTOR['buttonBookingType']);
      var locationFilter = document.querySelector(photographerFilterForm_SELECTOR['locationFilter']);
      // As there are two category select elements, symlink their values
      headerCategorySelect && headerCategorySelect.addEventListener('change', this.categoryChangeHandler);
      asideCategorySelect && asideCategorySelect.addEventListener('change', this.categoryChangeHandler);

      // As there are two date select elements, symlink their values
      headerCalendar && headerCalendar.addEventListener('change', this.dateChangeHandler);
      asideCalendar && asideCalendar.addEventListener('change', this.dateChangeHandler);

      // Change Handlers
      headerCategorySelect && headerCategorySelect.addEventListener('change', this.changeHandler);
      asideCategorySelect && asideCategorySelect.addEventListener('change', this.changeHandler);
      headerCalendar && headerCalendar.addEventListener('change', this.changeHandler);
      asideCalendar && asideCalendar.addEventListener('change', this.changeHandler);
      priceFilter && priceFilter.addEventListener('change', this.changeHandler);
      locationFilter && locationFilter.addEventListener(locationSearch_events["f" /* LOCATION_SEARCH_SELECT_LOCATION_SUCCESS */], this.changeHandler);

      // Click Handlers
      buttonBookingType && buttonBookingType.addEventListener('click', this.changeBookingTypeHandler);

      this.toggleFilterButton && this.toggleFilterButton.addEventListener('click', this.toggleFilterButtonClickHandler);
    }
  }]);

  return PhotographerFilterForm;
}();

/* harmony default export */ var photographerFilterForm = (photographerFilterForm_PhotographerFilterForm);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/AdvanceBookingPhotographer.js
var AdvanceBookingPhotographer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AdvanceBookingPhotographer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var AdvanceBookingPhotographer_SELECTOR = {
  headerCategorySelect: '#headerCategorySelect',
  asideCategorySelect: '#asideCategorySelect',
  filterForm: 'aside .form-photographer-filter'
};

var AdvanceBookingPhotographer_AdvanceBookingPhotographerScreen = function () {
  function AdvanceBookingPhotographerScreen() {
    AdvanceBookingPhotographer__classCallCheck(this, AdvanceBookingPhotographerScreen);

    this._setup();
  }

  // Private Methods

  AdvanceBookingPhotographer__createClass(AdvanceBookingPhotographerScreen, [{
    key: '_setup',
    value: function _setup() {
      new components_selectInput["b" /* default */](document.querySelector(AdvanceBookingPhotographer_SELECTOR['headerCategorySelect']), {
        addPopper: false
      });
      new components_selectInput["b" /* default */](document.querySelector(AdvanceBookingPhotographer_SELECTOR['asideCategorySelect']));

      new photographerFilterForm(document.querySelector(AdvanceBookingPhotographer_SELECTOR['filterForm']));
    }
  }]);

  return AdvanceBookingPhotographerScreen;
}();

// Setup the AdvanceBookingPhotographerScreen class, only on the photographers page.


var isAdvanceBookingPhotographerPage = document.body.classList.contains('advance-booking-photographers') && document.body.classList.contains('index');

if (isAdvanceBookingPhotographerPage) {
  new AdvanceBookingPhotographer_AdvanceBookingPhotographerScreen();
}
// EXTERNAL MODULE: ./app/assets/javascripts/components/paymentForm/index.js + 3 modules
var paymentForm = __webpack_require__(128);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/CheckoutPayment.js
var CheckoutPayment__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CheckoutPayment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var CheckoutPayment_SELECTOR = {
  paymentForm: '.form-payment'
};

var CheckoutPayment_CheckoutPaymentScreen = function () {
  function CheckoutPaymentScreen() {
    CheckoutPayment__classCallCheck(this, CheckoutPaymentScreen);

    this._setup();
  }

  // Private Methods

  CheckoutPayment__createClass(CheckoutPaymentScreen, [{
    key: '_setup',
    value: function _setup() {
      document.querySelectorAll(CheckoutPayment_SELECTOR['paymentForm']).forEach(function (element) {
        new paymentForm["a" /* default */](element);
      });
    }
  }]);

  return CheckoutPaymentScreen;
}();

// Setup the CheckoutPaymentScreen class, only on the payments page.


var isCheckoutPaymentPage = document.body.classList.contains('checkout') && document.body.classList.contains('payments');

if (isCheckoutPaymentPage) {
  new CheckoutPayment_CheckoutPaymentScreen();
}
// CONCATENATED MODULE: ./app/assets/javascripts/utils/browser.js
/**
 * Checks whether a web browser is the Samsung Internet Browser.
 *
 * @returns {boolean}
 */
function isSamsungBrowser() {
  return navigator.userAgent.includes('SamsungBrowser');
}
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/bookingForm/index.js
var bookingForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function bookingForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var bookingForm_SELECTOR = {
  searchButton: '.modal-booking .form-booking__btn--results',
  categorySelect: '.form-booking__group--category select',
  locationInput: '.form-booking__location',
  locationPlaceIdInput: '.form-booking__location-place-id-input',
  dateInput: '.flatpickr-input'
};

var bookingForm_BookingForm = function () {
  function BookingForm() {
    bookingForm__classCallCheck(this, BookingForm);

    this.clickHandler = this.clickHandler.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler when the form is submitted
   *
   * @param {Event} event - click event.
   * */


  bookingForm__createClass(BookingForm, [{
    key: 'clickHandler',
    value: function clickHandler(event) {
      event.preventDefault();
      var serializedFormParams = this._serialiseForm();
      var queryString = toQueryString(serializedFormParams);

      window.location.href = window.location.origin + '/photographers?' + queryString;
    }

    // Private Methods

    /**
     * Serialises the form values into request params.
     * */

  }, {
    key: '_serialiseForm',
    value: function _serialiseForm() {
      return {
        'filter[category_id]': document.querySelector(bookingForm_SELECTOR['categorySelect']).value,
        'filter[date]': document.querySelector(bookingForm_SELECTOR['dateInput']).value,
        'filter[location]': document.querySelector(bookingForm_SELECTOR['locationInput']).value,
        'filter[location_place_id]': document.querySelector(bookingForm_SELECTOR['locationPlaceIdInput']).value
      };
    }

    /**
     * Adds event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      document.querySelector(bookingForm_SELECTOR['searchButton']).addEventListener('click', this.clickHandler);
    }
  }]);

  return BookingForm;
}();

/* harmony default export */ var bookingForm = (bookingForm_BookingForm);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/Home.js
var Home__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Home__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var Home_SELECTOR = {
  hero: '.hero',
  advanceBookingButton: '.form-booking .form-booking__btn--later',
  categorySelect: '#photographer_category_select',
  introductionBookButton: '.introduction .btn--primary',
  navigationMenuLinks: '.navbar__link'
};

var CATEGORY_SELECT_OPTION = {
  isSearchable: false
};

var Home_HomeScreen = function () {
  function HomeScreen() {
    Home__classCallCheck(this, HomeScreen);

    this.advanceBookingButton = document.querySelector(Home_SELECTOR['advanceBookingButton']);
    this.introductionBookButton = document.querySelector(Home_SELECTOR['introductionBookButton']);
    this.navLinks = document.querySelectorAll(Home_SELECTOR['navigationMenuLinks']);

    // Bind Function
    this._clickBookButtonHandler = this._clickBookButtonHandler.bind(this);

    this._setup();
    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Trigger the booking form modal from the introduction section
   *
   * @param {Event} event - click event
   * */


  Home__createClass(HomeScreen, [{
    key: '_clickBookButtonHandler',
    value: function _clickBookButtonHandler(event) {
      event.preventDefault();

      this.advanceBookingButton.click();
    }

    /**
     * Scroll handler of navLinks.
     *  Finds the closest link clicked.
     *    1) If the href is a hash url, enables smooth scroll.
     *    2) Else allows the default browser action.
     *
     * @param {Event} event - scroll event on navLinks
     * */

  }, {
    key: '_scrollHandler',
    value: function _scrollHandler(event) {
      var closestLink = event.target.closest('a');
      var targetHref = closestLink.hash;

      if (closestLink.pathname !== window.location.pathname || targetHref.indexOf('#') === -1) {
        return;
      }

      event.preventDefault();

      var scrollToEl = document.querySelector(targetHref);

      var appHeader = document.querySelector('.app-header');
      var appHeaderHeight = appHeader.getBoundingClientRect().height;

      // compensate for the header height, as its fixed at top
      var verticalScroll = scrollToEl.getBoundingClientRect().y - appHeaderHeight;

      // Enable Smooth scroll
      window.scrollBy({
        top: verticalScroll,
        left: 0,
        behavior: 'smooth'
      });
    }

    // Private Methods

  }, {
    key: '_setup',
    value: function _setup() {
      new bookingForm();
      new components_selectInput["b" /* default */](document.querySelector(Home_SELECTOR['categorySelect']), CATEGORY_SELECT_OPTION);

      isSamsungBrowser() && this._fixBrowserHeightResize();
    }

    /**
     * Binds event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this = this;

      this.navLinks.forEach(function (navLink) {
        return navLink.addEventListener('click', _this._scrollHandler);
      });

      this.introductionBookButton.addEventListener('click', this._clickBookButtonHandler);
    }

    /**
     * Change the height of the hero to avoid resize issue on scroll
     *
     * See issue: https://www.pivotaltracker.com/story/show/160337836
     * */

  }, {
    key: '_fixBrowserHeightResize',
    value: function _fixBrowserHeightResize() {
      var heroElement = document.querySelector(Home_SELECTOR['hero']);

      heroElement.style.height = document.documentElement.clientHeight - 54 + 'px';
    }
  }]);

  return HomeScreen;
}();

// Setup the HomeScreen class, only on landing page.


var isHomePage = document.body.classList.contains('home') && document.body.classList.contains('index');

if (isHomePage) {
  new Home_HomeScreen();
}
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/instantBookingPhotographerFilterForm/index.js
var instantBookingPhotographerFilterForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function instantBookingPhotographerFilterForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var instantBookingPhotographerFilterForm_SELECTOR = {
  headerLocationFilter: '.form-photographer-filter--header .location-search__input',
  headerGeoLocationFilter: '.form-photographer-filter--header__input-geolocation',
  locationFilter: '.location-search__input',
  locationFilterInputField: '.location-search-input',
  geoLocationFilter: '.form-photographer-filter__input-geolocation',
  distanceSlider: '.slider',
  minDistanceFilter: '.form-photographer-filter__input-distance-min',
  maxDistanceFilter: '.form-photographer-filter__input-distance-max'
};

var instantBookingPhotographerFilterForm_InstantBookingPhotographerFilterForm = function () {
  function InstantBookingPhotographerFilterForm(elementRef) {
    instantBookingPhotographerFilterForm__classCallCheck(this, InstantBookingPhotographerFilterForm);

    // Initialise attributes
    this.elementRef = elementRef;
    this.locationFilter = this.elementRef.querySelector(instantBookingPhotographerFilterForm_SELECTOR['locationFilter']);
    this.geoLocationFilter = this.elementRef.querySelector(instantBookingPhotographerFilterForm_SELECTOR['geoLocationFilter']);
    this.locationFilterInputField = this.elementRef.querySelector(instantBookingPhotographerFilterForm_SELECTOR['locationFilterInputField']);
    this.headerLocationFilter = document.querySelector(instantBookingPhotographerFilterForm_SELECTOR['headerLocationFilter']);
    this.headerGeoLocationFilter = document.querySelector(instantBookingPhotographerFilterForm_SELECTOR['headerGeoLocationFilter']);
    this.distanceSliders = document.querySelectorAll(instantBookingPhotographerFilterForm_SELECTOR['distanceSlider']);
    this.minDistanceFilter = this.elementRef.querySelector(instantBookingPhotographerFilterForm_SELECTOR['minDistanceFilter']);
    this.maxDistanceFilter = this.elementRef.querySelector(instantBookingPhotographerFilterForm_SELECTOR['maxDistanceFilter']);

    this.changeHandler = this.changeHandler.bind(this);
    this.headerLocationChangeHandler = this.headerLocationChangeHandler.bind(this);
    this.distanceSliderChangeHandler = this.distanceSliderChangeHandler.bind(this);

    this._addEventListeners();
  }

  instantBookingPhotographerFilterForm__createClass(InstantBookingPhotographerFilterForm, [{
    key: 'changeHandler',
    value: function changeHandler() {
      this.elementRef.submit();
    }
  }, {
    key: 'headerLocationChangeHandler',
    value: function headerLocationChangeHandler() {
      this.locationFilterInputField.value = this.headerLocationFilter.value;
      this.geoLocationFilter.value = this.headerGeoLocationFilter.value;

      this.elementRef.submit();
    }
  }, {
    key: 'distanceSliderChangeHandler',
    value: function distanceSliderChangeHandler(event) {
      var distanceRange = event.target.querySelector('.slider__container').noUiSlider.get();

      this.minDistanceFilter.value = distanceRange[0];
      this.maxDistanceFilter.value = distanceRange[1];

      this.elementRef.submit();
    }
  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this = this;

      this.locationFilter.addEventListener(locationSearch_events["d" /* LOCATION_SEARCH_SELECT_LOCATION_COMPLETE */], this.changeHandler);
      this.headerLocationFilter.addEventListener(locationSearch_events["d" /* LOCATION_SEARCH_SELECT_LOCATION_COMPLETE */], this.headerLocationChangeHandler);
      this.distanceSliders.forEach(function (distanceSlider) {
        distanceSlider.addEventListener('change', _this.distanceSliderChangeHandler);
      });
    }
  }]);

  return InstantBookingPhotographerFilterForm;
}();

/* harmony default export */ var instantBookingPhotographerFilterForm = (instantBookingPhotographerFilterForm_InstantBookingPhotographerFilterForm);
// EXTERNAL MODULE: ./app/assets/javascripts/lib/browserGeolocationManager.js
var lib_browserGeolocationManager = __webpack_require__(129);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/userRequestLocation/events.js
var USER_REQUEST_LOCATION_IS_FETCHING_GEOLOCATION = 'USER_REQUEST_LOCATION_IS_FETCHING_GEOLOCATION';
var USER_REQUEST_LOCATION_FETCH_GEOLOCATION_SUCCESS = 'USER_REQUEST_LOCATION_FETCH_GEOLOCATION_SUCCESS';
var USER_REQUEST_LOCATION_FETCH_GEOLOCATION_FAILURE = 'USER_REQUEST_LOCATION_FETCH_GEOLOCATION_FAILURE';
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/userRequestLocation/index.js
var userRequestLocation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function userRequestLocation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var userRequestLocation_CLASS_NAME = {
  fetchingLocation: 'user-request-location--fetching',
  locationFetchFailure: 'user-request-location--error'
};

var userRequestLocation_UserRequestLocation = function () {
  function UserRequestLocation(elementRef) {
    userRequestLocation__classCallCheck(this, UserRequestLocation);

    // Initialise attributes
    this.elementRef = elementRef;
    this.location = elementRef.dataset['location'];

    this.locationForm = elementRef.querySelector('.form-location');

    // Bind functions
    this.onGeolocationFetchStart = this.onGeolocationFetchStart.bind(this);
    this.onGeolocationFetchSuccess = this.onGeolocationFetchSuccess.bind(this);
    this.onGeolocationFetchFailure = this.onGeolocationFetchFailure.bind(this);

    this.onSelectLocationHandler = this.onSelectLocationHandler.bind(this);

    this._addEventListeners();

    // Fetch the user location on mount
    this._retrieveGeolocation();
  }

  // Event Handlers

  /**
   * Event handler when requesting a browser geolocation
   *
   * @param {Event} event - geolocation request start event.
   * */


  userRequestLocation__createClass(UserRequestLocation, [{
    key: 'onGeolocationFetchStart',
    value: function onGeolocationFetchStart(event) {
      this._showSpinner();
    }

    /**
     * Event handler when the browser geolocation has been fetched successfully
     *
     * @param {Event} event - geolocation fetch success event.
     * */

  }, {
    key: 'onGeolocationFetchSuccess',
    value: function onGeolocationFetchSuccess(event) {
      if (!event.detail && !event.detail.geolocation && !event.detail.location) {
        return;
      }

      this._reloadPageWith(event.detail.location, event.detail.geolocation);
    }

    /**
     * Event handler when the browser geolocation has NOT been fetched successfully
     *
     * @param {Event} _event - geolocation fetch failure event.
     * */

  }, {
    key: 'onGeolocationFetchFailure',
    value: function onGeolocationFetchFailure(_event) {
      this._hideSpinner();
      this._showFallbackForm();
    }

    /**
     * Event handler when the user successfully select a location manually.
     *
     * @param {Event} event - custom event triggered by locationSearch.
     * */

  }, {
    key: 'onSelectLocationHandler',
    value: function onSelectLocationHandler(event) {
      event.stopPropagation();

      this.locationForm.submit();
    }

    // Private

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.elementRef.addEventListener(USER_REQUEST_LOCATION_IS_FETCHING_GEOLOCATION, this.onGeolocationFetchStart);
      this.elementRef.addEventListener(USER_REQUEST_LOCATION_FETCH_GEOLOCATION_SUCCESS, this.onGeolocationFetchSuccess);
      this.elementRef.addEventListener(USER_REQUEST_LOCATION_FETCH_GEOLOCATION_FAILURE, this.onGeolocationFetchFailure);

      this.locationForm && this.locationForm.addEventListener(locationSearch_events["d" /* LOCATION_SEARCH_SELECT_LOCATION_COMPLETE */], this.onSelectLocationHandler);
    }

    /**
     * Retrieve the user geolocation via the browser geolocation API
     * */

  }, {
    key: '_retrieveGeolocation',
    value: function _retrieveGeolocation() {
      var _this = this;

      var fetchLocationEvent = new CustomEvent(USER_REQUEST_LOCATION_IS_FETCHING_GEOLOCATION);
      this.elementRef.dispatchEvent(fetchLocationEvent);

      var browserGeolocationManager = new lib_browserGeolocationManager["a" /* default */]();
      browserGeolocationManager.getCurrentPosition(function (position) {
        return _this._locationFetchSuccessHandler(position);
      }, function (error) {
        return _this._locationFetchErrorHandler(error);
      });
    }

    /**
     * When `geolocation` is fetched successfully
     *
     * @param {Object} [position] - the geolocation position
     * */

  }, {
    key: '_locationFetchSuccessHandler',
    value: function _locationFetchSuccessHandler(position) {
      var _this2 = this;

      var _position$coords = position.coords,
          latitude = _position$coords.latitude,
          longitude = _position$coords.longitude;

      var geocoder = new google.maps.Geocoder();
      var latlng = { lat: latitude, lng: longitude };

      geocoder.geocode({ 'location': latlng }, function (results, stats) {
        var fetchLocationSuccessEvent = new CustomEvent(USER_REQUEST_LOCATION_FETCH_GEOLOCATION_SUCCESS, {
          detail: {
            geolocation: '(' + latitude + ', ' + longitude + ')',
            location: results[0]['formatted_address']
          }
        });
        _this2.elementRef.dispatchEvent(fetchLocationSuccessEvent);
      });
    }

    /**
     * When `geolocation` is NOT fetched successfully
     *
     * @param {Object} [_error] - the geolocation error
     * */

  }, {
    key: '_locationFetchErrorHandler',
    value: function _locationFetchErrorHandler(_error) {
      var fetchLocationFailureEvent = new CustomEvent(USER_REQUEST_LOCATION_FETCH_GEOLOCATION_FAILURE);
      this.elementRef.dispatchEvent(fetchLocationFailureEvent);
    }

    /**
     * Append the geolocation filter to the page params
     *
     * @param {String} [geolocation] - a geolocation string e.g. (10, 20)
     * */

  }, {
    key: '_reloadPageWith',
    value: function _reloadPageWith(location, geolocation) {
      var filterParams = {
        'filter[instant_location]': location,
        'filter[instant_geolocation]': geolocation
      };
      var queryString = new URLSearchParams(filterParams).toString();

      Object(utils_window["a" /* redirectTo */])('' + window.location.origin + window.location.pathname + '?' + queryString);
    }
  }, {
    key: '_showSpinner',
    value: function _showSpinner() {
      this.elementRef.classList.add(userRequestLocation_CLASS_NAME['fetchingLocation']);
    }
  }, {
    key: '_hideSpinner',
    value: function _hideSpinner() {
      this.elementRef.classList.remove(userRequestLocation_CLASS_NAME['fetchingLocation']);
    }
  }, {
    key: '_showFallbackForm',
    value: function _showFallbackForm() {
      this.elementRef.classList.add(userRequestLocation_CLASS_NAME['locationFetchFailure']);
    }
  }]);

  return UserRequestLocation;
}();

/* harmony default export */ var components_userRequestLocation = (userRequestLocation_UserRequestLocation);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/InstantBookingPhotographer.js
var InstantBookingPhotographer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function InstantBookingPhotographer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var InstantBookingPhotographer_SELECTOR = {
  filterForm: 'aside .form-photographer-filter',
  userRequestLocation: '.user-request-location'
};

var InstantBookingPhotographer_InstantBookingPhotographerScreen = function () {
  function InstantBookingPhotographerScreen() {
    InstantBookingPhotographer__classCallCheck(this, InstantBookingPhotographerScreen);

    this._setup();
  }

  // Private Methods

  InstantBookingPhotographer__createClass(InstantBookingPhotographerScreen, [{
    key: '_setup',
    value: function _setup() {
      var filterForm = document.querySelector(InstantBookingPhotographer_SELECTOR['filterForm']);
      var userRequestLocation = document.querySelector(InstantBookingPhotographer_SELECTOR['userRequestLocation']);

      filterForm && new instantBookingPhotographerFilterForm(filterForm);
      userRequestLocation && new components_userRequestLocation(userRequestLocation);
    }
  }]);

  return InstantBookingPhotographerScreen;
}();

// Setup the InstantBookingPhotographerScreen class, only on the photographers page.


var isInstantBookingPhotographerPage = document.body.classList.contains('instant-booking-photographers') && document.body.classList.contains('index');

if (isInstantBookingPhotographerPage) {
  new InstantBookingPhotographer_InstantBookingPhotographerScreen();
}
// EXTERNAL MODULE: ./node_modules/sharer.js/sharer.js
var sharer = __webpack_require__(542);
var sharer_default = /*#__PURE__*/__webpack_require__.n(sharer);

// EXTERNAL MODULE: ./app/assets/javascripts/components/videoPlayer/index.js
var videoPlayer = __webpack_require__(57);

// EXTERNAL MODULE: ./app/assets/javascripts/components/navTab/events.js
var navTab_events = __webpack_require__(86);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/availabilityTimetableForm/timetableSlot.js
var timetableSlot_CLASS_NAME = {
  'wrapper': 'form-group form-availability-timetable__slot',
  'input': 'form__radio--tag',
  // States
  'available': 'form__radio--outline',
  'unavailable': 'form__radio--muted',
  'past': 'form__radio--disabled'
};

// Output:
// <div class="form-group form-availability-timetable__slot">
//    <input id="slot-1525982400"
//           name="slot"
//           type="radio"
//           value="1525982400"
//           class="form__radio--tag form__radio--outline">
//    <label for="slot-1525982400">20:00</label>
// </div>
var TimetableSlot = function TimetableSlot(_ref) {
  var inputName = _ref.inputName,
      time = _ref.time,
      timestamp = _ref.timestamp,
      isPast = _ref.isPast,
      isAvailable = _ref.isAvailable;

  var slotId = 'slot-' + timestamp;
  var slotElement = document.createElement('div');
  slotElement.setAttribute('class', timetableSlot_CLASS_NAME['wrapper']);

  var inputElement = document.createElement('input');
  var inputClassName = [timetableSlot_CLASS_NAME['input']];
  isPast && inputClassName.push(timetableSlot_CLASS_NAME['past']);
  !isPast && isAvailable && inputClassName.push(timetableSlot_CLASS_NAME['available']);
  !isAvailable && inputClassName.push(timetableSlot_CLASS_NAME['unavailable']);

  inputElement.setAttribute('type', 'radio');
  inputElement.setAttribute('name', inputName);
  inputElement.setAttribute('value', timestamp);
  inputElement.setAttribute('id', slotId);
  inputElement.setAttribute('class', inputClassName.join(' '));
  (isPast || !isAvailable) && inputElement.setAttribute('disabled', 'disabled');

  var labelElement = document.createElement('label');
  labelElement.setAttribute('for', slotId);
  labelElement.innerText = time;

  slotElement.appendChild(inputElement);
  slotElement.appendChild(labelElement);

  return slotElement;
};

/* harmony default export */ var availabilityTimetableForm_timetableSlot = (TimetableSlot);
// EXTERNAL MODULE: ./app/assets/javascripts/config/index.js
var javascripts_config = __webpack_require__(56);

// EXTERNAL MODULE: ./app/assets/javascripts/adapters/base.js
var adapters_base = __webpack_require__(23);

// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/adapters/photographerAvailability.js
var photographerAvailability__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function photographerAvailability__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint camelcase: "off" */




var photographerAvailability_PhotographerAvailabilityAdapter = function (_BaseAdapter) {
  _inherits(PhotographerAvailabilityAdapter, _BaseAdapter);

  function PhotographerAvailabilityAdapter() {
    photographerAvailability__classCallCheck(this, PhotographerAvailabilityAdapter);

    return _possibleConstructorReturn(this, (PhotographerAvailabilityAdapter.__proto__ || Object.getPrototypeOf(PhotographerAvailabilityAdapter)).apply(this, arguments));
  }

  photographerAvailability__createClass(PhotographerAvailabilityAdapter, null, [{
    key: 'get',

    /**
     * Get the photographer availabilities
     *
     * @param {Integer} [photographer_id] - photographer ID
     * @param {Integer} [package_id] - package ID
     * @param {String} date - the date for which to check the availability against
     * @return {Promise} - a promise which will resolve to the availability list
     */
    value: function get(photographer_id, package_id) {
      var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var requestParams = {
        params: {
          package_id: package_id,
          date: date
        }
      };

      return this.prototype.getRequest(javascripts_config["a" /* default */]['api']['photographerAvailabilities'] + '/' + photographer_id, requestParams);
    }
  }]);

  return PhotographerAvailabilityAdapter;
}(adapters_base["a" /* default */]);

/* harmony default export */ var photographerAvailability = (photographerAvailability_PhotographerAvailabilityAdapter);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/availabilityTimetableForm/events.js
var PHOTOGRAPHER_AVAILABILITIES_IS_FETCHING = 'PHOTOGRAPHER_AVAILABILITIES_IS_FETCHING';
var PHOTOGRAPHER_AVAILABILITIES_FETCH_SUCCESS = 'PHOTOGRAPHER_AVAILABILITIES_FETCH_SUCCESS';
var PHOTOGRAPHER_AVAILABILITIES_FETCH_FAILURE = 'PHOTOGRAPHER_AVAILABILITIES_FETCH_FAILURE';

var PHOTOGRAPHER_AVAILABILITIES_SELECT_SLOT = 'PHOTOGRAPHER_AVAILABILITIES_SELECT_SLOT';
var PHOTOGRAPHER_AVAILABILITIES_UNSELECT_SLOT = 'PHOTOGRAPHER_AVAILABILITIES_UNSELECT_SLOT';

var PHOTOGRAPHER_AVAILABILITIES_SELECT_CATEGORY = 'PHOTOGRAPHER_AVAILABILITIES_SELECT_CATEGORY';
var PHOTOGRAPHER_AVAILABILITIES_SELECT_PACKAGE = 'PHOTOGRAPHER_AVAILABILITIES_SELECT_PACKAGE';
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/availabilityTimetableForm/index.js
var availabilityTimetableForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function availabilityTimetableForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







// Default timetable form selector
var availabilityTimetableForm_DEFAULT_SELECTOR = '.form-availability-timetable';

var availabilityTimetableForm_SELECTOR = {
  photographerIdInput: '[name="cart[photographer_id]"]',
  calendarInput: '.form-availability-timetable__select-date',
  packageSelect: '.form-availability-timetable__select-package',
  packageSelectInput: '.form-availability-timetable .select',
  slotList: '.form-availability-timetable__list-slot',
  slotItem: '.form-availability-timetable__slot .form__radio--tag',
  submitButton: '.form-availability-timetable__action button[type="submit"]'
};

var availabilityTimetableForm_CLASS_NAME = {
  fetching: 'form-availability-timetable--fetching',
  error: 'form-availability-timetable--error'
};

var availabilityTimetableForm_AvailabilityTimetableForm = function () {
  function AvailabilityTimetableForm(elementRef) {
    availabilityTimetableForm__classCallCheck(this, AvailabilityTimetableForm);

    // Initialise attributes
    this.elementRef = elementRef || document.querySelector(availabilityTimetableForm_DEFAULT_SELECTOR);
    this.calendarInput = this.elementRef.querySelector(availabilityTimetableForm_SELECTOR['calendarInput']);
    this.packageSelects = this.elementRef.querySelectorAll(availabilityTimetableForm_SELECTOR['packageSelect']);
    this.slotList = this.elementRef.querySelector(availabilityTimetableForm_SELECTOR['slotList']);
    this.submitButton = document.querySelector(availabilityTimetableForm_SELECTOR['submitButton']);

    this.state = {
      slotSelected: false
    };

    // Bind functions
    this.changePackageOrDateHandler = this.changePackageOrDateHandler.bind(this);
    this.onClickSlotItemHandler = this.onClickSlotItemHandler.bind(this);
    this.onSubmitHandler = this.onSubmitHandler.bind(this);

    this.onFetchingHandler = this.onFetchingHandler.bind(this);
    this.onFetchSuccessHandler = this.onFetchSuccessHandler.bind(this);
    this.onFetchFailureHandler = this.onFetchFailureHandler.bind(this);

    this.onSelectCategoryHandler = this.onSelectCategoryHandler.bind(this);
    this.onSelectPackageHandler = this.onSelectPackageHandler.bind(this);
    this.onSelectSlotHandler = this.onSelectSlotHandler.bind(this);
    this.onUnselectSlotHandler = this.onUnselectSlotHandler.bind(this);
    this.submitButton.addEventListener('click', this.onSubmitHandler);

    this._setup();
    this._addEventListeners();

    // Initial fetching of availability on component mount
    this._fetchPhotographerAvailability();
  }

  // Event Handlers

  /**
   * Event handler to handle package or date changes.
   * Trigger fetch of a photographer availability.
   *
   * @param {Event} event - `change` event
   * */


  availabilityTimetableForm__createClass(AvailabilityTimetableForm, [{
    key: 'changePackageOrDateHandler',
    value: function changePackageOrDateHandler(event) {
      this._fetchPhotographerAvailability();
    }

    /**
     * Event handler when an available slot is clicked.
     *
     * @param {Event} event - `click` event.
     * */

  }, {
    key: 'onClickSlotItemHandler',
    value: function onClickSlotItemHandler(event) {
      this.elementRef.dispatchEvent(new CustomEvent(PHOTOGRAPHER_AVAILABILITIES_SELECT_SLOT));
    }

    /**
     * Event handler when the form is submitted.
     *
     * @param {Event} event - `submit` event.
     * */

  }, {
    key: 'onSubmitHandler',
    value: function onSubmitHandler(event) {
      this.elementRef.submit();
      this._disableFormSubmit();
    }

    // Custom Event Handlers

    /**
     * Event handler when fetching a photographer availability information.
     *
     * @param {Event} _event - fetch start event.
     * */

  }, {
    key: 'onFetchingHandler',
    value: function onFetchingHandler(_event) {
      this._showSpinner();
      this._hideError();

      this.elementRef.dispatchEvent(new CustomEvent(PHOTOGRAPHER_AVAILABILITIES_UNSELECT_SLOT));
    }

    /**
     * Event handler when a photographer availability information has been fetched successfully
     *
     * @param {Event} [event] - fetch success event.
     * */

  }, {
    key: 'onFetchSuccessHandler',
    value: function onFetchSuccessHandler(event) {
      var slots = event.detail.slots;


      this._hideSpinner();
      this._resetSlotList();
      this._generateSlotList(slots);
    }

    /**
     * Event handler when a photographer availability information has NOT been fetched successfully
     *
     * @param {Event} _event - fetch failure event.
     * */

  }, {
    key: 'onFetchFailureHandler',
    value: function onFetchFailureHandler(_event) {
      this._hideSpinner();
      this._showError();
    }

    /**
     * Event handler when an availability slot is selected
     *
     * @param {Event} [event] - custom event.
     * */

  }, {
    key: 'onSelectSlotHandler',
    value: function onSelectSlotHandler(event) {
      this.state.slotSelected = true;
      this._enableFormSubmit();
    }

    /**
     * Event handler when an availability slot is unselected
     *
     * @param {Event} [event] - custom event.
     * */

  }, {
    key: 'onUnselectSlotHandler',
    value: function onUnselectSlotHandler(event) {
      this.state.slotSelected = false;
      this._disableFormSubmit();
    }

    /**
     * Event handler when the package category is changed
     * This is used to alter the category programmatically outside of the component scope
     *
     * @param {Event} [event] - custom event.
     * */

  }, {
    key: 'onSelectCategoryHandler',
    value: function onSelectCategoryHandler(event) {
      var categoryId = event.detail.categoryId;


      this._togglePackageSelectVisibilityFor(categoryId);
      this._resetPackageFor(categoryId);
      this._fetchPhotographerAvailability();
    }

    /**
     * Event handler when the package is selected
     * This is used to alter the package programmatically outside of the component scope
     *
     * @param {Event} [event] - custom event.
     * */

  }, {
    key: 'onSelectPackageHandler',
    value: function onSelectPackageHandler(event) {
      var _event$detail = event.detail,
          categoryId = _event$detail.categoryId,
          packageId = _event$detail.packageId;


      this._togglePackageSelectVisibilityFor(categoryId);
      this._selectPackage(packageId);
      this._fetchPhotographerAvailability();
    }

    // Private

  }, {
    key: '_setup',
    value: function _setup() {
      this.packageSelects.forEach(function (packageSelect) {
        new components_selectInput["b" /* default */](packageSelect);
      });

      !this.state.slotSelected && this._disableFormSubmit();
    }
  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this = this;

      this.elementRef.addEventListener(PHOTOGRAPHER_AVAILABILITIES_IS_FETCHING, this.onFetchingHandler);
      this.elementRef.addEventListener(PHOTOGRAPHER_AVAILABILITIES_FETCH_SUCCESS, this.onFetchSuccessHandler);
      this.elementRef.addEventListener(PHOTOGRAPHER_AVAILABILITIES_FETCH_FAILURE, this.onFetchFailureHandler);
      this.elementRef.addEventListener(PHOTOGRAPHER_AVAILABILITIES_SELECT_SLOT, this.onSelectSlotHandler);
      this.elementRef.addEventListener(PHOTOGRAPHER_AVAILABILITIES_UNSELECT_SLOT, this.onUnselectSlotHandler);
      this.elementRef.addEventListener(PHOTOGRAPHER_AVAILABILITIES_SELECT_CATEGORY, this.onSelectCategoryHandler);
      this.elementRef.addEventListener(PHOTOGRAPHER_AVAILABILITIES_SELECT_PACKAGE, this.onSelectPackageHandler);

      this.calendarInput.addEventListener('change', this.changePackageOrDateHandler);
      this.packageSelects.forEach(function (packageSelect) {
        packageSelect.addEventListener('change', _this.changePackageOrDateHandler);
      });
    }
  }, {
    key: '_addSlotClickEventListeners',
    value: function _addSlotClickEventListeners() {
      var _this2 = this;

      this.elementRef.querySelectorAll(availabilityTimetableForm_SELECTOR['slotItem']).forEach(function (slotItem) {
        slotItem.addEventListener('click', _this2.onClickSlotItemHandler);
      });
    }
  }, {
    key: '_removeSlotClickEventListeners',
    value: function _removeSlotClickEventListeners() {
      var _this3 = this;

      this.elementRef.querySelectorAll(availabilityTimetableForm_SELECTOR['slotItem']).forEach(function (slotItem) {
        slotItem.removeEventListener('click', _this3.onClickSlotItemHandler);
      });
    }
  }, {
    key: '_fetchPhotographerAvailability',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var fetchingEvent, photographerId, packageId, date, timetableSlots, fetchSuccessEvent, fetchFailureEvent;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fetchingEvent = new CustomEvent(PHOTOGRAPHER_AVAILABILITIES_IS_FETCHING);

                this.elementRef.dispatchEvent(fetchingEvent);

                _context.prev = 2;
                photographerId = this.elementRef.querySelector(availabilityTimetableForm_SELECTOR['photographerIdInput']).value;
                packageId = this.packageSelects.filter(function (select) {
                  return !select.attributes.disabled;
                })[0].value;
                date = this.calendarInput.value;
                _context.next = 8;
                return photographerAvailability.get(photographerId, packageId, date);

              case 8:
                timetableSlots = _context.sent;
                fetchSuccessEvent = new CustomEvent(PHOTOGRAPHER_AVAILABILITIES_FETCH_SUCCESS, {
                  detail: { slots: timetableSlots }
                });

                this.elementRef.dispatchEvent(fetchSuccessEvent);
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](2);
                fetchFailureEvent = new CustomEvent(PHOTOGRAPHER_AVAILABILITIES_FETCH_FAILURE, {
                  detail: _context.t0
                });

                this.elementRef.dispatchEvent(fetchFailureEvent);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 13]]);
      }));

      function _fetchPhotographerAvailability() {
        return _ref.apply(this, arguments);
      }

      return _fetchPhotographerAvailability;
    }()
  }, {
    key: '_generateSlotList',
    value: function _generateSlotList(timetableSlots) {
      this.slotList.innerHTML = timetableSlots.map(function (timetableSlot) {
        var slot = availabilityTimetableForm_timetableSlot({
          inputName: 'cart[appointment_date]',
          time: timetableSlot.start_time,
          timestamp: timetableSlot.start_timestamp,
          isPast: timetableSlot.is_past,
          isAvailable: timetableSlot.is_available
        });
        return slot.outerHTML;
      }).join('');

      this._addSlotClickEventListeners();
    }
  }, {
    key: '_resetSlotList',
    value: function _resetSlotList() {
      this.slotList.innerHTML = '';
      this._removeSlotClickEventListeners();

      this.state.slotSelected = false;
    }

    /**
     * At any given time, only one list of package options is displayed
     * Hide / display the corresponding package option list for the current category
     *
     * @param {Integer} [categoryId] - category ID.
     * */

  }, {
    key: '_togglePackageSelectVisibilityFor',
    value: function _togglePackageSelectVisibilityFor(categoryId) {
      this.elementRef.querySelectorAll(availabilityTimetableForm_SELECTOR['packageSelectInput']).forEach(function (selectInput) {
        var originalSelect = selectInput.previousElementSibling;

        if (originalSelect.dataset.categoryId === categoryId) {
          selectInput.removeAttribute('hidden');
          originalSelect.removeAttribute('disabled');
        } else {
          selectInput.setAttribute('hidden', 'hidden');
          originalSelect.setAttribute('disabled', 'disabled');
        }
      });
    }

    /**
     * Select the package in the custom select
     *
     * @param {Integer} [packageId] - package ID.
     * */

  }, {
    key: '_selectPackage',
    value: function _selectPackage(packageId) {
      var packageOption = this.elementRef.querySelector(availabilityTimetableForm_SELECTOR['packageSelectInput'] + ' li[rel="' + packageId + '"]');

      packageOption.click();
    }

    /**
     * Reset the selected package option by picking the first package for a category
     *
     * @param {Integer} [categoryId] - category ID.
     * */

  }, {
    key: '_resetPackageFor',
    value: function _resetPackageFor(categoryId) {
      var originalSelect = this.packageSelects.filter(function (select) {
        return select.dataset.categoryId === categoryId;
      })[0];
      var packageOptions = originalSelect.nextElementSibling.querySelectorAll('.select__options li');

      packageOptions[0].click();
    }
  }, {
    key: '_showSpinner',
    value: function _showSpinner() {
      this.elementRef.classList.add(availabilityTimetableForm_CLASS_NAME['fetching']);
    }
  }, {
    key: '_hideSpinner',
    value: function _hideSpinner() {
      this.elementRef.classList.remove(availabilityTimetableForm_CLASS_NAME['fetching']);
    }
  }, {
    key: '_showError',
    value: function _showError() {
      this.elementRef.classList.add(availabilityTimetableForm_CLASS_NAME['error']);
    }
  }, {
    key: '_hideError',
    value: function _hideError() {
      this.elementRef.classList.remove(availabilityTimetableForm_CLASS_NAME['error']);
    }
  }, {
    key: '_enableFormSubmit',
    value: function _enableFormSubmit() {
      this.submitButton.disabled = false;
    }
  }, {
    key: '_disableFormSubmit',
    value: function _disableFormSubmit() {
      this.submitButton.disabled = true;
    }
  }]);

  return AvailabilityTimetableForm;
}();

/* harmony default export */ var availabilityTimetableForm = (availabilityTimetableForm_AvailabilityTimetableForm);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/photographerProfileInfo/index.js
var photographerProfileInfo__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function photographerProfileInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var photographerProfileInfo_CLASS_NAME = {
  detailContainerExpanded: 'photographer-profile-info__detail--expanded',
  visible: 'list-package-set__item--visible'
};

var photographerProfileInfo_SELECTOR = {
  headerCategorySelect: '#headerCategorySelect',
  asideCategorySelect: '#asideCategorySelect'
};

var photographerProfileInfo_PhotographerProfileInfo = function () {
  function PhotographerProfileInfo(elementRef) {
    photographerProfileInfo__classCallCheck(this, PhotographerProfileInfo);

    this._setup();

    // Initialise attributes
    this.elementRef = elementRef;

    this.detailContainer = elementRef.querySelector('.photographer-profile-info__detail');
    this.toggleProfileInfoButton = elementRef.querySelector('.photographer-profile-info__btn-toggle-detail');
    this.categoryBadges = elementRef.querySelectorAll('.list-photographer-category__item');
    this.categorySelectOptions = elementRef.querySelectorAll('.select__options li');

    // Bind functions
    this.toggleProfileInfoButtonClickHandler = this.toggleProfileInfoButtonClickHandler.bind(this);
    this.onVisibleCategoryPackage = this.onVisibleCategoryPackage.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler when the toggle button is clicked to collapse/expand the detail container
   * on small screens only
   *
   * @param {Event} event - click event
   * */


  photographerProfileInfo__createClass(PhotographerProfileInfo, [{
    key: 'toggleProfileInfoButtonClickHandler',
    value: function toggleProfileInfoButtonClickHandler(event) {
      this.detailContainer.classList.toggle(photographerProfileInfo_CLASS_NAME['detailContainerExpanded']);
    }
  }, {
    key: 'onVisibleCategoryPackage',
    value: function onVisibleCategoryPackage(event) {
      var targetElement = event.target || event.srcElement;
      var categoryId = targetElement.id || targetElement.getAttribute('rel');
      this._updateUrlParams(categoryId);
    }

    // Private

  }, {
    key: '_setup',
    value: function _setup() {
      new components_selectInput["b" /* default */](document.querySelector(photographerProfileInfo_SELECTOR['headerCategorySelect']), {
        addPopper: false
      });

      new components_selectInput["b" /* default */](document.querySelector(photographerProfileInfo_SELECTOR['asideCategorySelect']));
    }
  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this = this;

      this.toggleProfileInfoButton && this.toggleProfileInfoButton.addEventListener('click', this.toggleProfileInfoButtonClickHandler);

      this.categoryBadges.forEach(function (categoryBadge) {
        categoryBadge.addEventListener('click', _this.onVisibleCategoryPackage);
      });

      this.categorySelectOptions.forEach(function (categorySelectOption) {
        categorySelectOption.addEventListener('click', _this.onVisibleCategoryPackage);
      });
    }
  }, {
    key: '_updateUrlParams',
    value: function _updateUrlParams(categoryId) {
      // const urlParams = new URLSearchParams(window.location.search);
      var formData = { 'category_id': categoryId };
      var queryString = toQueryString(formData);
      Object(utils_window["a" /* redirectTo */])('' + window.location.origin + window.location.pathname + '?' + queryString);
    }
  }]);

  return PhotographerProfileInfo;
}();

/* harmony default export */ var photographerProfileInfo = (photographerProfileInfo_PhotographerProfileInfo);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/photographerPackageList/events.js
var PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE = 'PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE';
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/photographerPackageList/index.js
var photographerPackageList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function photographerPackageList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var photographerPackageList_CLASS_NAME = {
  visible: 'list-package-set__item--visible'
};

var photographerPackageList_SELECTOR = {
  packageList: '.list-package-set__item'
};

var PARAMS = {
  categoryId: 'category_id'
};

var photographerPackageList_PhotographerPackageList = function () {
  function PhotographerPackageList(elementRef) {
    photographerPackageList__classCallCheck(this, PhotographerPackageList);

    this.elementRef = elementRef;
    this.packageList = this.elementRef.querySelectorAll(photographerPackageList_SELECTOR['packageList']);

    // Bind functions
    this.onVisibleCategoryPackage = this.onVisibleCategoryPackage.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler to handle visibility of package list.
   *
   * @param {Event} [event] - custom event.
   * */


  photographerPackageList__createClass(PhotographerPackageList, [{
    key: 'onVisibleCategoryPackage',
    value: function onVisibleCategoryPackage(event) {
      var categoryId = event.detail.categoryId;


      this.packageList.forEach(function (list) {
        if (list.dataset.packageListId === categoryId) {
          list.classList.add(photographerPackageList_CLASS_NAME['visible']);
        } else {
          list.classList.remove(photographerPackageList_CLASS_NAME['visible']);
        }
      });

      this._updateUrlParams(categoryId);
    }

    // Private

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.elementRef.addEventListener(PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE, this.onVisibleCategoryPackage);
    }
  }, {
    key: '_updateUrlParams',
    value: function _updateUrlParams(categoryId) {
      var url = new URLSearchParams(location.search);

      if (url.has(PARAMS['categoryId']) && url.get(PARAMS['categoryId']) !== categoryId) {
        url.set(PARAMS['categoryId'], categoryId);
        history.replaceState({ categoryId: categoryId }, '', '?' + url.toString());
      }
    }
  }]);

  return PhotographerPackageList;
}();

/* harmony default export */ var photographerPackageList = (photographerPackageList_PhotographerPackageList);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/PhotographerProfile.js
var PhotographerProfile__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PhotographerProfile__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
















var PhotographerProfile_SELECTOR = {
  profileInfo: '.photographer-profile-info',
  availabilityCategoryHeaderSelect: '.form-availability-header select',
  availabilityCategorySelect: '.photographer-profile-info__booking select',
  availabilityTimetable: '.form-availability-timetable',
  categoryPackageList: '.list-package-set',
  linkToSeeReviews: '.btn--link-secondary',
  videoPlayer: '[id^=videoPlayer]',
  appHeader: '.app-header',
  // Elements with event listeners
  photographerProfileContent: '.photographer-profile-content',
  priceListButton: '.photographer-profile-info__booking .btn--link',
  seePricesButton: '.btn--see-price',
  packageListItem: '.card-package__btn-action'
};

var TABS = {
  prices: 'pricesPane',
  portfolio: 'portfolioPane'
};

var CLASS_NAMES = {
  instantBooking: 'photographers--instant-booking'
};

var PhotographerProfile_PhotographerInfoScreen = function () {
  function PhotographerInfoScreen() {
    PhotographerProfile__classCallCheck(this, PhotographerInfoScreen);

    this.profileInfo = document.querySelector(PhotographerProfile_SELECTOR['profileInfo']);
    this.isInstantBooking = document.body.classList.contains(CLASS_NAMES['instantBooking']);
    this.availabilityTimetable = document.querySelector(PhotographerProfile_SELECTOR['availabilityTimetable']);
    this.availabilityCategoryHeaderSelect = document.querySelector(PhotographerProfile_SELECTOR['availabilityCategoryHeaderSelect']);
    this.availabilityCategorySelect = document.querySelector(PhotographerProfile_SELECTOR['availabilityCategorySelect']);
    this.categoryPackageList = document.querySelector(PhotographerProfile_SELECTOR['categoryPackageList']);
    this.seePricesButton = document.querySelector(PhotographerProfile_SELECTOR['seePricesButton']);
    this.photographerProfileContent = document.querySelector(PhotographerProfile_SELECTOR['photographerProfileContent']);
    this.linkToSeeReviews = document.querySelector(PhotographerProfile_SELECTOR['linkToSeeReviews']);
    this.videoPlayers = document.querySelectorAll(PhotographerProfile_SELECTOR['videoPlayer']);

    // Bind functions
    this.categoryChangeHandler = this.categoryChangeHandler.bind(this);
    this.packageCategoryChangeHandler = this.packageCategoryChangeHandler.bind(this);
    this.packageClickHandler = this.packageClickHandler.bind(this);
    this.onNavigationTabChange = this.onNavigationTabChange.bind(this);
    this.scrollHandler = this.scrollHandler.bind(this);

    this._setup();
    this._addEventListeners();
  }

  // Event Handlers
  /**
   * Event handler when a package is selected
   * Dispatches a custom event to the `AvailabilityTimetableForm` and `PhotographerPackageList` components
   *
   * @param {Event} [event] - `change` event.
   * */


  PhotographerProfile__createClass(PhotographerInfoScreen, [{
    key: 'packageCategoryChangeHandler',
    value: function packageCategoryChangeHandler(event) {
      var categoryId = event.currentTarget.value;

      this._dispatchCategorySelectEvent(categoryId);
      this._dispatchPhotographerPackageListEvent(categoryId);
    }

    /**
     * Event handler triggered when category select elements are changed.
     *
     * @param {Event} event - click event.
     * */

  }, {
    key: 'categoryChangeHandler',
    value: function categoryChangeHandler(event) {
      this.availabilityCategoryHeaderSelect.value = event.target.value;
      this.availabilityCategorySelect.value = event.target.value;
    }

    /**
     * Event handler when a package is selected in the package list
     * Dispatches a custom event to the `AvailabilityTimetableForm` component
     *
     * @param {Event} [event] - `click` event.
     * */

  }, {
    key: 'packageClickHandler',
    value: function packageClickHandler(event) {
      var _event$currentTarget$ = event.currentTarget.dataset,
          categoryId = _event$currentTarget$.categoryId,
          packageId = _event$currentTarget$.packageId;


      this._dispatchPackageSelectEvent(packageId, categoryId);
    }

    /**
     * Scroll handler of reviews link.
     *  Finds the closest link clicked.
     *    1) If the href is a hash url, enables smooth scroll.
     *    2) Else allows the default browser action.
     *
     * @param {Event} event - scroll event on reviews link.
     * */

  }, {
    key: 'scrollHandler',
    value: function scrollHandler(event) {
      var closestLink = event.target.closest('a');
      var targetHref = closestLink.hash;
      var scrollToEl = document.querySelector(targetHref);

      var invalidLink = closestLink.pathname !== window.location.pathname || targetHref.includes('#');
      var missingScrollElement = scrollToEl === null;

      if (invalidLink || missingScrollElement) {
        return;
      }

      event.preventDefault();

      var appHeader = document.querySelector(PhotographerProfile_SELECTOR['appHeader']);
      var appHeaderHeight = appHeader.getBoundingClientRect().height;

      // compensate for the header height, as its fixed at top
      var verticalScroll = scrollToEl.getBoundingClientRect().y - appHeaderHeight;

      // Enable Smooth scroll
      window.scrollBy({
        top: verticalScroll,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, {
    key: 'onNavigationTabChange',
    value: function onNavigationTabChange(event) {
      if (event.detail.tab === TABS['prices']) {
        this.seePricesButton.setAttribute('hidden', true);
      } else if (event.detail.tab === TABS['portfolio']) {
        this.seePricesButton.removeAttribute('hidden');
      }
    }
  }, {
    key: '_setup',
    value: function _setup() {
      if (!this.isInstantBooking) {
        this.profileInfo && new photographerProfileInfo(this.profileInfo);
        this.availabilityTimetable && new availabilityTimetableForm(this.availabilityTimetable);
        this.availabilityCategoryHeaderSelect && new components_selectInput["b" /* default */](this.availabilityCategoryHeaderSelect);
        this.availabilityCategorySelect && new components_selectInput["b" /* default */](this.availabilityCategorySelect);
        this.categoryPackageList && new photographerPackageList(this.categoryPackageList);

        this._dispatchPhotographerPackageListEvent(this.availabilityCategorySelect.value);
      }

      this._setupVideoPlayers();
    }
  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      var _this = this;

      if (!this.isInstantBooking) {
        // As there are two category select elements, symlink their values
        document.querySelector(PhotographerProfile_SELECTOR['availabilityCategoryHeaderSelect']).addEventListener('change', this.categoryChangeHandler);
        document.querySelector(PhotographerProfile_SELECTOR['availabilityCategorySelect']).addEventListener('change', this.categoryChangeHandler);

        // Actual change category handler to update the availability check
        document.querySelector(PhotographerProfile_SELECTOR['availabilityCategoryHeaderSelect']).addEventListener('change', this.packageCategoryChangeHandler);
        document.querySelector(PhotographerProfile_SELECTOR['availabilityCategorySelect']).addEventListener('change', this.packageCategoryChangeHandler);

        document.querySelectorAll(PhotographerProfile_SELECTOR['packageListItem']).forEach(function (packageListItem) {
          packageListItem.addEventListener('click', _this.packageClickHandler);
        });
      }
      this.photographerProfileContent.addEventListener(navTab_events["a" /* NAVIGATION_TAB_CHANGED */], this.onNavigationTabChange);

      this.linkToSeeReviews && this.linkToSeeReviews.addEventListener('click', this.scrollHandler);
    }
  }, {
    key: '_dispatchCategorySelectEvent',
    value: function _dispatchCategorySelectEvent(categoryId) {
      var categorySelectEvent = new CustomEvent(PHOTOGRAPHER_AVAILABILITIES_SELECT_CATEGORY, {
        detail: {
          categoryId: categoryId
        }
      });

      this.availabilityTimetable.dispatchEvent(categorySelectEvent);
    }
  }, {
    key: '_dispatchPhotographerPackageListEvent',
    value: function _dispatchPhotographerPackageListEvent(categoryId) {
      var visibleCategoryPackageEvent = new CustomEvent(PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE, {
        detail: {
          categoryId: categoryId
        }
      });

      this.categoryPackageList.dispatchEvent(visibleCategoryPackageEvent);
    }
  }, {
    key: '_dispatchPackageSelectEvent',
    value: function _dispatchPackageSelectEvent(packageId, categoryId) {
      var packageSelectEvent = new CustomEvent(PHOTOGRAPHER_AVAILABILITIES_SELECT_PACKAGE, {
        detail: {
          categoryId: categoryId,
          packageId: packageId
        }
      });

      this.availabilityTimetable.dispatchEvent(packageSelectEvent);
    }
  }, {
    key: '_setupVideoPlayers',
    value: function _setupVideoPlayers() {
      if (!(this.videoPlayers && this.videoPlayers.length)) {
        return;
      }

      this.videoPlayers.forEach(function (videoPlayerElement) {
        var modalId = '#' + videoPlayerElement.id.replace(/Player/, 'Modal');
        var videoPlayerOptions = {
          file: videoPlayerElement.dataset.videoFile,
          title: videoPlayerElement.dataset.videoTitle,
          mediaid: videoPlayerElement.dataset.videoUuid,
          type: videoPlayerElement.dataset.videoType,
          displaytitle: true
        };

        if (videoPlayerElement.dataset.videoPoster) {
          Object.assign(videoPlayerOptions, {
            image: videoPlayerElement.dataset.videoPoster
          });
        }

        var modal = new components_modal["b" /* default */](document.querySelector(modalId));
        var player = new videoPlayer["a" /* default */](videoPlayerElement, videoPlayerOptions);

        modal.onShowed(function () {
          player.play();
        });

        modal.onHidden(function () {
          player.pause();
        });

        player.onFullScreen(function (event) {
          var fullscreen = event.fullscreen;


          if (fullscreen && document.body.classList.contains('modal__open')) {
            document.querySelector('.modal__overlay').style.display = 'none';
          } else {
            document.querySelector('.modal__overlay').style.display = 'block';
          }
        });
      });
    }
  }]);

  return PhotographerInfoScreen;
}();

// Setup the AdvanceBookingPhotographerScreen class, only on the photographer profile page.


var isPhotographerInfoPage = document.body.classList.contains('photographers') && document.body.classList.contains('show');

if (isPhotographerInfoPage) {
  new PhotographerProfile_PhotographerInfoScreen();
}
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/adapters/promotionCode.js
var promotionCode__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function promotionCode__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function promotionCode__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function promotionCode__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint camelcase: "off" */



var PromotionCodeAdapter = function (_BaseAdapter) {
  promotionCode__inherits(PromotionCodeAdapter, _BaseAdapter);

  function PromotionCodeAdapter() {
    promotionCode__classCallCheck(this, PromotionCodeAdapter);

    return promotionCode__possibleConstructorReturn(this, (PromotionCodeAdapter.__proto__ || Object.getPrototypeOf(PromotionCodeAdapter)).apply(this, arguments));
  }

  promotionCode__createClass(PromotionCodeAdapter, null, [{
    key: 'get',
    value: function get(code, price) {
      var requestParams = {
        params: {
          code: code,
          price: price
        }
      };

      return this.prototype.getRequest('/checkout/promotion', requestParams);
    }
  }]);

  return PromotionCodeAdapter;
}(adapters_base["a" /* default */]);

/* harmony default export */ var promotionCode = (PromotionCodeAdapter);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/checkPromotion/index.js
var checkPromotion__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function checkPromotion__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function checkPromotion__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var checkPromotion_SELECTOR = {
  inputPromotionRow: '.booking-promotion__line-item',
  inputPromotionCode: '.booking-promotion__input__code',
  inputPromotionPrice: '.booking-promotion__input__price',
  inputPromotionSubmit: '.booking-promotion__submit',
  discountText: '.booking-promotion__line-discount',
  totalPrice: '.booking-summary__total_price'
};

var checkPromotion_CheckPromotion = function () {
  function CheckPromotion() {
    checkPromotion__classCallCheck(this, CheckPromotion);

    // this.inputPromotionSubmit = document.querySelector(SELECTOR['inputPromotionSubmit']);
    this.inputPromotionCode = document.querySelector(checkPromotion_SELECTOR['inputPromotionCode']);

    this._addEventListeners();
  }

  // Event Handlers

  checkPromotion__createClass(CheckPromotion, [{
    key: 'checkPromotionCode',
    value: function () {
      var _ref = checkPromotion__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var inputPromotionCode, inputPromotionPrice, responsePromotionCode, input;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                inputPromotionCode = document.querySelector(checkPromotion_SELECTOR['inputPromotionCode']).value;
                inputPromotionPrice = document.querySelector(checkPromotion_SELECTOR['inputPromotionPrice']).value;
                _context.next = 4;
                return promotionCode.get(inputPromotionCode, inputPromotionPrice);

              case 4:
                responsePromotionCode = _context.sent;
                input = document.getElementById('promotion_code');


                if (responsePromotionCode && responsePromotionCode.id) {
                  document.querySelector('#booking_promotion_id').value = responsePromotionCode.id;
                  document.querySelectorAll(checkPromotion_SELECTOR['discountText']).innerHTML = '\n        <td><span style="color: #00ca9f">Discount</span></td>\n        <td class=\'booking-summary__total_price\'><span style="color: #00ca9f">' + responsePromotionCode.discount_price + '</span></td>';
                  input.className = 'booking-promotion__input__code';
                  input.readOnly = true;
                } else {
                  document.querySelectorAll(checkPromotion_SELECTOR['discountText']).innerHTML = '';
                  input.className = 'booking-promotion__input__code invalid';
                  input.readOnly = true;
                }

                document.querySelector(checkPromotion_SELECTOR['totalPrice']).innerHTML = '' + responsePromotionCode.price;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkPromotionCode(_x) {
        return _ref.apply(this, arguments);
      }

      return checkPromotionCode;
    }()

    // Private Methods

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {}
  }]);

  return CheckPromotion;
}();

/* harmony default export */ var checkPromotion = (checkPromotion_CheckPromotion);
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/PromotionCode.js
var PromotionCode__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PromotionCode__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PromotionCode_PromotoinCodeScreen = function () {
  function PromotoinCodeScreen() {
    PromotionCode__classCallCheck(this, PromotoinCodeScreen);

    this._setup();
  }

  PromotionCode__createClass(PromotoinCodeScreen, [{
    key: '_setup',
    value: function _setup() {
      new checkPromotion();
    }
  }]);

  return PromotoinCodeScreen;
}();

if (document.querySelector('#promotion_code')) {
  new PromotionCode_PromotoinCodeScreen();
}
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/CustomerDetail.js
var CustomerDetail__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CustomerDetail__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var CustomerDetail_CustomerDetail = function () {
  function CustomerDetail() {
    CustomerDetail__classCallCheck(this, CustomerDetail);

    this._setup();
  }

  CustomerDetail__createClass(CustomerDetail, [{
    key: '_setup',
    value: function _setup() {
      var telInput = document.querySelector('#booking_phone_number');
      var iti = intl_tel_input_default()(telInput, {
        initialCountry: 'th'
      });

      var numberType = iti.selectedCountryData.dialCode;
      telInput.value = telInput.value.replace('+' + numberType, '');

      var submit = document.querySelector('#formBookingSession__submit');
      submit.addEventListener('click', this.clickHandler);
    }
  }, {
    key: 'clickHandler',
    value: function clickHandler(event) {
      var telInput = document.querySelector('#booking_phone_number');
      var countryCodeInput = document.querySelector('#booking_country_code');
      var iti = window.intlTelInputGlobals.getInstance(telInput);

      var numberType = iti.selectedCountryData.dialCode;

      countryCodeInput.value = '+' + numberType;
    }
  }]);

  return CustomerDetail;
}();

if (document.querySelector('#booking_phone_number')) {
  new CustomerDetail_CustomerDetail();
}
// CONCATENATED MODULE: ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/packs/application.js










/***/ }),

/***/ 538:
/***/ (function(module, exports) {

/* eslint-disable handle-callback-err */

if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/swBooking.js').then(function (registration) {
    // Registration was successful
    // Perform registration setup if required here
  }).catch(function (err) {
    // registration failed :(
    // Perform registration failure tasks if required here
  });
}

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable */
/*!
  * Bootstrap util.js v4.3.1 (https://getbootstrap.com/)
  * Copyright 2011-2019 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
  */
(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory(__webpack_require__(31)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = global || self, global.Util = factory(global.jQuery));
})(this, function ($) {
  'use strict';

  $ = $ && $.hasOwnProperty('default') ? $['default'] : $;

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.3.1): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */

  var TRANSITION_END = 'transitionend';
  var MAX_UID = 1000000;
  var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

  function toType(obj) {
    return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: TRANSITION_END,
      delegateType: TRANSITION_END,
      handle: function handle(event) {
        if ($(event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }

        return undefined; // eslint-disable-line no-undefined
      }
    };
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;
    $(this).one(Util.TRANSITION_END, function () {
      called = true;
    });
    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);
    return this;
  }

  function setTransitionEndSupport() {
    $.fn.emulateTransitionEnd = transitionEndEmulator;
    $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
  }
  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */

  var Util = {
    TRANSITION_END: 'bsTransitionEnd',
    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));

      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector || selector === '#') {
        var hrefAttr = element.getAttribute('href');
        selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
      }

      try {
        return document.querySelector(selector) ? selector : null;
      } catch (err) {
        return null;
      }
    },
    getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
      if (!element) {
        return 0;
      } // Get transition-duration of the element


      var transitionDuration = $(element).css('transition-duration');
      var transitionDelay = $(element).css('transition-delay');
      var floatTransitionDuration = parseFloat(transitionDuration);
      var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

      if (!floatTransitionDuration && !floatTransitionDelay) {
        return 0;
      } // If multiple durations are defined, take the first


      transitionDuration = transitionDuration.split(',')[0];
      transitionDelay = transitionDelay.split(',')[0];
      return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $(element).trigger(TRANSITION_END);
    },
    // TODO: Remove in v5
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(TRANSITION_END);
    },
    isElement: function isElement(obj) {
      return (obj[0] || obj).nodeType;
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && Util.isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
          }
        }
      }
    },
    findShadowRoot: function findShadowRoot(element) {
      if (!document.documentElement.attachShadow) {
        return null;
      } // Can find the shadow root otherwise it'll return the document


      if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
      }

      if (element instanceof ShadowRoot) {
        return element;
      } // when we don't find a shadow root


      if (!element.parentNode) {
        return null;
      }

      return Util.findShadowRoot(element.parentNode);
    }
  };
  setTransitionEndSupport();

  return Util;
});
//# sourceMappingURL=util.js.map
/* eslint-enable */

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// Object.keys
if (!Object.keys) {
  Object.keys = function (object) {
    var keys = [];
    for (var name in object) {
      if (Object.prototype.hasOwnProperty.call(object, name)) {
        keys.push(name);
      }
    }
    return keys;
  };
}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// ChildNode.remove
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {};

config['axios'] = {
  timeout: 30000
};

config['api'] = {
  jobMedia: '/me/jobs/:job_id/media',
  photographerMedia: '/me/photographer_media',
  photographerAvailabilities: '/photographer_availabilities',
  payment: '/checkout/pay'
};

config['currency'] = {
  minimumValidPrice: 0,
  maximumValidPrice: 1000000,
  precision: 2
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_OPTIONS = {
  controls: true
};

var VideoPlayer = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - The element target for initialize JWPlayer.
   * @param {Object} options - The JWPlayer options.
   * */
  function VideoPlayer(elementRef, options) {
    _classCallCheck(this, VideoPlayer);

    this.elementRef = elementRef;
    this.options = Object.assign({}, DEFAULT_OPTIONS, options);

    this.onReady = this.onReady.bind(this);

    this._setup();
  }

  /**
   * Play the video.
   */


  _createClass(VideoPlayer, [{
    key: 'play',
    value: function play() {
      if (!this.player) {
        return;
      }

      this.player.play();
    }

    /**
     * Pause the video.
     */

  }, {
    key: 'pause',
    value: function pause() {
      if (!this.player) {
        return;
      }

      this.player.pause();
    }

    // Event

    /**
     * Event handler for signifies when the player has been initialized and is ready for playback.
     *
     * @param {Function} callback - The callback function.
     * */

  }, {
    key: 'onReady',
    value: function onReady(callback) {
      return this.player.on('ready', function (event) {
        callback(event);
      });
    }

    /**
     * Event handler for triggered when video playing in fullscreen mode.
     *
     * @param {Function} callback - The callback function.
     * */

  }, {
    key: 'onFullScreen',
    value: function onFullScreen(callback) {
      return this.player.on('fullscreen', function (event) {
        callback(event);
      });
    }

    // Private

    /**
     * Setup the JWPlayer.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      if (window.jwplayer) {
        this.player = window.jwplayer(this.elementRef);
        this.player.setup(this.options);
      }
    }
  }]);

  return VideoPlayer;
}();

/* harmony default export */ __webpack_exports__["a"] = (VideoPlayer);

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

/**
 * Allows iteration over a HTMLCollection
 * */
HTMLCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];

/**
 * Extend `HTMLCollection` prototype to provide a `Array`-like interface
 * */
HTMLCollection.prototype.find = Array.prototype.find;
HTMLCollection.prototype.filter = Array.prototype.filter;

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

/**
 * Allows iteration over a NodeList
 * */
NamedNodeMap.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];

/**
 * Extend `NodeList` prototype to provide a `Array`-like interface
 * */
NamedNodeMap.prototype.forEach = Array.prototype.forEach;
NamedNodeMap.prototype.filter = Array.prototype.filter;

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

/**
 * Allows iteration over a NodeList
 * */
NodeList.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];

/**
 * Extend `NodeList` prototype to provide a `Array`-like interface
 * */
NodeList.prototype.find = Array.prototype.find;
NodeList.prototype.filter = Array.prototype.filter;

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smoothscroll_polyfill__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smoothscroll_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_smoothscroll_polyfill__);


/**
 *  [Scroll Behavior specification](https://drafts.csswg.org/cssom-view/#dom-window-scrollby) has been introduced as an
 *  extension of the Window interface to allow for the developer to opt in to native smooth scrolling.
 *
 *   Add polyfill for the specification.
 * */
__WEBPACK_IMPORTED_MODULE_0_smoothscroll_polyfill___default.a.polyfill();

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SvgIcon = function SvgIcon(_ref) {
  var name = _ref.name,
      width = _ref.width,
      height = _ref.height;

  var svgns = 'http://www.w3.org/2000/svg';
  var xlinkns = 'http://www.w3.org/1999/xlink';

  var svgElement = document.createElementNS(svgns, 'svg');
  var svgUse = document.createElementNS(svgns, 'use');

  svgElement.setAttribute('width', width || 16);
  svgElement.setAttribute('height', height || 16);

  svgUse.setAttributeNS(xlinkns, 'href', '#' + name);
  svgElement.appendChild(svgUse);

  return svgElement;
};

/* harmony default export */ __webpack_exports__["a"] = (SvgIcon);

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOSE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSED_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SHOWED_MODAL; });
var CLOSE_MODAL = 'CLOSE_MODAL';
var CLOSED_MODAL = 'CLOSED_MODAL';

var SHOW_MODAL = 'SHOW_MODAL';
var SHOWED_MODAL = 'SHOWED_MODAL';

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uploadcare_widget__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uploadcare_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uploadcare_widget__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DEFAULT_OPTIONS = {
  previewStep: true,
  crop: 'free'
};

/**
 * Error class to handle file upload errors.
 * */

var FileUploadError = function (_Error) {
  _inherits(FileUploadError, _Error);

  function FileUploadError(message, fileInfo) {
    _classCallCheck(this, FileUploadError);

    var _this = _possibleConstructorReturn(this, (FileUploadError.__proto__ || Object.getPrototypeOf(FileUploadError)).call(this, message));

    _this.name = 'FileUploadError';
    _this.message = I18n.t('account.profile.notice.medium_upload_error');
    _this.fileInfo = fileInfo;
    return _this;
  }

  return FileUploadError;
}(Error);

var FileUploadManager = function () {
  function FileUploadManager() {
    _classCallCheck(this, FileUploadManager);
  }

  _createClass(FileUploadManager, null, [{
    key: 'pick',

    /**
     * Uploadcare-based file picker via JS API
     *
     * @param {Object} [options] - additional configuration params
     *  Optional Options:
     *    onFileUploadStart -> callback function when each upload is started
     *    onFileUploadSuccess -> callback function when upload finishes
     *    onFileUploadError -> callback function when upload results in error
     */
    value: function pick() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var widgetOptions = _extends({
        publicKey: UPLOADCARE_PUBLIC_KEY
      }, DEFAULT_OPTIONS, options);

      __WEBPACK_IMPORTED_MODULE_0_uploadcare_widget___default.a.openDialog(null, widgetOptions).done(function (result) {
        return FileUploadManager.onDialogHide(result, widgetOptions);
      });
    }
  }, {
    key: 'onDialogHide',
    value: function onDialogHide(result, options) {
      options.onFileUploadStart && options.onFileUploadStart();

      var hasMultipleUpload = typeof result.files === 'function';

      if (hasMultipleUpload) {
        FileUploadManager.multipleUploadHandler(result, options);
        return;
      }

      FileUploadManager.singleUploadHandler(result, options);
    }
  }, {
    key: 'multipleUploadHandler',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result, options) {
        var uploadPromise, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uploadPromise = [];


                result.files().forEach(function (file) {
                  var promise = new Promise(function (resolve, _) {
                    file.progress(function (uploadInfo) {
                      if (uploadInfo['state'] === 'ready' && options.onFileUploadSuccess) {
                        resolve(uploadInfo['incompleteFileInfo']);
                      }
                    });

                    file.fail(function (error, fileInfo) {
                      FileUploadManager.errorHandler(error, fileInfo, options);
                    });
                  });

                  uploadPromise.push(promise);
                });

                _context.next = 4;
                return Promise.all(uploadPromise);

              case 4:
                response = _context.sent;

                options.onFileUploadSuccess && options.onFileUploadSuccess(response);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function multipleUploadHandler(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return multipleUploadHandler;
    }()
  }, {
    key: 'singleUploadHandler',
    value: function singleUploadHandler(result, options) {
      result.progress(function (uploadInfo) {
        result.done(function (fileInfo) {
          options.onFileUploadSuccess(fileInfo);
        });
      });

      result.fail(function (error, fileInfo) {
        FileUploadManager.errorHandler(error, fileInfo, options);
      });
    }

    /**
     * Error handler for the uploads.
     *  1) Builds an `FileUploadError` object.
     *  2) If the error callback is available, passes the error to the callback gracefully.
     *  3) Else, raises the error.
     * */

  }, {
    key: 'errorHandler',
    value: function errorHandler(error, fileInfo, options) {
      var uploadError = new FileUploadError(error, fileInfo);

      if (options.onFileUploadError) {
        options.onFileUploadError(uploadError);
        return;
      }

      throw uploadError;
    }
  }]);

  return FileUploadManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (FileUploadManager);

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var defaultOptions = {
  responseType: 'json'
};

/**
 * The main API access function that comes preconfigured with useful defaults.
 *
 * @param {string} [method] - the HTTP method to use
 * @param {string} [endpoint] - the API endpoint to use
 * @param {object} [requestOptions] - params and date to be sent
 * @return {Promise} a Promise that will resolve into an object or reject with
 *                   an error object for its reason
 */
/* harmony default export */ __webpack_exports__["a"] = (function (method, endpoint) {
  var requestOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var requestParams = _extends({
    method: method,
    url: endpoint
  }, defaultOptions, requestOptions);

  return Object(__WEBPACK_IMPORTED_MODULE_0_axios__["request"])(requestParams).then(function (response) {
    return response.data;
  }).catch(function (error) {
    var response = error.response;

    console.error('[API][' + method + '][' + endpoint + ']', response.status, response.data);

    throw response.data;
  });
});

// Set up request and response interceptors
// Used in tests to query the request queue

window.VCL = {};
window.VCL.requestManager = { pending: 0 };

__WEBPACK_IMPORTED_MODULE_0_axios__["interceptors"].request.use(function (config) {
  window.VCL.requestManager.pending++;
  return config;
}, function (error) {
  return Promise.reject(error);
});

__WEBPACK_IMPORTED_MODULE_0_axios__["interceptors"].response.use(function (response) {
  window.VCL.requestManager.pending--;
  return response;
}, function (error) {
  return Promise.reject(error);
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SELECTOR; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Default class names for loader container
var SELECTOR = '[data-image-loader="true"]';

var ProgressiveImageLoader = function () {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to progressively load a background image.
   * */
  function ProgressiveImageLoader(elementRef) {
    _classCallCheck(this, ProgressiveImageLoader);

    // Initialise attributes
    this.elementRef = elementRef;
    this.elementRef.classList.add('progressive-image');
    this.image = new Image();

    // Bind functions
    this.onLoad = this.onLoad.bind(this);

    this._setup();
  }

  /**
   * Load the high res image.
   * */


  _createClass(ProgressiveImageLoader, [{
    key: 'load',
    value: function load() {
      this.image.src = this.elementRef.dataset['imagePath'];
    }

    // Event Handlers

    /**
     * Event callback to be triggered after the high res image has been loaded.
     * */

  }, {
    key: 'onLoad',
    value: function onLoad() {
      this.overlay.style.backgroundImage = 'url(' + this.image.src + ')';
      this.overlay.style.opacity = 1;
    }

    // private

    /**
     * Set-up the ProgressiveImageLoader.
     *  1) Append the overlay element to load the high res image.
     * */

  }, {
    key: '_setup',
    value: function _setup() {
      this.overlay = this._createOverlay();
      this._addEventListeners();
    }

    /**
     * Creates the overlay.
     *
     * @return {Element} - HTML node for the overlay.
     * */

  }, {
    key: '_createOverlay',
    value: function _createOverlay() {
      var overlay = document.createElement('div');
      overlay.setAttribute('class', 'progressive-image--overlay');
      this.elementRef.appendChild(overlay);

      return overlay;
    }

    /**
     * Adds all the required event listeners.
     * */

  }, {
    key: '_addEventListeners',
    value: function _addEventListeners() {
      this.image.onload = this.onLoad;
    }
  }]);

  return ProgressiveImageLoader;
}();

/* harmony default export */ __webpack_exports__["b"] = (ProgressiveImageLoader);

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAVIGATION_TAB_CHANGED; });
var NAVIGATION_TAB_CHANGED = 'NAVIGATION_TAB_CHANGED';

/***/ })

},[534]);


// WEBPACK FOOTER //
// booking-6e3b7c625a04be9df593.js